function Ke(i) {
  return i !== null && typeof i == "object" && "constructor" in i && i.constructor === Object;
}
function Ye(i, e) {
  i === void 0 && (i = {}), e === void 0 && (e = {}), Object.keys(e).forEach((t) => {
    typeof i[t] > "u" ? i[t] = e[t] : Ke(e[t]) && Ke(i[t]) && Object.keys(e[t]).length > 0 && Ye(i[t], e[t]);
  });
}
const at = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function W() {
  const i = typeof document < "u" ? document : {};
  return Ye(i, at), i;
}
const mt = {
  document: at,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(i) {
    return typeof setTimeout > "u" ? (i(), null) : setTimeout(i, 0);
  },
  cancelAnimationFrame(i) {
    typeof setTimeout > "u" || clearTimeout(i);
  }
};
function F() {
  const i = typeof window < "u" ? window : {};
  return Ye(i, mt), i;
}
function ee(i) {
  return i === void 0 && (i = ""), i.trim().split(" ").filter((e) => !!e.trim());
}
function ht(i) {
  const e = i;
  Object.keys(e).forEach((t) => {
    try {
      e[t] = null;
    } catch {
    }
    try {
      delete e[t];
    } catch {
    }
  });
}
function re(i, e) {
  return e === void 0 && (e = 0), setTimeout(i, e);
}
function Z() {
  return Date.now();
}
function gt(i) {
  const e = F();
  let t;
  return e.getComputedStyle && (t = e.getComputedStyle(i, null)), !t && i.currentStyle && (t = i.currentStyle), t || (t = i.style), t;
}
function Be(i, e) {
  e === void 0 && (e = "x");
  const t = F();
  let s, r, a;
  const p = gt(i);
  return t.WebKitCSSMatrix ? (r = p.transform || p.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((c) => c.replace(",", ".")).join(", ")), a = new t.WebKitCSSMatrix(r === "none" ? "" : r)) : (a = p.MozTransform || p.OTransform || p.MsTransform || p.msTransform || p.transform || p.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), s = a.toString().split(",")), e === "x" && (t.WebKitCSSMatrix ? r = a.m41 : s.length === 16 ? r = parseFloat(s[12]) : r = parseFloat(s[4])), e === "y" && (t.WebKitCSSMatrix ? r = a.m42 : s.length === 16 ? r = parseFloat(s[13]) : r = parseFloat(s[5])), r || 0;
}
function fe(i) {
  return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object";
}
function wt(i) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? i instanceof HTMLElement : i && (i.nodeType === 1 || i.nodeType === 11);
}
function U() {
  const i = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let t = 1; t < arguments.length; t += 1) {
    const s = t < 0 || arguments.length <= t ? void 0 : arguments[t];
    if (s != null && !wt(s)) {
      const r = Object.keys(Object(s)).filter((a) => e.indexOf(a) < 0);
      for (let a = 0, p = r.length; a < p; a += 1) {
        const c = r[a], n = Object.getOwnPropertyDescriptor(s, c);
        n !== void 0 && n.enumerable && (fe(i[c]) && fe(s[c]) ? s[c].__swiper__ ? i[c] = s[c] : U(i[c], s[c]) : !fe(i[c]) && fe(s[c]) ? (i[c] = {}, s[c].__swiper__ ? i[c] = s[c] : U(i[c], s[c])) : i[c] = s[c]);
      }
    }
  }
  return i;
}
function ue(i, e, t) {
  i.style.setProperty(e, t);
}
function nt(i) {
  let {
    swiper: e,
    targetPosition: t,
    side: s
  } = i;
  const r = F(), a = -e.translate;
  let p = null, c;
  const n = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(e.cssModeFrameID);
  const f = t > a ? "next" : "prev", l = (d, m) => f === "next" && d >= m || f === "prev" && d <= m, o = () => {
    c = (/* @__PURE__ */ new Date()).getTime(), p === null && (p = c);
    const d = Math.max(Math.min((c - p) / n, 1), 0), m = 0.5 - Math.cos(d * Math.PI) / 2;
    let h = a + m * (t - a);
    if (l(h, t) && (h = t), e.wrapperEl.scrollTo({
      [s]: h
    }), l(h, t)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [s]: h
        });
      }), r.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = r.requestAnimationFrame(o);
  };
  o();
}
function ae(i) {
  return i.querySelector(".swiper-slide-transform") || i.shadowRoot && i.shadowRoot.querySelector(".swiper-slide-transform") || i;
}
function N(i, e) {
  e === void 0 && (e = "");
  const t = [...i.children];
  return i instanceof HTMLSlotElement && t.push(...i.assignedElements()), e ? t.filter((s) => s.matches(e)) : t;
}
function vt(i, e) {
  const t = e.contains(i);
  return !t && e instanceof HTMLSlotElement ? [...e.assignedElements()].includes(i) : t;
}
function xe(i) {
  try {
    console.warn(i);
    return;
  } catch {
  }
}
function K(i, e) {
  e === void 0 && (e = []);
  const t = document.createElement(i);
  return t.classList.add(...Array.isArray(e) ? e : ee(e)), t;
}
function Ee(i) {
  const e = F(), t = W(), s = i.getBoundingClientRect(), r = t.body, a = i.clientTop || r.clientTop || 0, p = i.clientLeft || r.clientLeft || 0, c = i === e ? e.scrollY : i.scrollTop, n = i === e ? e.scrollX : i.scrollLeft;
  return {
    top: s.top + c - a,
    left: s.left + n - p
  };
}
function bt(i, e) {
  const t = [];
  for (; i.previousElementSibling; ) {
    const s = i.previousElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), i = s;
  }
  return t;
}
function yt(i, e) {
  const t = [];
  for (; i.nextElementSibling; ) {
    const s = i.nextElementSibling;
    e ? s.matches(e) && t.push(s) : t.push(s), i = s;
  }
  return t;
}
function te(i, e) {
  return F().getComputedStyle(i, null).getPropertyValue(e);
}
function he(i) {
  let e = i, t;
  if (e) {
    for (t = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (t += 1);
    return t;
  }
}
function se(i, e) {
  const t = [];
  let s = i.parentElement;
  for (; s; )
    e ? s.matches(e) && t.push(s) : t.push(s), s = s.parentElement;
  return t;
}
function me(i, e) {
  function t(s) {
    s.target === i && (e.call(i, s), i.removeEventListener("transitionend", t));
  }
  e && i.addEventListener("transitionend", t);
}
function _e(i, e, t) {
  const s = F();
  return i[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(s.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(s.getComputedStyle(i, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function X(i) {
  return (Array.isArray(i) ? i : [i]).filter((e) => !!e);
}
function Te(i) {
  return (e) => Math.abs(e) > 0 && i.browser && i.browser.need3dFix && Math.abs(e) % 90 === 0 ? e + 1e-3 : e;
}
let Ae;
function St() {
  const i = F(), e = W();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in i || i.DocumentTouch && e instanceof i.DocumentTouch)
  };
}
function lt() {
  return Ae || (Ae = St()), Ae;
}
let $e;
function xt(i) {
  let {
    userAgent: e
  } = i === void 0 ? {} : i;
  const t = lt(), s = F(), r = s.navigator.platform, a = e || s.navigator.userAgent, p = {
    ios: !1,
    android: !1
  }, c = s.screen.width, n = s.screen.height, f = a.match(/(Android);?[\s\/]+([\d.]+)?/);
  let l = a.match(/(iPad).*OS\s([\d_]+)/);
  const o = a.match(/(iPod)(.*OS\s([\d_]+))?/), d = !l && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), m = r === "Win32";
  let h = r === "MacIntel";
  const g = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !l && h && t.touch && g.indexOf(`${c}x${n}`) >= 0 && (l = a.match(/(Version)\/([\d.]+)/), l || (l = [0, 1, "13_0_0"]), h = !1), f && !m && (p.os = "android", p.android = !0), (l || d || o) && (p.os = "ios", p.ios = !0), p;
}
function ot(i) {
  return i === void 0 && (i = {}), $e || ($e = xt(i)), $e;
}
let Oe;
function Et() {
  const i = F(), e = ot();
  let t = !1;
  function s() {
    const c = i.navigator.userAgent.toLowerCase();
    return c.indexOf("safari") >= 0 && c.indexOf("chrome") < 0 && c.indexOf("android") < 0;
  }
  if (s()) {
    const c = String(i.navigator.userAgent);
    if (c.includes("Version/")) {
      const [n, f] = c.split("Version/")[1].split(" ")[0].split(".").map((l) => Number(l));
      t = n < 16 || n === 16 && f < 2;
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(i.navigator.userAgent), a = s(), p = a || r && e.ios;
  return {
    isSafari: t || a,
    needPerspectiveFix: t,
    need3dFix: p,
    isWebView: r
  };
}
function Tt() {
  return Oe || (Oe = Et()), Oe;
}
function Mt(i) {
  let {
    swiper: e,
    on: t,
    emit: s
  } = i;
  const r = F();
  let a = null, p = null;
  const c = () => {
    !e || e.destroyed || !e.initialized || (s("beforeResize"), s("resize"));
  }, n = () => {
    !e || e.destroyed || !e.initialized || (a = new ResizeObserver((o) => {
      p = r.requestAnimationFrame(() => {
        const {
          width: d,
          height: m
        } = e;
        let h = d, g = m;
        o.forEach((v) => {
          let {
            contentBoxSize: b,
            contentRect: w,
            target: u
          } = v;
          u && u !== e.el || (h = w ? w.width : (b[0] || b).inlineSize, g = w ? w.height : (b[0] || b).blockSize);
        }), (h !== d || g !== m) && c();
      });
    }), a.observe(e.el));
  }, f = () => {
    p && r.cancelAnimationFrame(p), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
  }, l = () => {
    !e || e.destroyed || !e.initialized || s("orientationchange");
  };
  t("init", () => {
    if (e.params.resizeObserver && typeof r.ResizeObserver < "u") {
      n();
      return;
    }
    r.addEventListener("resize", c), r.addEventListener("orientationchange", l);
  }), t("destroy", () => {
    f(), r.removeEventListener("resize", c), r.removeEventListener("orientationchange", l);
  });
}
function Ct(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = [], p = F(), c = function(l, o) {
    o === void 0 && (o = {});
    const d = p.MutationObserver || p.WebkitMutationObserver, m = new d((h) => {
      if (e.__preventObserver__) return;
      if (h.length === 1) {
        r("observerUpdate", h[0]);
        return;
      }
      const g = function() {
        r("observerUpdate", h[0]);
      };
      p.requestAnimationFrame ? p.requestAnimationFrame(g) : p.setTimeout(g, 0);
    });
    m.observe(l, {
      attributes: typeof o.attributes > "u" ? !0 : o.attributes,
      childList: e.isElement || (typeof o.childList > "u" ? !0 : o).childList,
      characterData: typeof o.characterData > "u" ? !0 : o.characterData
    }), a.push(m);
  }, n = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const l = se(e.hostEl);
        for (let o = 0; o < l.length; o += 1)
          c(l[o]);
      }
      c(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), c(e.wrapperEl, {
        attributes: !1
      });
    }
  }, f = () => {
    a.forEach((l) => {
      l.disconnect();
    }), a.splice(0, a.length);
  };
  t({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), s("init", n), s("destroy", f);
}
var Pt = {
  on(i, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    const r = t ? "unshift" : "push";
    return i.split(" ").forEach((a) => {
      s.eventsListeners[a] || (s.eventsListeners[a] = []), s.eventsListeners[a][r](e);
    }), s;
  },
  once(i, e, t) {
    const s = this;
    if (!s.eventsListeners || s.destroyed || typeof e != "function") return s;
    function r() {
      s.off(i, r), r.__emitterProxy && delete r.__emitterProxy;
      for (var a = arguments.length, p = new Array(a), c = 0; c < a; c++)
        p[c] = arguments[c];
      e.apply(s, p);
    }
    return r.__emitterProxy = e, s.on(i, r, t);
  },
  onAny(i, e) {
    const t = this;
    if (!t.eventsListeners || t.destroyed || typeof i != "function") return t;
    const s = e ? "unshift" : "push";
    return t.eventsAnyListeners.indexOf(i) < 0 && t.eventsAnyListeners[s](i), t;
  },
  offAny(i) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const t = e.eventsAnyListeners.indexOf(i);
    return t >= 0 && e.eventsAnyListeners.splice(t, 1), e;
  },
  off(i, e) {
    const t = this;
    return !t.eventsListeners || t.destroyed || !t.eventsListeners || i.split(" ").forEach((s) => {
      typeof e > "u" ? t.eventsListeners[s] = [] : t.eventsListeners[s] && t.eventsListeners[s].forEach((r, a) => {
        (r === e || r.__emitterProxy && r.__emitterProxy === e) && t.eventsListeners[s].splice(a, 1);
      });
    }), t;
  },
  emit() {
    const i = this;
    if (!i.eventsListeners || i.destroyed || !i.eventsListeners) return i;
    let e, t, s;
    for (var r = arguments.length, a = new Array(r), p = 0; p < r; p++)
      a[p] = arguments[p];
    return typeof a[0] == "string" || Array.isArray(a[0]) ? (e = a[0], t = a.slice(1, a.length), s = i) : (e = a[0].events, t = a[0].data, s = a[0].context || i), t.unshift(s), (Array.isArray(e) ? e : e.split(" ")).forEach((n) => {
      i.eventsAnyListeners && i.eventsAnyListeners.length && i.eventsAnyListeners.forEach((f) => {
        f.apply(s, [n, ...t]);
      }), i.eventsListeners && i.eventsListeners[n] && i.eventsListeners[n].forEach((f) => {
        f.apply(s, t);
      });
    }), i;
  }
};
function Lt() {
  const i = this;
  let e, t;
  const s = i.el;
  typeof i.params.width < "u" && i.params.width !== null ? e = i.params.width : e = s.clientWidth, typeof i.params.height < "u" && i.params.height !== null ? t = i.params.height : t = s.clientHeight, !(e === 0 && i.isHorizontal() || t === 0 && i.isVertical()) && (e = e - parseInt(te(s, "padding-left") || 0, 10) - parseInt(te(s, "padding-right") || 0, 10), t = t - parseInt(te(s, "padding-top") || 0, 10) - parseInt(te(s, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(t) && (t = 0), Object.assign(i, {
    width: e,
    height: t,
    size: i.isHorizontal() ? e : t
  }));
}
function zt() {
  const i = this;
  function e(M, z) {
    return parseFloat(M.getPropertyValue(i.getDirectionLabel(z)) || 0);
  }
  const t = i.params, {
    wrapperEl: s,
    slidesEl: r,
    size: a,
    rtlTranslate: p,
    wrongRTL: c
  } = i, n = i.virtual && t.virtual.enabled, f = n ? i.virtual.slides.length : i.slides.length, l = N(r, `.${i.params.slideClass}, swiper-slide`), o = n ? i.virtual.slides.length : l.length;
  let d = [];
  const m = [], h = [];
  let g = t.slidesOffsetBefore;
  typeof g == "function" && (g = t.slidesOffsetBefore.call(i));
  let v = t.slidesOffsetAfter;
  typeof v == "function" && (v = t.slidesOffsetAfter.call(i));
  const b = i.snapGrid.length, w = i.slidesGrid.length;
  let u = t.spaceBetween, y = -g, x = 0, A = 0;
  if (typeof a > "u")
    return;
  typeof u == "string" && u.indexOf("%") >= 0 ? u = parseFloat(u.replace("%", "")) / 100 * a : typeof u == "string" && (u = parseFloat(u)), i.virtualSize = -u, l.forEach((M) => {
    p ? M.style.marginLeft = "" : M.style.marginRight = "", M.style.marginBottom = "", M.style.marginTop = "";
  }), t.centeredSlides && t.cssMode && (ue(s, "--swiper-centered-offset-before", ""), ue(s, "--swiper-centered-offset-after", ""));
  const O = t.grid && t.grid.rows > 1 && i.grid;
  O ? i.grid.initSlides(l) : i.grid && i.grid.unsetSlides();
  let I;
  const S = t.slidesPerView === "auto" && t.breakpoints && Object.keys(t.breakpoints).filter((M) => typeof t.breakpoints[M].slidesPerView < "u").length > 0;
  for (let M = 0; M < o; M += 1) {
    I = 0;
    let z;
    if (l[M] && (z = l[M]), O && i.grid.updateSlide(M, z, l), !(l[M] && te(z, "display") === "none")) {
      if (t.slidesPerView === "auto") {
        S && (l[M].style[i.getDirectionLabel("width")] = "");
        const P = getComputedStyle(z), E = z.style.transform, T = z.style.webkitTransform;
        if (E && (z.style.transform = "none"), T && (z.style.webkitTransform = "none"), t.roundLengths)
          I = i.isHorizontal() ? _e(z, "width") : _e(z, "height");
        else {
          const $ = e(P, "width"), H = e(P, "padding-left"), C = e(P, "padding-right"), L = e(P, "margin-left"), G = e(P, "margin-right"), R = P.getPropertyValue("box-sizing");
          if (R && R === "border-box")
            I = $ + L + G;
          else {
            const {
              clientWidth: D,
              offsetWidth: k
            } = z;
            I = $ + H + C + L + G + (k - D);
          }
        }
        E && (z.style.transform = E), T && (z.style.webkitTransform = T), t.roundLengths && (I = Math.floor(I));
      } else
        I = (a - (t.slidesPerView - 1) * u) / t.slidesPerView, t.roundLengths && (I = Math.floor(I)), l[M] && (l[M].style[i.getDirectionLabel("width")] = `${I}px`);
      l[M] && (l[M].swiperSlideSize = I), h.push(I), t.centeredSlides ? (y = y + I / 2 + x / 2 + u, x === 0 && M !== 0 && (y = y - a / 2 - u), M === 0 && (y = y - a / 2 - u), Math.abs(y) < 1 / 1e3 && (y = 0), t.roundLengths && (y = Math.floor(y)), A % t.slidesPerGroup === 0 && d.push(y), m.push(y)) : (t.roundLengths && (y = Math.floor(y)), (A - Math.min(i.params.slidesPerGroupSkip, A)) % i.params.slidesPerGroup === 0 && d.push(y), m.push(y), y = y + I + u), i.virtualSize += I + u, x = I, A += 1;
    }
  }
  if (i.virtualSize = Math.max(i.virtualSize, a) + v, p && c && (t.effect === "slide" || t.effect === "coverflow") && (s.style.width = `${i.virtualSize + u}px`), t.setWrapperSize && (s.style[i.getDirectionLabel("width")] = `${i.virtualSize + u}px`), O && i.grid.updateWrapperSize(I, d), !t.centeredSlides) {
    const M = [];
    for (let z = 0; z < d.length; z += 1) {
      let P = d[z];
      t.roundLengths && (P = Math.floor(P)), d[z] <= i.virtualSize - a && M.push(P);
    }
    d = M, Math.floor(i.virtualSize - a) - Math.floor(d[d.length - 1]) > 1 && d.push(i.virtualSize - a);
  }
  if (n && t.loop) {
    const M = h[0] + u;
    if (t.slidesPerGroup > 1) {
      const z = Math.ceil((i.virtual.slidesBefore + i.virtual.slidesAfter) / t.slidesPerGroup), P = M * t.slidesPerGroup;
      for (let E = 0; E < z; E += 1)
        d.push(d[d.length - 1] + P);
    }
    for (let z = 0; z < i.virtual.slidesBefore + i.virtual.slidesAfter; z += 1)
      t.slidesPerGroup === 1 && d.push(d[d.length - 1] + M), m.push(m[m.length - 1] + M), i.virtualSize += M;
  }
  if (d.length === 0 && (d = [0]), u !== 0) {
    const M = i.isHorizontal() && p ? "marginLeft" : i.getDirectionLabel("marginRight");
    l.filter((z, P) => !t.cssMode || t.loop ? !0 : P !== l.length - 1).forEach((z) => {
      z.style[M] = `${u}px`;
    });
  }
  if (t.centeredSlides && t.centeredSlidesBounds) {
    let M = 0;
    h.forEach((P) => {
      M += P + (u || 0);
    }), M -= u;
    const z = M > a ? M - a : 0;
    d = d.map((P) => P <= 0 ? -g : P > z ? z + v : P);
  }
  if (t.centerInsufficientSlides) {
    let M = 0;
    h.forEach((P) => {
      M += P + (u || 0);
    }), M -= u;
    const z = (t.slidesOffsetBefore || 0) + (t.slidesOffsetAfter || 0);
    if (M + z < a) {
      const P = (a - M - z) / 2;
      d.forEach((E, T) => {
        d[T] = E - P;
      }), m.forEach((E, T) => {
        m[T] = E + P;
      });
    }
  }
  if (Object.assign(i, {
    slides: l,
    snapGrid: d,
    slidesGrid: m,
    slidesSizesGrid: h
  }), t.centeredSlides && t.cssMode && !t.centeredSlidesBounds) {
    ue(s, "--swiper-centered-offset-before", `${-d[0]}px`), ue(s, "--swiper-centered-offset-after", `${i.size / 2 - h[h.length - 1] / 2}px`);
    const M = -i.snapGrid[0], z = -i.slidesGrid[0];
    i.snapGrid = i.snapGrid.map((P) => P + M), i.slidesGrid = i.slidesGrid.map((P) => P + z);
  }
  if (o !== f && i.emit("slidesLengthChange"), d.length !== b && (i.params.watchOverflow && i.checkOverflow(), i.emit("snapGridLengthChange")), m.length !== w && i.emit("slidesGridLengthChange"), t.watchSlidesProgress && i.updateSlidesOffset(), i.emit("slidesUpdated"), !n && !t.cssMode && (t.effect === "slide" || t.effect === "fade")) {
    const M = `${t.containerModifierClass}backface-hidden`, z = i.el.classList.contains(M);
    o <= t.maxBackfaceHiddenSlides ? z || i.el.classList.add(M) : z && i.el.classList.remove(M);
  }
}
function It(i) {
  const e = this, t = [], s = e.virtual && e.params.virtual.enabled;
  let r = 0, a;
  typeof i == "number" ? e.setTransition(i) : i === !0 && e.setTransition(e.params.speed);
  const p = (c) => s ? e.slides[e.getSlideIndexByData(c)] : e.slides[c];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((c) => {
        t.push(c);
      });
    else
      for (a = 0; a < Math.ceil(e.params.slidesPerView); a += 1) {
        const c = e.activeIndex + a;
        if (c > e.slides.length && !s) break;
        t.push(p(c));
      }
  else
    t.push(p(e.activeIndex));
  for (a = 0; a < t.length; a += 1)
    if (typeof t[a] < "u") {
      const c = t[a].offsetHeight;
      r = c > r ? c : r;
    }
  (r || r === 0) && (e.wrapperEl.style.height = `${r}px`);
}
function At() {
  const i = this, e = i.slides, t = i.isElement ? i.isHorizontal() ? i.wrapperEl.offsetLeft : i.wrapperEl.offsetTop : 0;
  for (let s = 0; s < e.length; s += 1)
    e[s].swiperSlideOffset = (i.isHorizontal() ? e[s].offsetLeft : e[s].offsetTop) - t - i.cssOverflowAdjustment();
}
const Ze = (i, e, t) => {
  e && !i.classList.contains(t) ? i.classList.add(t) : !e && i.classList.contains(t) && i.classList.remove(t);
};
function $t(i) {
  i === void 0 && (i = this && this.translate || 0);
  const e = this, t = e.params, {
    slides: s,
    rtlTranslate: r,
    snapGrid: a
  } = e;
  if (s.length === 0) return;
  typeof s[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let p = -i;
  r && (p = i), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let c = t.spaceBetween;
  typeof c == "string" && c.indexOf("%") >= 0 ? c = parseFloat(c.replace("%", "")) / 100 * e.size : typeof c == "string" && (c = parseFloat(c));
  for (let n = 0; n < s.length; n += 1) {
    const f = s[n];
    let l = f.swiperSlideOffset;
    t.cssMode && t.centeredSlides && (l -= s[0].swiperSlideOffset);
    const o = (p + (t.centeredSlides ? e.minTranslate() : 0) - l) / (f.swiperSlideSize + c), d = (p - a[0] + (t.centeredSlides ? e.minTranslate() : 0) - l) / (f.swiperSlideSize + c), m = -(p - l), h = m + e.slidesSizesGrid[n], g = m >= 0 && m <= e.size - e.slidesSizesGrid[n], v = m >= 0 && m < e.size - 1 || h > 1 && h <= e.size || m <= 0 && h >= e.size;
    v && (e.visibleSlides.push(f), e.visibleSlidesIndexes.push(n)), Ze(f, v, t.slideVisibleClass), Ze(f, g, t.slideFullyVisibleClass), f.progress = r ? -o : o, f.originalProgress = r ? -d : d;
  }
}
function Ot(i) {
  const e = this;
  if (typeof i > "u") {
    const l = e.rtlTranslate ? -1 : 1;
    i = e && e.translate && e.translate * l || 0;
  }
  const t = e.params, s = e.maxTranslate() - e.minTranslate();
  let {
    progress: r,
    isBeginning: a,
    isEnd: p,
    progressLoop: c
  } = e;
  const n = a, f = p;
  if (s === 0)
    r = 0, a = !0, p = !0;
  else {
    r = (i - e.minTranslate()) / s;
    const l = Math.abs(i - e.minTranslate()) < 1, o = Math.abs(i - e.maxTranslate()) < 1;
    a = l || r <= 0, p = o || r >= 1, l && (r = 0), o && (r = 1);
  }
  if (t.loop) {
    const l = e.getSlideIndexByData(0), o = e.getSlideIndexByData(e.slides.length - 1), d = e.slidesGrid[l], m = e.slidesGrid[o], h = e.slidesGrid[e.slidesGrid.length - 1], g = Math.abs(i);
    g >= d ? c = (g - d) / h : c = (g + h - m) / h, c > 1 && (c -= 1);
  }
  Object.assign(e, {
    progress: r,
    progressLoop: c,
    isBeginning: a,
    isEnd: p
  }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && e.updateSlidesProgress(i), a && !n && e.emit("reachBeginning toEdge"), p && !f && e.emit("reachEnd toEdge"), (n && !a || f && !p) && e.emit("fromEdge"), e.emit("progress", r);
}
const De = (i, e, t) => {
  e && !i.classList.contains(t) ? i.classList.add(t) : !e && i.classList.contains(t) && i.classList.remove(t);
};
function Dt() {
  const i = this, {
    slides: e,
    params: t,
    slidesEl: s,
    activeIndex: r
  } = i, a = i.virtual && t.virtual.enabled, p = i.grid && t.grid && t.grid.rows > 1, c = (o) => N(s, `.${t.slideClass}${o}, swiper-slide${o}`)[0];
  let n, f, l;
  if (a)
    if (t.loop) {
      let o = r - i.virtual.slidesBefore;
      o < 0 && (o = i.virtual.slides.length + o), o >= i.virtual.slides.length && (o -= i.virtual.slides.length), n = c(`[data-swiper-slide-index="${o}"]`);
    } else
      n = c(`[data-swiper-slide-index="${r}"]`);
  else
    p ? (n = e.filter((o) => o.column === r)[0], l = e.filter((o) => o.column === r + 1)[0], f = e.filter((o) => o.column === r - 1)[0]) : n = e[r];
  n && (p || (l = yt(n, `.${t.slideClass}, swiper-slide`)[0], t.loop && !l && (l = e[0]), f = bt(n, `.${t.slideClass}, swiper-slide`)[0], t.loop && !f === 0 && (f = e[e.length - 1]))), e.forEach((o) => {
    De(o, o === n, t.slideActiveClass), De(o, o === l, t.slideNextClass), De(o, o === f, t.slidePrevClass);
  }), i.emitSlidesClasses();
}
const ye = (i, e) => {
  if (!i || i.destroyed || !i.params) return;
  const t = () => i.isElement ? "swiper-slide" : `.${i.params.slideClass}`, s = e.closest(t());
  if (s) {
    let r = s.querySelector(`.${i.params.lazyPreloaderClass}`);
    !r && i.isElement && (s.shadowRoot ? r = s.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      s.shadowRoot && (r = s.shadowRoot.querySelector(`.${i.params.lazyPreloaderClass}`), r && r.remove());
    })), r && r.remove();
  }
}, ke = (i, e) => {
  if (!i.slides[e]) return;
  const t = i.slides[e].querySelector('[loading="lazy"]');
  t && t.removeAttribute("loading");
}, Re = (i) => {
  if (!i || i.destroyed || !i.params) return;
  let e = i.params.lazyPreloadPrevNext;
  const t = i.slides.length;
  if (!t || !e || e < 0) return;
  e = Math.min(e, t);
  const s = i.params.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(i.params.slidesPerView), r = i.activeIndex;
  if (i.params.grid && i.params.grid.rows > 1) {
    const p = r, c = [p - e];
    c.push(...Array.from({
      length: e
    }).map((n, f) => p + s + f)), i.slides.forEach((n, f) => {
      c.includes(n.column) && ke(i, f);
    });
    return;
  }
  const a = r + s - 1;
  if (i.params.rewind || i.params.loop)
    for (let p = r - e; p <= a + e; p += 1) {
      const c = (p % t + t) % t;
      (c < r || c > a) && ke(i, c);
    }
  else
    for (let p = Math.max(r - e, 0); p <= Math.min(a + e, t - 1); p += 1)
      p !== r && (p > a || p < r) && ke(i, p);
};
function kt(i) {
  const {
    slidesGrid: e,
    params: t
  } = i, s = i.rtlTranslate ? i.translate : -i.translate;
  let r;
  for (let a = 0; a < e.length; a += 1)
    typeof e[a + 1] < "u" ? s >= e[a] && s < e[a + 1] - (e[a + 1] - e[a]) / 2 ? r = a : s >= e[a] && s < e[a + 1] && (r = a + 1) : s >= e[a] && (r = a);
  return t.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r;
}
function Gt(i) {
  const e = this, t = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: s,
    params: r,
    activeIndex: a,
    realIndex: p,
    snapIndex: c
  } = e;
  let n = i, f;
  const l = (m) => {
    let h = m - e.virtual.slidesBefore;
    return h < 0 && (h = e.virtual.slides.length + h), h >= e.virtual.slides.length && (h -= e.virtual.slides.length), h;
  };
  if (typeof n > "u" && (n = kt(e)), s.indexOf(t) >= 0)
    f = s.indexOf(t);
  else {
    const m = Math.min(r.slidesPerGroupSkip, n);
    f = m + Math.floor((n - m) / r.slidesPerGroup);
  }
  if (f >= s.length && (f = s.length - 1), n === a && !e.params.loop) {
    f !== c && (e.snapIndex = f, e.emit("snapIndexChange"));
    return;
  }
  if (n === a && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = l(n);
    return;
  }
  const o = e.grid && r.grid && r.grid.rows > 1;
  let d;
  if (e.virtual && r.virtual.enabled && r.loop)
    d = l(n);
  else if (o) {
    const m = e.slides.filter((g) => g.column === n)[0];
    let h = parseInt(m.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(h) && (h = Math.max(e.slides.indexOf(m), 0)), d = Math.floor(h / r.grid.rows);
  } else if (e.slides[n]) {
    const m = e.slides[n].getAttribute("data-swiper-slide-index");
    m ? d = parseInt(m, 10) : d = n;
  } else
    d = n;
  Object.assign(e, {
    previousSnapIndex: c,
    snapIndex: f,
    previousRealIndex: p,
    realIndex: d,
    previousIndex: a,
    activeIndex: n
  }), e.initialized && Re(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (p !== d && e.emit("realIndexChange"), e.emit("slideChange"));
}
function Ht(i, e) {
  const t = this, s = t.params;
  let r = i.closest(`.${s.slideClass}, swiper-slide`);
  !r && t.isElement && e && e.length > 1 && e.includes(i) && [...e.slice(e.indexOf(i) + 1, e.length)].forEach((c) => {
    !r && c.matches && c.matches(`.${s.slideClass}, swiper-slide`) && (r = c);
  });
  let a = !1, p;
  if (r) {
    for (let c = 0; c < t.slides.length; c += 1)
      if (t.slides[c] === r) {
        a = !0, p = c;
        break;
      }
  }
  if (r && a)
    t.clickedSlide = r, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : t.clickedIndex = p;
  else {
    t.clickedSlide = void 0, t.clickedIndex = void 0;
    return;
  }
  s.slideToClickedSlide && t.clickedIndex !== void 0 && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
}
var Bt = {
  updateSize: Lt,
  updateSlides: zt,
  updateAutoHeight: It,
  updateSlidesOffset: At,
  updateSlidesProgress: $t,
  updateProgress: Ot,
  updateSlidesClasses: Dt,
  updateActiveIndex: Gt,
  updateClickedSlide: Ht
};
function _t(i) {
  i === void 0 && (i = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: t,
    rtlTranslate: s,
    translate: r,
    wrapperEl: a
  } = e;
  if (t.virtualTranslate)
    return s ? -r : r;
  if (t.cssMode)
    return r;
  let p = Be(a, i);
  return p += e.cssOverflowAdjustment(), s && (p = -p), p || 0;
}
function Rt(i, e) {
  const t = this, {
    rtlTranslate: s,
    params: r,
    wrapperEl: a,
    progress: p
  } = t;
  let c = 0, n = 0;
  const f = 0;
  t.isHorizontal() ? c = s ? -i : i : n = i, r.roundLengths && (c = Math.floor(c), n = Math.floor(n)), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? c : n, r.cssMode ? a[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -c : -n : r.virtualTranslate || (t.isHorizontal() ? c -= t.cssOverflowAdjustment() : n -= t.cssOverflowAdjustment(), a.style.transform = `translate3d(${c}px, ${n}px, ${f}px)`);
  let l;
  const o = t.maxTranslate() - t.minTranslate();
  o === 0 ? l = 0 : l = (i - t.minTranslate()) / o, l !== p && t.updateProgress(i), t.emit("setTranslate", t.translate, e);
}
function Xt() {
  return -this.snapGrid[0];
}
function Vt() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function Yt(i, e, t, s, r) {
  i === void 0 && (i = 0), e === void 0 && (e = this.params.speed), t === void 0 && (t = !0), s === void 0 && (s = !0);
  const a = this, {
    params: p,
    wrapperEl: c
  } = a;
  if (a.animating && p.preventInteractionOnTransition)
    return !1;
  const n = a.minTranslate(), f = a.maxTranslate();
  let l;
  if (s && i > n ? l = n : s && i < f ? l = f : l = i, a.updateProgress(l), p.cssMode) {
    const o = a.isHorizontal();
    if (e === 0)
      c[o ? "scrollLeft" : "scrollTop"] = -l;
    else {
      if (!a.support.smoothScroll)
        return nt({
          swiper: a,
          targetPosition: -l,
          side: o ? "left" : "top"
        }), !0;
      c.scrollTo({
        [o ? "left" : "top"]: -l,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (a.setTransition(0), a.setTranslate(l), t && (a.emit("beforeTransitionStart", e, r), a.emit("transitionEnd"))) : (a.setTransition(e), a.setTranslate(l), t && (a.emit("beforeTransitionStart", e, r), a.emit("transitionStart")), a.animating || (a.animating = !0, a.onTranslateToWrapperTransitionEnd || (a.onTranslateToWrapperTransitionEnd = function(d) {
    !a || a.destroyed || d.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onTranslateToWrapperTransitionEnd), a.onTranslateToWrapperTransitionEnd = null, delete a.onTranslateToWrapperTransitionEnd, a.animating = !1, t && a.emit("transitionEnd"));
  }), a.wrapperEl.addEventListener("transitionend", a.onTranslateToWrapperTransitionEnd))), !0;
}
var Ft = {
  getTranslate: _t,
  setTranslate: Rt,
  minTranslate: Xt,
  maxTranslate: Vt,
  translateTo: Yt
};
function Nt(i, e) {
  const t = this;
  t.params.cssMode || (t.wrapperEl.style.transitionDuration = `${i}ms`, t.wrapperEl.style.transitionDelay = i === 0 ? "0ms" : ""), t.emit("setTransition", i, e);
}
function dt(i) {
  let {
    swiper: e,
    runCallbacks: t,
    direction: s,
    step: r
  } = i;
  const {
    activeIndex: a,
    previousIndex: p
  } = e;
  let c = s;
  if (c || (a > p ? c = "next" : a < p ? c = "prev" : c = "reset"), e.emit(`transition${r}`), t && a !== p) {
    if (c === "reset") {
      e.emit(`slideResetTransition${r}`);
      return;
    }
    e.emit(`slideChangeTransition${r}`), c === "next" ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`);
  }
}
function Wt(i, e) {
  i === void 0 && (i = !0);
  const t = this, {
    params: s
  } = t;
  s.cssMode || (s.autoHeight && t.updateAutoHeight(), dt({
    swiper: t,
    runCallbacks: i,
    direction: e,
    step: "Start"
  }));
}
function qt(i, e) {
  i === void 0 && (i = !0);
  const t = this, {
    params: s
  } = t;
  t.animating = !1, !s.cssMode && (t.setTransition(0), dt({
    swiper: t,
    runCallbacks: i,
    direction: e,
    step: "End"
  }));
}
var jt = {
  setTransition: Nt,
  transitionStart: Wt,
  transitionEnd: qt
};
function Ut(i, e, t, s, r) {
  i === void 0 && (i = 0), t === void 0 && (t = !0), typeof i == "string" && (i = parseInt(i, 10));
  const a = this;
  let p = i;
  p < 0 && (p = 0);
  const {
    params: c,
    snapGrid: n,
    slidesGrid: f,
    previousIndex: l,
    activeIndex: o,
    rtlTranslate: d,
    wrapperEl: m,
    enabled: h
  } = a;
  if (!h && !s && !r || a.destroyed || a.animating && c.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = a.params.speed);
  const g = Math.min(a.params.slidesPerGroupSkip, p);
  let v = g + Math.floor((p - g) / a.params.slidesPerGroup);
  v >= n.length && (v = n.length - 1);
  const b = -n[v];
  if (c.normalizeSlideIndex)
    for (let x = 0; x < f.length; x += 1) {
      const A = -Math.floor(b * 100), O = Math.floor(f[x] * 100), I = Math.floor(f[x + 1] * 100);
      typeof f[x + 1] < "u" ? A >= O && A < I - (I - O) / 2 ? p = x : A >= O && A < I && (p = x + 1) : A >= O && (p = x);
    }
  if (a.initialized && p !== o && (!a.allowSlideNext && (d ? b > a.translate && b > a.minTranslate() : b < a.translate && b < a.minTranslate()) || !a.allowSlidePrev && b > a.translate && b > a.maxTranslate() && (o || 0) !== p))
    return !1;
  p !== (l || 0) && t && a.emit("beforeSlideChangeStart"), a.updateProgress(b);
  let w;
  p > o ? w = "next" : p < o ? w = "prev" : w = "reset";
  const u = a.virtual && a.params.virtual.enabled;
  if (!(u && r) && (d && -b === a.translate || !d && b === a.translate))
    return a.updateActiveIndex(p), c.autoHeight && a.updateAutoHeight(), a.updateSlidesClasses(), c.effect !== "slide" && a.setTranslate(b), w !== "reset" && (a.transitionStart(t, w), a.transitionEnd(t, w)), !1;
  if (c.cssMode) {
    const x = a.isHorizontal(), A = d ? b : -b;
    if (e === 0)
      u && (a.wrapperEl.style.scrollSnapType = "none", a._immediateVirtual = !0), u && !a._cssModeVirtualInitialSet && a.params.initialSlide > 0 ? (a._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        m[x ? "scrollLeft" : "scrollTop"] = A;
      })) : m[x ? "scrollLeft" : "scrollTop"] = A, u && requestAnimationFrame(() => {
        a.wrapperEl.style.scrollSnapType = "", a._immediateVirtual = !1;
      });
    else {
      if (!a.support.smoothScroll)
        return nt({
          swiper: a,
          targetPosition: A,
          side: x ? "left" : "top"
        }), !0;
      m.scrollTo({
        [x ? "left" : "top"]: A,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return a.setTransition(e), a.setTranslate(b), a.updateActiveIndex(p), a.updateSlidesClasses(), a.emit("beforeTransitionStart", e, s), a.transitionStart(t, w), e === 0 ? a.transitionEnd(t, w) : a.animating || (a.animating = !0, a.onSlideToWrapperTransitionEnd || (a.onSlideToWrapperTransitionEnd = function(A) {
    !a || a.destroyed || A.target === this && (a.wrapperEl.removeEventListener("transitionend", a.onSlideToWrapperTransitionEnd), a.onSlideToWrapperTransitionEnd = null, delete a.onSlideToWrapperTransitionEnd, a.transitionEnd(t, w));
  }), a.wrapperEl.addEventListener("transitionend", a.onSlideToWrapperTransitionEnd)), !0;
}
function Kt(i, e, t, s) {
  i === void 0 && (i = 0), t === void 0 && (t = !0), typeof i == "string" && (i = parseInt(i, 10));
  const r = this;
  if (r.destroyed) return;
  typeof e > "u" && (e = r.params.speed);
  const a = r.grid && r.params.grid && r.params.grid.rows > 1;
  let p = i;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled)
      p = p + r.virtual.slidesBefore;
    else {
      let c;
      if (a) {
        const d = p * r.params.grid.rows;
        c = r.slides.filter((m) => m.getAttribute("data-swiper-slide-index") * 1 === d)[0].column;
      } else
        c = r.getSlideIndexByData(p);
      const n = a ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, {
        centeredSlides: f
      } = r.params;
      let l = r.params.slidesPerView;
      l === "auto" ? l = r.slidesPerViewDynamic() : (l = Math.ceil(parseFloat(r.params.slidesPerView, 10)), f && l % 2 === 0 && (l = l + 1));
      let o = n - c < l;
      if (f && (o = o || c < Math.ceil(l / 2)), s && f && r.params.slidesPerView !== "auto" && !a && (o = !1), o) {
        const d = f ? c < r.activeIndex ? "prev" : "next" : c - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: d,
          slideTo: !0,
          activeSlideIndex: d === "next" ? c + 1 : c - n + 1,
          slideRealIndex: d === "next" ? r.realIndex : void 0
        });
      }
      if (a) {
        const d = p * r.params.grid.rows;
        p = r.slides.filter((m) => m.getAttribute("data-swiper-slide-index") * 1 === d)[0].column;
      } else
        p = r.getSlideIndexByData(p);
    }
  return requestAnimationFrame(() => {
    r.slideTo(p, e, t, s);
  }), r;
}
function Zt(i, e, t) {
  e === void 0 && (e = !0);
  const s = this, {
    enabled: r,
    params: a,
    animating: p
  } = s;
  if (!r || s.destroyed) return s;
  typeof i > "u" && (i = s.params.speed);
  let c = a.slidesPerGroup;
  a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (c = Math.max(s.slidesPerViewDynamic("current", !0), 1));
  const n = s.activeIndex < a.slidesPerGroupSkip ? 1 : c, f = s.virtual && a.virtual.enabled;
  if (a.loop) {
    if (p && !f && a.loopPreventsSliding) return !1;
    if (s.loopFix({
      direction: "next"
    }), s._clientLeft = s.wrapperEl.clientLeft, s.activeIndex === s.slides.length - 1 && a.cssMode)
      return requestAnimationFrame(() => {
        s.slideTo(s.activeIndex + n, i, e, t);
      }), !0;
  }
  return a.rewind && s.isEnd ? s.slideTo(0, i, e, t) : s.slideTo(s.activeIndex + n, i, e, t);
}
function Qt(i, e, t) {
  e === void 0 && (e = !0);
  const s = this, {
    params: r,
    snapGrid: a,
    slidesGrid: p,
    rtlTranslate: c,
    enabled: n,
    animating: f
  } = s;
  if (!n || s.destroyed) return s;
  typeof i > "u" && (i = s.params.speed);
  const l = s.virtual && r.virtual.enabled;
  if (r.loop) {
    if (f && !l && r.loopPreventsSliding) return !1;
    s.loopFix({
      direction: "prev"
    }), s._clientLeft = s.wrapperEl.clientLeft;
  }
  const o = c ? s.translate : -s.translate;
  function d(b) {
    return b < 0 ? -Math.floor(Math.abs(b)) : Math.floor(b);
  }
  const m = d(o), h = a.map((b) => d(b));
  let g = a[h.indexOf(m) - 1];
  if (typeof g > "u" && r.cssMode) {
    let b;
    a.forEach((w, u) => {
      m >= w && (b = u);
    }), typeof b < "u" && (g = a[b > 0 ? b - 1 : b]);
  }
  let v = 0;
  if (typeof g < "u" && (v = p.indexOf(g), v < 0 && (v = s.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (v = v - s.slidesPerViewDynamic("previous", !0) + 1, v = Math.max(v, 0))), r.rewind && s.isBeginning) {
    const b = s.params.virtual && s.params.virtual.enabled && s.virtual ? s.virtual.slides.length - 1 : s.slides.length - 1;
    return s.slideTo(b, i, e, t);
  } else if (r.loop && s.activeIndex === 0 && r.cssMode)
    return requestAnimationFrame(() => {
      s.slideTo(v, i, e, t);
    }), !0;
  return s.slideTo(v, i, e, t);
}
function Jt(i, e, t) {
  e === void 0 && (e = !0);
  const s = this;
  if (!s.destroyed)
    return typeof i > "u" && (i = s.params.speed), s.slideTo(s.activeIndex, i, e, t);
}
function ei(i, e, t, s) {
  e === void 0 && (e = !0), s === void 0 && (s = 0.5);
  const r = this;
  if (r.destroyed) return;
  typeof i > "u" && (i = r.params.speed);
  let a = r.activeIndex;
  const p = Math.min(r.params.slidesPerGroupSkip, a), c = p + Math.floor((a - p) / r.params.slidesPerGroup), n = r.rtlTranslate ? r.translate : -r.translate;
  if (n >= r.snapGrid[c]) {
    const f = r.snapGrid[c], l = r.snapGrid[c + 1];
    n - f > (l - f) * s && (a += r.params.slidesPerGroup);
  } else {
    const f = r.snapGrid[c - 1], l = r.snapGrid[c];
    n - f <= (l - f) * s && (a -= r.params.slidesPerGroup);
  }
  return a = Math.max(a, 0), a = Math.min(a, r.slidesGrid.length - 1), r.slideTo(a, i, e, t);
}
function ti() {
  const i = this;
  if (i.destroyed) return;
  const {
    params: e,
    slidesEl: t
  } = i, s = e.slidesPerView === "auto" ? i.slidesPerViewDynamic() : e.slidesPerView;
  let r = i.clickedIndex, a;
  const p = i.isElement ? "swiper-slide" : `.${e.slideClass}`;
  if (e.loop) {
    if (i.animating) return;
    a = parseInt(i.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? r < i.loopedSlides - s / 2 || r > i.slides.length - i.loopedSlides + s / 2 ? (i.loopFix(), r = i.getSlideIndex(N(t, `${p}[data-swiper-slide-index="${a}"]`)[0]), re(() => {
      i.slideTo(r);
    })) : i.slideTo(r) : r > i.slides.length - s ? (i.loopFix(), r = i.getSlideIndex(N(t, `${p}[data-swiper-slide-index="${a}"]`)[0]), re(() => {
      i.slideTo(r);
    })) : i.slideTo(r);
  } else
    i.slideTo(r);
}
var ii = {
  slideTo: Ut,
  slideToLoop: Kt,
  slideNext: Zt,
  slidePrev: Qt,
  slideReset: Jt,
  slideToClosest: ei,
  slideToClickedSlide: ti
};
function si(i) {
  const e = this, {
    params: t,
    slidesEl: s
  } = e;
  if (!t.loop || e.virtual && e.params.virtual.enabled) return;
  const r = () => {
    N(s, `.${t.slideClass}, swiper-slide`).forEach((o, d) => {
      o.setAttribute("data-swiper-slide-index", d);
    });
  }, a = e.grid && t.grid && t.grid.rows > 1, p = t.slidesPerGroup * (a ? t.grid.rows : 1), c = e.slides.length % p !== 0, n = a && e.slides.length % t.grid.rows !== 0, f = (l) => {
    for (let o = 0; o < l; o += 1) {
      const d = e.isElement ? K("swiper-slide", [t.slideBlankClass]) : K("div", [t.slideClass, t.slideBlankClass]);
      e.slidesEl.append(d);
    }
  };
  if (c) {
    if (t.loopAddBlankSlides) {
      const l = p - e.slides.length % p;
      f(l), e.recalcSlides(), e.updateSlides();
    } else
      xe("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else if (n) {
    if (t.loopAddBlankSlides) {
      const l = t.grid.rows - e.slides.length % t.grid.rows;
      f(l), e.recalcSlides(), e.updateSlides();
    } else
      xe("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    r();
  } else
    r();
  e.loopFix({
    slideRealIndex: i,
    direction: t.centeredSlides ? void 0 : "next"
  });
}
function ri(i) {
  let {
    slideRealIndex: e,
    slideTo: t = !0,
    direction: s,
    setTranslate: r,
    activeSlideIndex: a,
    byController: p,
    byMousewheel: c
  } = i === void 0 ? {} : i;
  const n = this;
  if (!n.params.loop) return;
  n.emit("beforeLoopFix");
  const {
    slides: f,
    allowSlidePrev: l,
    allowSlideNext: o,
    slidesEl: d,
    params: m
  } = n, {
    centeredSlides: h
  } = m;
  if (n.allowSlidePrev = !0, n.allowSlideNext = !0, n.virtual && m.virtual.enabled) {
    t && (!m.centeredSlides && n.snapIndex === 0 ? n.slideTo(n.virtual.slides.length, 0, !1, !0) : m.centeredSlides && n.snapIndex < m.slidesPerView ? n.slideTo(n.virtual.slides.length + n.snapIndex, 0, !1, !0) : n.snapIndex === n.snapGrid.length - 1 && n.slideTo(n.virtual.slidesBefore, 0, !1, !0)), n.allowSlidePrev = l, n.allowSlideNext = o, n.emit("loopFix");
    return;
  }
  let g = m.slidesPerView;
  g === "auto" ? g = n.slidesPerViewDynamic() : (g = Math.ceil(parseFloat(m.slidesPerView, 10)), h && g % 2 === 0 && (g = g + 1));
  const v = m.slidesPerGroupAuto ? g : m.slidesPerGroup;
  let b = v;
  b % v !== 0 && (b += v - b % v), b += m.loopAdditionalSlides, n.loopedSlides = b;
  const w = n.grid && m.grid && m.grid.rows > 1;
  f.length < g + b ? xe("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : w && m.grid.fill === "row" && xe("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const u = [], y = [];
  let x = n.activeIndex;
  typeof a > "u" ? a = n.getSlideIndex(f.filter((E) => E.classList.contains(m.slideActiveClass))[0]) : x = a;
  const A = s === "next" || !s, O = s === "prev" || !s;
  let I = 0, S = 0;
  const M = w ? Math.ceil(f.length / m.grid.rows) : f.length, P = (w ? f[a].column : a) + (h && typeof r > "u" ? -g / 2 + 0.5 : 0);
  if (P < b) {
    I = Math.max(b - P, v);
    for (let E = 0; E < b - P; E += 1) {
      const T = E - Math.floor(E / M) * M;
      if (w) {
        const $ = M - T - 1;
        for (let H = f.length - 1; H >= 0; H -= 1)
          f[H].column === $ && u.push(H);
      } else
        u.push(M - T - 1);
    }
  } else if (P + g > M - b) {
    S = Math.max(P - (M - b * 2), v);
    for (let E = 0; E < S; E += 1) {
      const T = E - Math.floor(E / M) * M;
      w ? f.forEach(($, H) => {
        $.column === T && y.push(H);
      }) : y.push(T);
    }
  }
  if (n.__preventObserver__ = !0, requestAnimationFrame(() => {
    n.__preventObserver__ = !1;
  }), O && u.forEach((E) => {
    f[E].swiperLoopMoveDOM = !0, d.prepend(f[E]), f[E].swiperLoopMoveDOM = !1;
  }), A && y.forEach((E) => {
    f[E].swiperLoopMoveDOM = !0, d.append(f[E]), f[E].swiperLoopMoveDOM = !1;
  }), n.recalcSlides(), m.slidesPerView === "auto" ? n.updateSlides() : w && (u.length > 0 && O || y.length > 0 && A) && n.slides.forEach((E, T) => {
    n.grid.updateSlide(T, E, n.slides);
  }), m.watchSlidesProgress && n.updateSlidesOffset(), t) {
    if (u.length > 0 && O) {
      if (typeof e > "u") {
        const E = n.slidesGrid[x], $ = n.slidesGrid[x + I] - E;
        c ? n.setTranslate(n.translate - $) : (n.slideTo(x + Math.ceil(I), 0, !1, !0), r && (n.touchEventsData.startTranslate = n.touchEventsData.startTranslate - $, n.touchEventsData.currentTranslate = n.touchEventsData.currentTranslate - $));
      } else if (r) {
        const E = w ? u.length / m.grid.rows : u.length;
        n.slideTo(n.activeIndex + E, 0, !1, !0), n.touchEventsData.currentTranslate = n.translate;
      }
    } else if (y.length > 0 && A)
      if (typeof e > "u") {
        const E = n.slidesGrid[x], $ = n.slidesGrid[x - S] - E;
        c ? n.setTranslate(n.translate - $) : (n.slideTo(x - S, 0, !1, !0), r && (n.touchEventsData.startTranslate = n.touchEventsData.startTranslate - $, n.touchEventsData.currentTranslate = n.touchEventsData.currentTranslate - $));
      } else {
        const E = w ? y.length / m.grid.rows : y.length;
        n.slideTo(n.activeIndex - E, 0, !1, !0);
      }
  }
  if (n.allowSlidePrev = l, n.allowSlideNext = o, n.controller && n.controller.control && !p) {
    const E = {
      slideRealIndex: e,
      direction: s,
      setTranslate: r,
      activeSlideIndex: a,
      byController: !0
    };
    Array.isArray(n.controller.control) ? n.controller.control.forEach((T) => {
      !T.destroyed && T.params.loop && T.loopFix({
        ...E,
        slideTo: T.params.slidesPerView === m.slidesPerView ? t : !1
      });
    }) : n.controller.control instanceof n.constructor && n.controller.control.params.loop && n.controller.control.loopFix({
      ...E,
      slideTo: n.controller.control.params.slidesPerView === m.slidesPerView ? t : !1
    });
  }
  n.emit("loopFix");
}
function ai() {
  const i = this, {
    params: e,
    slidesEl: t
  } = i;
  if (!e.loop || i.virtual && i.params.virtual.enabled) return;
  i.recalcSlides();
  const s = [];
  i.slides.forEach((r) => {
    const a = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    s[a] = r;
  }), i.slides.forEach((r) => {
    r.removeAttribute("data-swiper-slide-index");
  }), s.forEach((r) => {
    t.append(r);
  }), i.recalcSlides(), i.slideTo(i.realIndex, 0);
}
var ni = {
  loopCreate: si,
  loopFix: ri,
  loopDestroy: ai
};
function li(i) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const t = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), t.style.cursor = "move", t.style.cursor = i ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function oi() {
  const i = this;
  i.params.watchOverflow && i.isLocked || i.params.cssMode || (i.isElement && (i.__preventObserver__ = !0), i[i.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", i.isElement && requestAnimationFrame(() => {
    i.__preventObserver__ = !1;
  }));
}
var di = {
  setGrabCursor: li,
  unsetGrabCursor: oi
};
function ci(i, e) {
  e === void 0 && (e = this);
  function t(s) {
    if (!s || s === W() || s === F()) return null;
    s.assignedSlot && (s = s.assignedSlot);
    const r = s.closest(i);
    return !r && !s.getRootNode ? null : r || t(s.getRootNode().host);
  }
  return t(e);
}
function Qe(i, e, t) {
  const s = F(), {
    params: r
  } = i, a = r.edgeSwipeDetection, p = r.edgeSwipeThreshold;
  return a && (t <= p || t >= s.innerWidth - p) ? a === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function pi(i) {
  const e = this, t = W();
  let s = i;
  s.originalEvent && (s = s.originalEvent);
  const r = e.touchEventsData;
  if (s.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== s.pointerId)
      return;
    r.pointerId = s.pointerId;
  } else s.type === "touchstart" && s.targetTouches.length === 1 && (r.touchId = s.targetTouches[0].identifier);
  if (s.type === "touchstart") {
    Qe(e, s, s.targetTouches[0].pageX);
    return;
  }
  const {
    params: a,
    touches: p,
    enabled: c
  } = e;
  if (!c || !a.simulateTouch && s.pointerType === "mouse" || e.animating && a.preventInteractionOnTransition)
    return;
  !e.animating && a.cssMode && a.loop && e.loopFix();
  let n = s.target;
  if (a.touchEventsTarget === "wrapper" && !vt(n, e.wrapperEl) || "which" in s && s.which === 3 || "button" in s && s.button > 0 || r.isTouched && r.isMoved) return;
  const f = !!a.noSwipingClass && a.noSwipingClass !== "", l = s.composedPath ? s.composedPath() : s.path;
  f && s.target && s.target.shadowRoot && l && (n = l[0]);
  const o = a.noSwipingSelector ? a.noSwipingSelector : `.${a.noSwipingClass}`, d = !!(s.target && s.target.shadowRoot);
  if (a.noSwiping && (d ? ci(o, n) : n.closest(o))) {
    e.allowClick = !0;
    return;
  }
  if (a.swipeHandler && !n.closest(a.swipeHandler))
    return;
  p.currentX = s.pageX, p.currentY = s.pageY;
  const m = p.currentX, h = p.currentY;
  if (!Qe(e, s, m))
    return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), p.startX = m, p.startY = h, r.touchStartTime = Z(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, a.threshold > 0 && (r.allowThresholdMove = !1);
  let g = !0;
  n.matches(r.focusableElements) && (g = !1, n.nodeName === "SELECT" && (r.isTouched = !1)), t.activeElement && t.activeElement.matches(r.focusableElements) && t.activeElement !== n && (s.pointerType === "mouse" || s.pointerType !== "mouse" && !n.matches(r.focusableElements)) && t.activeElement.blur();
  const v = g && e.allowTouchMove && a.touchStartPreventDefault;
  (a.touchStartForcePreventDefault || v) && !n.isContentEditable && s.preventDefault(), a.freeMode && a.freeMode.enabled && e.freeMode && e.animating && !a.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", s);
}
function fi(i) {
  const e = W(), t = this, s = t.touchEventsData, {
    params: r,
    touches: a,
    rtlTranslate: p,
    enabled: c
  } = t;
  if (!c || !r.simulateTouch && i.pointerType === "mouse") return;
  let n = i;
  if (n.originalEvent && (n = n.originalEvent), n.type === "pointermove" && (s.touchId !== null || n.pointerId !== s.pointerId))
    return;
  let f;
  if (n.type === "touchmove") {
    if (f = [...n.changedTouches].filter((x) => x.identifier === s.touchId)[0], !f || f.identifier !== s.touchId) return;
  } else
    f = n;
  if (!s.isTouched) {
    s.startMoving && s.isScrolling && t.emit("touchMoveOpposite", n);
    return;
  }
  const l = f.pageX, o = f.pageY;
  if (n.preventedByNestedSwiper) {
    a.startX = l, a.startY = o;
    return;
  }
  if (!t.allowTouchMove) {
    n.target.matches(s.focusableElements) || (t.allowClick = !1), s.isTouched && (Object.assign(a, {
      startX: l,
      startY: o,
      currentX: l,
      currentY: o
    }), s.touchStartTime = Z());
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop) {
    if (t.isVertical()) {
      if (o < a.startY && t.translate <= t.maxTranslate() || o > a.startY && t.translate >= t.minTranslate()) {
        s.isTouched = !1, s.isMoved = !1;
        return;
      }
    } else if (l < a.startX && t.translate <= t.maxTranslate() || l > a.startX && t.translate >= t.minTranslate())
      return;
  }
  if (e.activeElement && e.activeElement.matches(s.focusableElements) && e.activeElement !== n.target && n.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && n.target === e.activeElement && n.target.matches(s.focusableElements)) {
    s.isMoved = !0, t.allowClick = !1;
    return;
  }
  s.allowTouchCallbacks && t.emit("touchMove", n), a.previousX = a.currentX, a.previousY = a.currentY, a.currentX = l, a.currentY = o;
  const d = a.currentX - a.startX, m = a.currentY - a.startY;
  if (t.params.threshold && Math.sqrt(d ** 2 + m ** 2) < t.params.threshold) return;
  if (typeof s.isScrolling > "u") {
    let x;
    t.isHorizontal() && a.currentY === a.startY || t.isVertical() && a.currentX === a.startX ? s.isScrolling = !1 : d * d + m * m >= 25 && (x = Math.atan2(Math.abs(m), Math.abs(d)) * 180 / Math.PI, s.isScrolling = t.isHorizontal() ? x > r.touchAngle : 90 - x > r.touchAngle);
  }
  if (s.isScrolling && t.emit("touchMoveOpposite", n), typeof s.startMoving > "u" && (a.currentX !== a.startX || a.currentY !== a.startY) && (s.startMoving = !0), s.isScrolling || n.type === "touchmove" && s.preventTouchMoveFromPointerMove) {
    s.isTouched = !1;
    return;
  }
  if (!s.startMoving)
    return;
  t.allowClick = !1, !r.cssMode && n.cancelable && n.preventDefault(), r.touchMoveStopPropagation && !r.nested && n.stopPropagation();
  let h = t.isHorizontal() ? d : m, g = t.isHorizontal() ? a.currentX - a.previousX : a.currentY - a.previousY;
  r.oneWayMovement && (h = Math.abs(h) * (p ? 1 : -1), g = Math.abs(g) * (p ? 1 : -1)), a.diff = h, h *= r.touchRatio, p && (h = -h, g = -g);
  const v = t.touchesDirection;
  t.swipeDirection = h > 0 ? "prev" : "next", t.touchesDirection = g > 0 ? "prev" : "next";
  const b = t.params.loop && !r.cssMode, w = t.touchesDirection === "next" && t.allowSlideNext || t.touchesDirection === "prev" && t.allowSlidePrev;
  if (!s.isMoved) {
    if (b && w && t.loopFix({
      direction: t.swipeDirection
    }), s.startTranslate = t.getTranslate(), t.setTransition(0), t.animating) {
      const x = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      t.wrapperEl.dispatchEvent(x);
    }
    s.allowMomentumBounce = !1, r.grabCursor && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!0), t.emit("sliderFirstMove", n);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), s.isMoved && s.allowThresholdMove && v !== t.touchesDirection && b && w && Math.abs(h) >= 1) {
    Object.assign(a, {
      startX: l,
      startY: o,
      currentX: l,
      currentY: o,
      startTranslate: s.currentTranslate
    }), s.loopSwapReset = !0, s.startTranslate = s.currentTranslate;
    return;
  }
  t.emit("sliderMove", n), s.isMoved = !0, s.currentTranslate = h + s.startTranslate;
  let u = !0, y = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (y = 0), h > 0 ? (b && w && s.allowThresholdMove && s.currentTranslate > (r.centeredSlides ? t.minTranslate() - t.slidesSizesGrid[t.activeIndex + 1] - (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.activeIndex + 1] + t.params.spaceBetween : 0) - t.params.spaceBetween : t.minTranslate()) && t.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), s.currentTranslate > t.minTranslate() && (u = !1, r.resistance && (s.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + s.startTranslate + h) ** y))) : h < 0 && (b && w && s.allowThresholdMove && s.currentTranslate < (r.centeredSlides ? t.maxTranslate() + t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween + (r.slidesPerView !== "auto" && t.slides.length - r.slidesPerView >= 2 ? t.slidesSizesGrid[t.slidesSizesGrid.length - 1] + t.params.spaceBetween : 0) : t.maxTranslate()) && t.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: t.slides.length - (r.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
  }), s.currentTranslate < t.maxTranslate() && (u = !1, r.resistance && (s.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - s.startTranslate - h) ** y))), u && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && t.swipeDirection === "next" && s.currentTranslate < s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && t.swipeDirection === "prev" && s.currentTranslate > s.startTranslate && (s.currentTranslate = s.startTranslate), !t.allowSlidePrev && !t.allowSlideNext && (s.currentTranslate = s.startTranslate), r.threshold > 0)
    if (Math.abs(h) > r.threshold || s.allowThresholdMove) {
      if (!s.allowThresholdMove) {
        s.allowThresholdMove = !0, a.startX = a.currentX, a.startY = a.currentY, s.currentTranslate = s.startTranslate, a.diff = t.isHorizontal() ? a.currentX - a.startX : a.currentY - a.startY;
        return;
      }
    } else {
      s.currentTranslate = s.startTranslate;
      return;
    }
  !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && t.freeMode || r.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(s.currentTranslate), t.setTranslate(s.currentTranslate));
}
function ui(i) {
  const e = this, t = e.touchEventsData;
  let s = i;
  s.originalEvent && (s = s.originalEvent);
  let r;
  if (s.type === "touchend" || s.type === "touchcancel") {
    if (r = [...s.changedTouches].filter((x) => x.identifier === t.touchId)[0], !r || r.identifier !== t.touchId) return;
  } else {
    if (t.touchId !== null || s.pointerId !== t.pointerId) return;
    r = s;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(s.type) && !(["pointercancel", "contextmenu"].includes(s.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  t.pointerId = null, t.touchId = null;
  const {
    params: p,
    touches: c,
    rtlTranslate: n,
    slidesGrid: f,
    enabled: l
  } = e;
  if (!l || !p.simulateTouch && s.pointerType === "mouse") return;
  if (t.allowTouchCallbacks && e.emit("touchEnd", s), t.allowTouchCallbacks = !1, !t.isTouched) {
    t.isMoved && p.grabCursor && e.setGrabCursor(!1), t.isMoved = !1, t.startMoving = !1;
    return;
  }
  p.grabCursor && t.isMoved && t.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const o = Z(), d = o - t.touchStartTime;
  if (e.allowClick) {
    const x = s.path || s.composedPath && s.composedPath();
    e.updateClickedSlide(x && x[0] || s.target, x), e.emit("tap click", s), d < 300 && o - t.lastClickTime < 300 && e.emit("doubleTap doubleClick", s);
  }
  if (t.lastClickTime = Z(), re(() => {
    e.destroyed || (e.allowClick = !0);
  }), !t.isTouched || !t.isMoved || !e.swipeDirection || c.diff === 0 && !t.loopSwapReset || t.currentTranslate === t.startTranslate && !t.loopSwapReset) {
    t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
    return;
  }
  t.isTouched = !1, t.isMoved = !1, t.startMoving = !1;
  let m;
  if (p.followFinger ? m = n ? e.translate : -e.translate : m = -t.currentTranslate, p.cssMode)
    return;
  if (p.freeMode && p.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: m
    });
    return;
  }
  const h = m >= -e.maxTranslate() && !e.params.loop;
  let g = 0, v = e.slidesSizesGrid[0];
  for (let x = 0; x < f.length; x += x < p.slidesPerGroupSkip ? 1 : p.slidesPerGroup) {
    const A = x < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
    typeof f[x + A] < "u" ? (h || m >= f[x] && m < f[x + A]) && (g = x, v = f[x + A] - f[x]) : (h || m >= f[x]) && (g = x, v = f[f.length - 1] - f[f.length - 2]);
  }
  let b = null, w = null;
  p.rewind && (e.isBeginning ? w = p.virtual && p.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (b = 0));
  const u = (m - f[g]) / v, y = g < p.slidesPerGroupSkip - 1 ? 1 : p.slidesPerGroup;
  if (d > p.longSwipesMs) {
    if (!p.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (u >= p.longSwipesRatio ? e.slideTo(p.rewind && e.isEnd ? b : g + y) : e.slideTo(g)), e.swipeDirection === "prev" && (u > 1 - p.longSwipesRatio ? e.slideTo(g + y) : w !== null && u < 0 && Math.abs(u) > p.longSwipesRatio ? e.slideTo(w) : e.slideTo(g));
  } else {
    if (!p.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (s.target === e.navigation.nextEl || s.target === e.navigation.prevEl) ? s.target === e.navigation.nextEl ? e.slideTo(g + y) : e.slideTo(g) : (e.swipeDirection === "next" && e.slideTo(b !== null ? b : g + y), e.swipeDirection === "prev" && e.slideTo(w !== null ? w : g));
  }
}
function Je() {
  const i = this, {
    params: e,
    el: t
  } = i;
  if (t && t.offsetWidth === 0) return;
  e.breakpoints && i.setBreakpoint();
  const {
    allowSlideNext: s,
    allowSlidePrev: r,
    snapGrid: a
  } = i, p = i.virtual && i.params.virtual.enabled;
  i.allowSlideNext = !0, i.allowSlidePrev = !0, i.updateSize(), i.updateSlides(), i.updateSlidesClasses();
  const c = p && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && i.isEnd && !i.isBeginning && !i.params.centeredSlides && !c ? i.slideTo(i.slides.length - 1, 0, !1, !0) : i.params.loop && !p ? i.slideToLoop(i.realIndex, 0, !1, !0) : i.slideTo(i.activeIndex, 0, !1, !0), i.autoplay && i.autoplay.running && i.autoplay.paused && (clearTimeout(i.autoplay.resizeTimeout), i.autoplay.resizeTimeout = setTimeout(() => {
    i.autoplay && i.autoplay.running && i.autoplay.paused && i.autoplay.resume();
  }, 500)), i.allowSlidePrev = r, i.allowSlideNext = s, i.params.watchOverflow && a !== i.snapGrid && i.checkOverflow();
}
function mi(i) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && i.preventDefault(), e.params.preventClicksPropagation && e.animating && (i.stopPropagation(), i.stopImmediatePropagation())));
}
function hi() {
  const i = this, {
    wrapperEl: e,
    rtlTranslate: t,
    enabled: s
  } = i;
  if (!s) return;
  i.previousTranslate = i.translate, i.isHorizontal() ? i.translate = -e.scrollLeft : i.translate = -e.scrollTop, i.translate === 0 && (i.translate = 0), i.updateActiveIndex(), i.updateSlidesClasses();
  let r;
  const a = i.maxTranslate() - i.minTranslate();
  a === 0 ? r = 0 : r = (i.translate - i.minTranslate()) / a, r !== i.progress && i.updateProgress(t ? -i.translate : i.translate), i.emit("setTranslate", i.translate, !1);
}
function gi(i) {
  const e = this;
  ye(e, i.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function wi() {
  const i = this;
  i.documentTouchHandlerProceeded || (i.documentTouchHandlerProceeded = !0, i.params.touchReleaseOnEdges && (i.el.style.touchAction = "auto"));
}
const ct = (i, e) => {
  const t = W(), {
    params: s,
    el: r,
    wrapperEl: a,
    device: p
  } = i, c = !!s.nested, n = e === "on" ? "addEventListener" : "removeEventListener", f = e;
  !r || typeof r == "string" || (t[n]("touchstart", i.onDocumentTouchStart, {
    passive: !1,
    capture: c
  }), r[n]("touchstart", i.onTouchStart, {
    passive: !1
  }), r[n]("pointerdown", i.onTouchStart, {
    passive: !1
  }), t[n]("touchmove", i.onTouchMove, {
    passive: !1,
    capture: c
  }), t[n]("pointermove", i.onTouchMove, {
    passive: !1,
    capture: c
  }), t[n]("touchend", i.onTouchEnd, {
    passive: !0
  }), t[n]("pointerup", i.onTouchEnd, {
    passive: !0
  }), t[n]("pointercancel", i.onTouchEnd, {
    passive: !0
  }), t[n]("touchcancel", i.onTouchEnd, {
    passive: !0
  }), t[n]("pointerout", i.onTouchEnd, {
    passive: !0
  }), t[n]("pointerleave", i.onTouchEnd, {
    passive: !0
  }), t[n]("contextmenu", i.onTouchEnd, {
    passive: !0
  }), (s.preventClicks || s.preventClicksPropagation) && r[n]("click", i.onClick, !0), s.cssMode && a[n]("scroll", i.onScroll), s.updateOnWindowResize ? i[f](p.ios || p.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Je, !0) : i[f]("observerUpdate", Je, !0), r[n]("load", i.onLoad, {
    capture: !0
  }));
};
function vi() {
  const i = this, {
    params: e
  } = i;
  i.onTouchStart = pi.bind(i), i.onTouchMove = fi.bind(i), i.onTouchEnd = ui.bind(i), i.onDocumentTouchStart = wi.bind(i), e.cssMode && (i.onScroll = hi.bind(i)), i.onClick = mi.bind(i), i.onLoad = gi.bind(i), ct(i, "on");
}
function bi() {
  ct(this, "off");
}
var yi = {
  attachEvents: vi,
  detachEvents: bi
};
const et = (i, e) => i.grid && e.grid && e.grid.rows > 1;
function Si() {
  const i = this, {
    realIndex: e,
    initialized: t,
    params: s,
    el: r
  } = i, a = s.breakpoints;
  if (!a || a && Object.keys(a).length === 0) return;
  const p = i.getBreakpoint(a, i.params.breakpointsBase, i.el);
  if (!p || i.currentBreakpoint === p) return;
  const n = (p in a ? a[p] : void 0) || i.originalParams, f = et(i, s), l = et(i, n), o = i.params.grabCursor, d = n.grabCursor, m = s.enabled;
  f && !l ? (r.classList.remove(`${s.containerModifierClass}grid`, `${s.containerModifierClass}grid-column`), i.emitContainerClasses()) : !f && l && (r.classList.add(`${s.containerModifierClass}grid`), (n.grid.fill && n.grid.fill === "column" || !n.grid.fill && s.grid.fill === "column") && r.classList.add(`${s.containerModifierClass}grid-column`), i.emitContainerClasses()), o && !d ? i.unsetGrabCursor() : !o && d && i.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((u) => {
    if (typeof n[u] > "u") return;
    const y = s[u] && s[u].enabled, x = n[u] && n[u].enabled;
    y && !x && i[u].disable(), !y && x && i[u].enable();
  });
  const h = n.direction && n.direction !== s.direction, g = s.loop && (n.slidesPerView !== s.slidesPerView || h), v = s.loop;
  h && t && i.changeDirection(), U(i.params, n);
  const b = i.params.enabled, w = i.params.loop;
  Object.assign(i, {
    allowTouchMove: i.params.allowTouchMove,
    allowSlideNext: i.params.allowSlideNext,
    allowSlidePrev: i.params.allowSlidePrev
  }), m && !b ? i.disable() : !m && b && i.enable(), i.currentBreakpoint = p, i.emit("_beforeBreakpoint", n), t && (g ? (i.loopDestroy(), i.loopCreate(e), i.updateSlides()) : !v && w ? (i.loopCreate(e), i.updateSlides()) : v && !w && i.loopDestroy()), i.emit("breakpoint", n);
}
function xi(i, e, t) {
  if (e === void 0 && (e = "window"), !i || e === "container" && !t) return;
  let s = !1;
  const r = F(), a = e === "window" ? r.innerHeight : t.clientHeight, p = Object.keys(i).map((c) => {
    if (typeof c == "string" && c.indexOf("@") === 0) {
      const n = parseFloat(c.substr(1));
      return {
        value: a * n,
        point: c
      };
    }
    return {
      value: c,
      point: c
    };
  });
  p.sort((c, n) => parseInt(c.value, 10) - parseInt(n.value, 10));
  for (let c = 0; c < p.length; c += 1) {
    const {
      point: n,
      value: f
    } = p[c];
    e === "window" ? r.matchMedia(`(min-width: ${f}px)`).matches && (s = n) : f <= t.clientWidth && (s = n);
  }
  return s || "max";
}
var Ei = {
  setBreakpoint: Si,
  getBreakpoint: xi
};
function Ti(i, e) {
  const t = [];
  return i.forEach((s) => {
    typeof s == "object" ? Object.keys(s).forEach((r) => {
      s[r] && t.push(e + r);
    }) : typeof s == "string" && t.push(e + s);
  }), t;
}
function Mi() {
  const i = this, {
    classNames: e,
    params: t,
    rtl: s,
    el: r,
    device: a
  } = i, p = Ti(["initialized", t.direction, {
    "free-mode": i.params.freeMode && t.freeMode.enabled
  }, {
    autoheight: t.autoHeight
  }, {
    rtl: s
  }, {
    grid: t.grid && t.grid.rows > 1
  }, {
    "grid-column": t.grid && t.grid.rows > 1 && t.grid.fill === "column"
  }, {
    android: a.android
  }, {
    ios: a.ios
  }, {
    "css-mode": t.cssMode
  }, {
    centered: t.cssMode && t.centeredSlides
  }, {
    "watch-progress": t.watchSlidesProgress
  }], t.containerModifierClass);
  e.push(...p), r.classList.add(...e), i.emitContainerClasses();
}
function Ci() {
  const i = this, {
    el: e,
    classNames: t
  } = i;
  !e || typeof e == "string" || (e.classList.remove(...t), i.emitContainerClasses());
}
var Pi = {
  addClasses: Mi,
  removeClasses: Ci
};
function Li() {
  const i = this, {
    isLocked: e,
    params: t
  } = i, {
    slidesOffsetBefore: s
  } = t;
  if (s) {
    const r = i.slides.length - 1, a = i.slidesGrid[r] + i.slidesSizesGrid[r] + s * 2;
    i.isLocked = i.size > a;
  } else
    i.isLocked = i.snapGrid.length === 1;
  t.allowSlideNext === !0 && (i.allowSlideNext = !i.isLocked), t.allowSlidePrev === !0 && (i.allowSlidePrev = !i.isLocked), e && e !== i.isLocked && (i.isEnd = !1), e !== i.isLocked && i.emit(i.isLocked ? "lock" : "unlock");
}
var zi = {
  checkOverflow: Li
}, Xe = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function Ii(i, e) {
  return function(s) {
    s === void 0 && (s = {});
    const r = Object.keys(s)[0], a = s[r];
    if (typeof a != "object" || a === null) {
      U(e, s);
      return;
    }
    if (i[r] === !0 && (i[r] = {
      enabled: !0
    }), r === "navigation" && i[r] && i[r].enabled && !i[r].prevEl && !i[r].nextEl && (i[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && i[r] && i[r].enabled && !i[r].el && (i[r].auto = !0), !(r in i && "enabled" in a)) {
      U(e, s);
      return;
    }
    typeof i[r] == "object" && !("enabled" in i[r]) && (i[r].enabled = !0), i[r] || (i[r] = {
      enabled: !1
    }), U(e, s);
  };
}
const Ge = {
  eventsEmitter: Pt,
  update: Bt,
  translate: Ft,
  transition: jt,
  slide: ii,
  loop: ni,
  grabCursor: di,
  events: yi,
  breakpoints: Ei,
  checkOverflow: zi,
  classes: Pi
}, He = {};
class j {
  constructor() {
    let e, t;
    for (var s = arguments.length, r = new Array(s), a = 0; a < s; a++)
      r[a] = arguments[a];
    r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? t = r[0] : [e, t] = r, t || (t = {}), t = U({}, t), e && !t.el && (t.el = e);
    const p = W();
    if (t.el && typeof t.el == "string" && p.querySelectorAll(t.el).length > 1) {
      const l = [];
      return p.querySelectorAll(t.el).forEach((o) => {
        const d = U({}, t, {
          el: o
        });
        l.push(new j(d));
      }), l;
    }
    const c = this;
    c.__swiper__ = !0, c.support = lt(), c.device = ot({
      userAgent: t.userAgent
    }), c.browser = Tt(), c.eventsListeners = {}, c.eventsAnyListeners = [], c.modules = [...c.__modules__], t.modules && Array.isArray(t.modules) && c.modules.push(...t.modules);
    const n = {};
    c.modules.forEach((l) => {
      l({
        params: t,
        swiper: c,
        extendParams: Ii(t, n),
        on: c.on.bind(c),
        once: c.once.bind(c),
        off: c.off.bind(c),
        emit: c.emit.bind(c)
      });
    });
    const f = U({}, Xe, n);
    return c.params = U({}, f, He, t), c.originalParams = U({}, c.params), c.passedParams = U({}, t), c.params && c.params.on && Object.keys(c.params.on).forEach((l) => {
      c.on(l, c.params.on[l]);
    }), c.params && c.params.onAny && c.onAny(c.params.onAny), Object.assign(c, {
      enabled: c.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return c.params.direction === "horizontal";
      },
      isVertical() {
        return c.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: c.params.allowSlideNext,
      allowSlidePrev: c.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: c.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: c.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), c.emit("_swiper"), c.params.init && c.init(), c;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: t,
      params: s
    } = this, r = N(t, `.${s.slideClass}, swiper-slide`), a = he(r[0]);
    return he(e) - a;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.filter((t) => t.getAttribute("data-swiper-slide-index") * 1 === e)[0]);
  }
  recalcSlides() {
    const e = this, {
      slidesEl: t,
      params: s
    } = e;
    e.slides = N(t, `.${s.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, t) {
    const s = this;
    e = Math.min(Math.max(e, 0), 1);
    const r = s.minTranslate(), p = (s.maxTranslate() - r) * e + r;
    s.translateTo(p, typeof t > "u" ? 0 : t), s.updateActiveIndex(), s.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = e.el.className.split(" ").filter((s) => s.indexOf("swiper") === 0 || s.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", t.join(" "));
  }
  getSlideClasses(e) {
    const t = this;
    return t.destroyed ? "" : e.className.split(" ").filter((s) => s.indexOf("swiper-slide") === 0 || s.indexOf(t.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const t = [];
    e.slides.forEach((s) => {
      const r = e.getSlideClasses(s);
      t.push({
        slideEl: s,
        classNames: r
      }), e.emit("_slideClass", s, r);
    }), e.emit("_slideClasses", t);
  }
  slidesPerViewDynamic(e, t) {
    e === void 0 && (e = "current"), t === void 0 && (t = !1);
    const s = this, {
      params: r,
      slides: a,
      slidesGrid: p,
      slidesSizesGrid: c,
      size: n,
      activeIndex: f
    } = s;
    let l = 1;
    if (typeof r.slidesPerView == "number") return r.slidesPerView;
    if (r.centeredSlides) {
      let o = a[f] ? Math.ceil(a[f].swiperSlideSize) : 0, d;
      for (let m = f + 1; m < a.length; m += 1)
        a[m] && !d && (o += Math.ceil(a[m].swiperSlideSize), l += 1, o > n && (d = !0));
      for (let m = f - 1; m >= 0; m -= 1)
        a[m] && !d && (o += a[m].swiperSlideSize, l += 1, o > n && (d = !0));
    } else if (e === "current")
      for (let o = f + 1; o < a.length; o += 1)
        (t ? p[o] + c[o] - p[f] < n : p[o] - p[f] < n) && (l += 1);
    else
      for (let o = f - 1; o >= 0; o -= 1)
        p[f] - p[o] < n && (l += 1);
    return l;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: t,
      params: s
    } = e;
    s.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((p) => {
      p.complete && ye(e, p);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function r() {
      const p = e.rtlTranslate ? e.translate * -1 : e.translate, c = Math.min(Math.max(p, e.maxTranslate()), e.minTranslate());
      e.setTranslate(c), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let a;
    if (s.freeMode && s.freeMode.enabled && !s.cssMode)
      r(), s.autoHeight && e.updateAutoHeight();
    else {
      if ((s.slidesPerView === "auto" || s.slidesPerView > 1) && e.isEnd && !s.centeredSlides) {
        const p = e.virtual && s.virtual.enabled ? e.virtual.slides : e.slides;
        a = e.slideTo(p.length - 1, 0, !1, !0);
      } else
        a = e.slideTo(e.activeIndex, 0, !1, !0);
      a || r();
    }
    s.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, t) {
    t === void 0 && (t = !0);
    const s = this, r = s.params.direction;
    return e || (e = r === "horizontal" ? "vertical" : "horizontal"), e === r || e !== "horizontal" && e !== "vertical" || (s.el.classList.remove(`${s.params.containerModifierClass}${r}`), s.el.classList.add(`${s.params.containerModifierClass}${e}`), s.emitContainerClasses(), s.params.direction = e, s.slides.forEach((a) => {
      e === "vertical" ? a.style.width = "" : a.style.height = "";
    }), s.emit("changeDirection"), t && s.update()), s;
  }
  changeLanguageDirection(e) {
    const t = this;
    t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
  }
  mount(e) {
    const t = this;
    if (t.mounted) return !0;
    let s = e || t.params.el;
    if (typeof s == "string" && (s = document.querySelector(s)), !s)
      return !1;
    s.swiper = t, s.parentNode && s.parentNode.host && s.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
    const r = () => `.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let p = s && s.shadowRoot && s.shadowRoot.querySelector ? s.shadowRoot.querySelector(r()) : N(s, r())[0];
    return !p && t.params.createElements && (p = K("div", t.params.wrapperClass), s.append(p), N(s, `.${t.params.slideClass}`).forEach((c) => {
      p.append(c);
    })), Object.assign(t, {
      el: s,
      wrapperEl: p,
      slidesEl: t.isElement && !s.parentNode.host.slideSlots ? s.parentNode.host : p,
      hostEl: t.isElement ? s.parentNode.host : s,
      mounted: !0,
      // RTL
      rtl: s.dir.toLowerCase() === "rtl" || te(s, "direction") === "rtl",
      rtlTranslate: t.params.direction === "horizontal" && (s.dir.toLowerCase() === "rtl" || te(s, "direction") === "rtl"),
      wrongRTL: te(p, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const t = this;
    if (t.initialized || t.mount(e) === !1) return t;
    t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(), t.attachEvents();
    const r = [...t.el.querySelectorAll('[loading="lazy"]')];
    return t.isElement && r.push(...t.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((a) => {
      a.complete ? ye(t, a) : a.addEventListener("load", (p) => {
        ye(t, p.target);
      });
    }), Re(t), t.initialized = !0, Re(t), t.emit("init"), t.emit("afterInit"), t;
  }
  destroy(e, t) {
    e === void 0 && (e = !0), t === void 0 && (t = !0);
    const s = this, {
      params: r,
      el: a,
      wrapperEl: p,
      slides: c
    } = s;
    return typeof s.params > "u" || s.destroyed || (s.emit("beforeDestroy"), s.initialized = !1, s.detachEvents(), r.loop && s.loopDestroy(), t && (s.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), p && p.removeAttribute("style"), c && c.length && c.forEach((n) => {
      n.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), n.removeAttribute("style"), n.removeAttribute("data-swiper-slide-index");
    })), s.emit("destroy"), Object.keys(s.eventsListeners).forEach((n) => {
      s.off(n);
    }), e !== !1 && (s.el && typeof s.el != "string" && (s.el.swiper = null), ht(s)), s.destroyed = !0), null;
  }
  static extendDefaults(e) {
    U(He, e);
  }
  static get extendedDefaults() {
    return He;
  }
  static get defaults() {
    return Xe;
  }
  static installModule(e) {
    j.prototype.__modules__ || (j.prototype.__modules__ = []);
    const t = j.prototype.__modules__;
    typeof e == "function" && t.indexOf(e) < 0 && t.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((t) => j.installModule(t)), j) : (j.installModule(e), j);
  }
}
Object.keys(Ge).forEach((i) => {
  Object.keys(Ge[i]).forEach((e) => {
    j.prototype[e] = Ge[i][e];
  });
});
j.use([Mt, Ct]);
function Ai(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  t({
    virtual: {
      enabled: !1,
      slides: [],
      cache: !0,
      renderSlide: null,
      renderExternal: null,
      renderExternalUpdate: !0,
      addSlidesBefore: 0,
      addSlidesAfter: 0
    }
  });
  let a;
  const p = W();
  e.virtual = {
    cache: {},
    from: void 0,
    to: void 0,
    slides: [],
    offset: 0,
    slidesGrid: []
  };
  const c = p.createElement("div");
  function n(h, g) {
    const v = e.params.virtual;
    if (v.cache && e.virtual.cache[g])
      return e.virtual.cache[g];
    let b;
    return v.renderSlide ? (b = v.renderSlide.call(e, h, g), typeof b == "string" && (c.innerHTML = b, b = c.children[0])) : e.isElement ? b = K("swiper-slide") : b = K("div", e.params.slideClass), b.setAttribute("data-swiper-slide-index", g), v.renderSlide || (b.innerHTML = h), v.cache && (e.virtual.cache[g] = b), b;
  }
  function f(h, g) {
    const {
      slidesPerView: v,
      slidesPerGroup: b,
      centeredSlides: w,
      loop: u,
      initialSlide: y
    } = e.params;
    if (g && !u && y > 0)
      return;
    const {
      addSlidesBefore: x,
      addSlidesAfter: A
    } = e.params.virtual, {
      from: O,
      to: I,
      slides: S,
      slidesGrid: M,
      offset: z
    } = e.virtual;
    e.params.cssMode || e.updateActiveIndex();
    const P = e.activeIndex || 0;
    let E;
    e.rtlTranslate ? E = "right" : E = e.isHorizontal() ? "left" : "top";
    let T, $;
    w ? (T = Math.floor(v / 2) + b + A, $ = Math.floor(v / 2) + b + x) : (T = v + (b - 1) + A, $ = (u ? v : b) + x);
    let H = P - $, C = P + T;
    u || (H = Math.max(H, 0), C = Math.min(C, S.length - 1));
    let L = (e.slidesGrid[H] || 0) - (e.slidesGrid[0] || 0);
    u && P >= $ ? (H -= $, w || (L += e.slidesGrid[0])) : u && P < $ && (H = -$, w && (L += e.slidesGrid[0])), Object.assign(e.virtual, {
      from: H,
      to: C,
      offset: L,
      slidesGrid: e.slidesGrid,
      slidesBefore: $,
      slidesAfter: T
    });
    function G() {
      e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), r("virtualUpdate");
    }
    if (O === H && I === C && !h) {
      e.slidesGrid !== M && L !== z && e.slides.forEach((_) => {
        _.style[E] = `${L - Math.abs(e.cssOverflowAdjustment())}px`;
      }), e.updateProgress(), r("virtualUpdate");
      return;
    }
    if (e.params.virtual.renderExternal) {
      e.params.virtual.renderExternal.call(e, {
        offset: L,
        from: H,
        to: C,
        slides: (function() {
          const V = [];
          for (let q = H; q <= C; q += 1)
            V.push(S[q]);
          return V;
        })()
      }), e.params.virtual.renderExternalUpdate ? G() : r("virtualUpdate");
      return;
    }
    const R = [], D = [], k = (_) => {
      let V = _;
      return _ < 0 ? V = S.length + _ : V >= S.length && (V = V - S.length), V;
    };
    if (h)
      e.slides.filter((_) => _.matches(`.${e.params.slideClass}, swiper-slide`)).forEach((_) => {
        _.remove();
      });
    else
      for (let _ = O; _ <= I; _ += 1)
        if (_ < H || _ > C) {
          const V = k(_);
          e.slides.filter((q) => q.matches(`.${e.params.slideClass}[data-swiper-slide-index="${V}"], swiper-slide[data-swiper-slide-index="${V}"]`)).forEach((q) => {
            q.remove();
          });
        }
    const B = u ? -S.length : 0, Y = u ? S.length * 2 : S.length;
    for (let _ = B; _ < Y; _ += 1)
      if (_ >= H && _ <= C) {
        const V = k(_);
        typeof I > "u" || h ? D.push(V) : (_ > I && D.push(V), _ < O && R.push(V));
      }
    if (D.forEach((_) => {
      e.slidesEl.append(n(S[_], _));
    }), u)
      for (let _ = R.length - 1; _ >= 0; _ -= 1) {
        const V = R[_];
        e.slidesEl.prepend(n(S[V], V));
      }
    else
      R.sort((_, V) => V - _), R.forEach((_) => {
        e.slidesEl.prepend(n(S[_], _));
      });
    N(e.slidesEl, ".swiper-slide, swiper-slide").forEach((_) => {
      _.style[E] = `${L - Math.abs(e.cssOverflowAdjustment())}px`;
    }), G();
  }
  function l(h) {
    if (typeof h == "object" && "length" in h)
      for (let g = 0; g < h.length; g += 1)
        h[g] && e.virtual.slides.push(h[g]);
    else
      e.virtual.slides.push(h);
    f(!0);
  }
  function o(h) {
    const g = e.activeIndex;
    let v = g + 1, b = 1;
    if (Array.isArray(h)) {
      for (let w = 0; w < h.length; w += 1)
        h[w] && e.virtual.slides.unshift(h[w]);
      v = g + h.length, b = h.length;
    } else
      e.virtual.slides.unshift(h);
    if (e.params.virtual.cache) {
      const w = e.virtual.cache, u = {};
      Object.keys(w).forEach((y) => {
        const x = w[y], A = x.getAttribute("data-swiper-slide-index");
        A && x.setAttribute("data-swiper-slide-index", parseInt(A, 10) + b), u[parseInt(y, 10) + b] = x;
      }), e.virtual.cache = u;
    }
    f(!0), e.slideTo(v, 0);
  }
  function d(h) {
    if (typeof h > "u" || h === null) return;
    let g = e.activeIndex;
    if (Array.isArray(h))
      for (let v = h.length - 1; v >= 0; v -= 1)
        e.params.virtual.cache && (delete e.virtual.cache[h[v]], Object.keys(e.virtual.cache).forEach((b) => {
          b > h && (e.virtual.cache[b - 1] = e.virtual.cache[b], e.virtual.cache[b - 1].setAttribute("data-swiper-slide-index", b - 1), delete e.virtual.cache[b]);
        })), e.virtual.slides.splice(h[v], 1), h[v] < g && (g -= 1), g = Math.max(g, 0);
    else
      e.params.virtual.cache && (delete e.virtual.cache[h], Object.keys(e.virtual.cache).forEach((v) => {
        v > h && (e.virtual.cache[v - 1] = e.virtual.cache[v], e.virtual.cache[v - 1].setAttribute("data-swiper-slide-index", v - 1), delete e.virtual.cache[v]);
      })), e.virtual.slides.splice(h, 1), h < g && (g -= 1), g = Math.max(g, 0);
    f(!0), e.slideTo(g, 0);
  }
  function m() {
    e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), f(!0), e.slideTo(0, 0);
  }
  s("beforeInit", () => {
    if (!e.params.virtual.enabled) return;
    let h;
    if (typeof e.passedParams.virtual.slides > "u") {
      const g = [...e.slidesEl.children].filter((v) => v.matches(`.${e.params.slideClass}, swiper-slide`));
      g && g.length && (e.virtual.slides = [...g], h = !0, g.forEach((v, b) => {
        v.setAttribute("data-swiper-slide-index", b), e.virtual.cache[b] = v, v.remove();
      }));
    }
    h || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, f(!1, !0);
  }), s("setTranslate", () => {
    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(a), a = setTimeout(() => {
      f();
    }, 100)) : f());
  }), s("init update resize", () => {
    e.params.virtual.enabled && e.params.cssMode && ue(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`);
  }), Object.assign(e.virtual, {
    appendSlide: l,
    prependSlide: o,
    removeSlide: d,
    removeAllSlides: m,
    update: f
  });
}
function $i(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = W(), p = F();
  e.keyboard = {
    enabled: !1
  }, t({
    keyboard: {
      enabled: !1,
      onlyInViewport: !0,
      pageUpDown: !0
    }
  });
  function c(l) {
    if (!e.enabled) return;
    const {
      rtlTranslate: o
    } = e;
    let d = l;
    d.originalEvent && (d = d.originalEvent);
    const m = d.keyCode || d.charCode, h = e.params.keyboard.pageUpDown, g = h && m === 33, v = h && m === 34, b = m === 37, w = m === 39, u = m === 38, y = m === 40;
    if (!e.allowSlideNext && (e.isHorizontal() && w || e.isVertical() && y || v) || !e.allowSlidePrev && (e.isHorizontal() && b || e.isVertical() && u || g))
      return !1;
    if (!(d.shiftKey || d.altKey || d.ctrlKey || d.metaKey) && !(a.activeElement && a.activeElement.nodeName && (a.activeElement.nodeName.toLowerCase() === "input" || a.activeElement.nodeName.toLowerCase() === "textarea"))) {
      if (e.params.keyboard.onlyInViewport && (g || v || b || w || u || y)) {
        let x = !1;
        if (se(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && se(e.el, `.${e.params.slideActiveClass}`).length === 0)
          return;
        const A = e.el, O = A.clientWidth, I = A.clientHeight, S = p.innerWidth, M = p.innerHeight, z = Ee(A);
        o && (z.left -= A.scrollLeft);
        const P = [[z.left, z.top], [z.left + O, z.top], [z.left, z.top + I], [z.left + O, z.top + I]];
        for (let E = 0; E < P.length; E += 1) {
          const T = P[E];
          if (T[0] >= 0 && T[0] <= S && T[1] >= 0 && T[1] <= M) {
            if (T[0] === 0 && T[1] === 0) continue;
            x = !0;
          }
        }
        if (!x) return;
      }
      e.isHorizontal() ? ((g || v || b || w) && (d.preventDefault ? d.preventDefault() : d.returnValue = !1), ((v || w) && !o || (g || b) && o) && e.slideNext(), ((g || b) && !o || (v || w) && o) && e.slidePrev()) : ((g || v || u || y) && (d.preventDefault ? d.preventDefault() : d.returnValue = !1), (v || y) && e.slideNext(), (g || u) && e.slidePrev()), r("keyPress", m);
    }
  }
  function n() {
    e.keyboard.enabled || (a.addEventListener("keydown", c), e.keyboard.enabled = !0);
  }
  function f() {
    e.keyboard.enabled && (a.removeEventListener("keydown", c), e.keyboard.enabled = !1);
  }
  s("init", () => {
    e.params.keyboard.enabled && n();
  }), s("destroy", () => {
    e.keyboard.enabled && f();
  }), Object.assign(e.keyboard, {
    enable: n,
    disable: f
  });
}
function Oi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = F();
  t({
    mousewheel: {
      enabled: !1,
      releaseOnEdges: !1,
      invert: !1,
      forceToAxis: !1,
      sensitivity: 1,
      eventsTarget: "container",
      thresholdDelta: null,
      thresholdTime: null,
      noMousewheelClass: "swiper-no-mousewheel"
    }
  }), e.mousewheel = {
    enabled: !1
  };
  let p, c = Z(), n;
  const f = [];
  function l(u) {
    let O = 0, I = 0, S = 0, M = 0;
    return "detail" in u && (I = u.detail), "wheelDelta" in u && (I = -u.wheelDelta / 120), "wheelDeltaY" in u && (I = -u.wheelDeltaY / 120), "wheelDeltaX" in u && (O = -u.wheelDeltaX / 120), "axis" in u && u.axis === u.HORIZONTAL_AXIS && (O = I, I = 0), S = O * 10, M = I * 10, "deltaY" in u && (M = u.deltaY), "deltaX" in u && (S = u.deltaX), u.shiftKey && !S && (S = M, M = 0), (S || M) && u.deltaMode && (u.deltaMode === 1 ? (S *= 40, M *= 40) : (S *= 800, M *= 800)), S && !O && (O = S < 1 ? -1 : 1), M && !I && (I = M < 1 ? -1 : 1), {
      spinX: O,
      spinY: I,
      pixelX: S,
      pixelY: M
    };
  }
  function o() {
    e.enabled && (e.mouseEntered = !0);
  }
  function d() {
    e.enabled && (e.mouseEntered = !1);
  }
  function m(u) {
    return e.params.mousewheel.thresholdDelta && u.delta < e.params.mousewheel.thresholdDelta || e.params.mousewheel.thresholdTime && Z() - c < e.params.mousewheel.thresholdTime ? !1 : u.delta >= 6 && Z() - c < 60 ? !0 : (u.direction < 0 ? (!e.isEnd || e.params.loop) && !e.animating && (e.slideNext(), r("scroll", u.raw)) : (!e.isBeginning || e.params.loop) && !e.animating && (e.slidePrev(), r("scroll", u.raw)), c = new a.Date().getTime(), !1);
  }
  function h(u) {
    const y = e.params.mousewheel;
    if (u.direction < 0) {
      if (e.isEnd && !e.params.loop && y.releaseOnEdges)
        return !0;
    } else if (e.isBeginning && !e.params.loop && y.releaseOnEdges)
      return !0;
    return !1;
  }
  function g(u) {
    let y = u, x = !0;
    if (!e.enabled || u.target.closest(`.${e.params.mousewheel.noMousewheelClass}`)) return;
    const A = e.params.mousewheel;
    e.params.cssMode && y.preventDefault();
    let O = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (O = document.querySelector(e.params.mousewheel.eventsTarget));
    const I = O && O.contains(y.target);
    if (!e.mouseEntered && !I && !A.releaseOnEdges) return !0;
    y.originalEvent && (y = y.originalEvent);
    let S = 0;
    const M = e.rtlTranslate ? -1 : 1, z = l(y);
    if (A.forceToAxis)
      if (e.isHorizontal())
        if (Math.abs(z.pixelX) > Math.abs(z.pixelY)) S = -z.pixelX * M;
        else return !0;
      else if (Math.abs(z.pixelY) > Math.abs(z.pixelX)) S = -z.pixelY;
      else return !0;
    else
      S = Math.abs(z.pixelX) > Math.abs(z.pixelY) ? -z.pixelX * M : -z.pixelY;
    if (S === 0) return !0;
    A.invert && (S = -S);
    let P = e.getTranslate() + S * A.sensitivity;
    if (P >= e.minTranslate() && (P = e.minTranslate()), P <= e.maxTranslate() && (P = e.maxTranslate()), x = e.params.loop ? !0 : !(P === e.minTranslate() || P === e.maxTranslate()), x && e.params.nested && y.stopPropagation(), !e.params.freeMode || !e.params.freeMode.enabled) {
      const E = {
        time: Z(),
        delta: Math.abs(S),
        direction: Math.sign(S),
        raw: u
      };
      f.length >= 2 && f.shift();
      const T = f.length ? f[f.length - 1] : void 0;
      if (f.push(E), T ? (E.direction !== T.direction || E.delta > T.delta || E.time > T.time + 150) && m(E) : m(E), h(E))
        return !0;
    } else {
      const E = {
        time: Z(),
        delta: Math.abs(S),
        direction: Math.sign(S)
      }, T = n && E.time < n.time + 500 && E.delta <= n.delta && E.direction === n.direction;
      if (!T) {
        n = void 0;
        let $ = e.getTranslate() + S * A.sensitivity;
        const H = e.isBeginning, C = e.isEnd;
        if ($ >= e.minTranslate() && ($ = e.minTranslate()), $ <= e.maxTranslate() && ($ = e.maxTranslate()), e.setTransition(0), e.setTranslate($), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!H && e.isBeginning || !C && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
          direction: E.direction < 0 ? "next" : "prev",
          byMousewheel: !0
        }), e.params.freeMode.sticky) {
          clearTimeout(p), p = void 0, f.length >= 15 && f.shift();
          const L = f.length ? f[f.length - 1] : void 0, G = f[0];
          if (f.push(E), L && (E.delta > L.delta || E.direction !== L.direction))
            f.splice(0);
          else if (f.length >= 15 && E.time - G.time < 500 && G.delta - E.delta >= 1 && E.delta <= 6) {
            const R = S > 0 ? 0.8 : 0.2;
            n = E, f.splice(0), p = re(() => {
              e.destroyed || !e.params || e.slideToClosest(e.params.speed, !0, void 0, R);
            }, 0);
          }
          p || (p = re(() => {
            if (e.destroyed || !e.params) return;
            const R = 0.5;
            n = E, f.splice(0), e.slideToClosest(e.params.speed, !0, void 0, R);
          }, 500));
        }
        if (T || r("scroll", y), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), A.releaseOnEdges && ($ === e.minTranslate() || $ === e.maxTranslate()))
          return !0;
      }
    }
    return y.preventDefault ? y.preventDefault() : y.returnValue = !1, !1;
  }
  function v(u) {
    let y = e.el;
    e.params.mousewheel.eventsTarget !== "container" && (y = document.querySelector(e.params.mousewheel.eventsTarget)), y[u]("mouseenter", o), y[u]("mouseleave", d), y[u]("wheel", g);
  }
  function b() {
    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", g), !0) : e.mousewheel.enabled ? !1 : (v("addEventListener"), e.mousewheel.enabled = !0, !0);
  }
  function w() {
    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, g), !0) : e.mousewheel.enabled ? (v("removeEventListener"), e.mousewheel.enabled = !1, !0) : !1;
  }
  s("init", () => {
    !e.params.mousewheel.enabled && e.params.cssMode && w(), e.params.mousewheel.enabled && b();
  }), s("destroy", () => {
    e.params.cssMode && b(), e.mousewheel.enabled && w();
  }), Object.assign(e.mousewheel, {
    enable: b,
    disable: w
  });
}
function Fe(i, e, t, s) {
  return i.params.createElements && Object.keys(s).forEach((r) => {
    if (!t[r] && t.auto === !0) {
      let a = N(i.el, `.${s[r]}`)[0];
      a || (a = K("div", s[r]), a.className = s[r], i.el.append(a)), t[r] = a, e[r] = a;
    }
  }), t;
}
function Di(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  t({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function a(h) {
    let g;
    return h && typeof h == "string" && e.isElement && (g = e.el.querySelector(h) || e.hostEl.querySelector(h), g) ? g : (h && (typeof h == "string" && (g = [...document.querySelectorAll(h)]), e.params.uniqueNavElements && typeof h == "string" && g && g.length > 1 && e.el.querySelectorAll(h).length === 1 ? g = e.el.querySelector(h) : g && g.length === 1 && (g = g[0])), h && !g ? h : g);
  }
  function p(h, g) {
    const v = e.params.navigation;
    h = X(h), h.forEach((b) => {
      b && (b.classList[g ? "add" : "remove"](...v.disabledClass.split(" ")), b.tagName === "BUTTON" && (b.disabled = g), e.params.watchOverflow && e.enabled && b.classList[e.isLocked ? "add" : "remove"](v.lockClass));
    });
  }
  function c() {
    const {
      nextEl: h,
      prevEl: g
    } = e.navigation;
    if (e.params.loop) {
      p(g, !1), p(h, !1);
      return;
    }
    p(g, e.isBeginning && !e.params.rewind), p(h, e.isEnd && !e.params.rewind);
  }
  function n(h) {
    h.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), r("navigationPrev"));
  }
  function f(h) {
    h.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), r("navigationNext"));
  }
  function l() {
    const h = e.params.navigation;
    if (e.params.navigation = Fe(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(h.nextEl || h.prevEl)) return;
    let g = a(h.nextEl), v = a(h.prevEl);
    Object.assign(e.navigation, {
      nextEl: g,
      prevEl: v
    }), g = X(g), v = X(v);
    const b = (w, u) => {
      w && w.addEventListener("click", u === "next" ? f : n), !e.enabled && w && w.classList.add(...h.lockClass.split(" "));
    };
    g.forEach((w) => b(w, "next")), v.forEach((w) => b(w, "prev"));
  }
  function o() {
    let {
      nextEl: h,
      prevEl: g
    } = e.navigation;
    h = X(h), g = X(g);
    const v = (b, w) => {
      b.removeEventListener("click", w === "next" ? f : n), b.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    h.forEach((b) => v(b, "next")), g.forEach((b) => v(b, "prev"));
  }
  s("init", () => {
    e.params.navigation.enabled === !1 ? m() : (l(), c());
  }), s("toEdge fromEdge lock unlock", () => {
    c();
  }), s("destroy", () => {
    o();
  }), s("enable disable", () => {
    let {
      nextEl: h,
      prevEl: g
    } = e.navigation;
    if (h = X(h), g = X(g), e.enabled) {
      c();
      return;
    }
    [...h, ...g].filter((v) => !!v).forEach((v) => v.classList.add(e.params.navigation.lockClass));
  }), s("click", (h, g) => {
    let {
      nextEl: v,
      prevEl: b
    } = e.navigation;
    v = X(v), b = X(b);
    const w = g.target;
    let u = b.includes(w) || v.includes(w);
    if (e.isElement && !u) {
      const y = g.path || g.composedPath && g.composedPath();
      y && (u = y.find((x) => v.includes(x) || b.includes(x)));
    }
    if (e.params.navigation.hideOnClick && !u) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === w || e.pagination.el.contains(w))) return;
      let y;
      v.length ? y = v[0].classList.contains(e.params.navigation.hiddenClass) : b.length && (y = b[0].classList.contains(e.params.navigation.hiddenClass)), r(y === !0 ? "navigationShow" : "navigationHide"), [...v, ...b].filter((x) => !!x).forEach((x) => x.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const d = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), l(), c();
  }, m = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), o();
  };
  Object.assign(e.navigation, {
    enable: d,
    disable: m,
    update: c,
    init: l,
    destroy: o
  });
}
function J(i) {
  return i === void 0 && (i = ""), `.${i.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`;
}
function ki(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = "swiper-pagination";
  t({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (w) => w,
      formatFractionTotal: (w) => w,
      bulletClass: `${a}-bullet`,
      bulletActiveClass: `${a}-bullet-active`,
      modifierClass: `${a}-`,
      currentClass: `${a}-current`,
      totalClass: `${a}-total`,
      hiddenClass: `${a}-hidden`,
      progressbarFillClass: `${a}-progressbar-fill`,
      progressbarOppositeClass: `${a}-progressbar-opposite`,
      clickableClass: `${a}-clickable`,
      lockClass: `${a}-lock`,
      horizontalClass: `${a}-horizontal`,
      verticalClass: `${a}-vertical`,
      paginationDisabledClass: `${a}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let p, c = 0;
  function n() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function f(w, u) {
    const {
      bulletActiveClass: y
    } = e.params.pagination;
    w && (w = w[`${u === "prev" ? "previous" : "next"}ElementSibling`], w && (w.classList.add(`${y}-${u}`), w = w[`${u === "prev" ? "previous" : "next"}ElementSibling`], w && w.classList.add(`${y}-${u}-${u}`)));
  }
  function l(w, u, y) {
    if (w = w % y, u = u % y, u === w + 1)
      return "next";
    if (u === w - 1)
      return "previous";
  }
  function o(w) {
    const u = w.target.closest(J(e.params.pagination.bulletClass));
    if (!u)
      return;
    w.preventDefault();
    const y = he(u) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === y) return;
      const x = l(e.realIndex, y, e.slides.length);
      x === "next" ? e.slideNext() : x === "previous" ? e.slidePrev() : e.slideToLoop(y);
    } else
      e.slideTo(y);
  }
  function d() {
    const w = e.rtl, u = e.params.pagination;
    if (n()) return;
    let y = e.pagination.el;
    y = X(y);
    let x, A;
    const O = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, I = e.params.loop ? Math.ceil(O / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (A = e.previousRealIndex || 0, x = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (x = e.snapIndex, A = e.previousSnapIndex) : (A = e.previousIndex || 0, x = e.activeIndex || 0), u.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const S = e.pagination.bullets;
      let M, z, P;
      if (u.dynamicBullets && (p = _e(S[0], e.isHorizontal() ? "width" : "height"), y.forEach((E) => {
        E.style[e.isHorizontal() ? "width" : "height"] = `${p * (u.dynamicMainBullets + 4)}px`;
      }), u.dynamicMainBullets > 1 && A !== void 0 && (c += x - (A || 0), c > u.dynamicMainBullets - 1 ? c = u.dynamicMainBullets - 1 : c < 0 && (c = 0)), M = Math.max(x - c, 0), z = M + (Math.min(S.length, u.dynamicMainBullets) - 1), P = (z + M) / 2), S.forEach((E) => {
        const T = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(($) => `${u.bulletActiveClass}${$}`)].map(($) => typeof $ == "string" && $.includes(" ") ? $.split(" ") : $).flat();
        E.classList.remove(...T);
      }), y.length > 1)
        S.forEach((E) => {
          const T = he(E);
          T === x ? E.classList.add(...u.bulletActiveClass.split(" ")) : e.isElement && E.setAttribute("part", "bullet"), u.dynamicBullets && (T >= M && T <= z && E.classList.add(...`${u.bulletActiveClass}-main`.split(" ")), T === M && f(E, "prev"), T === z && f(E, "next"));
        });
      else {
        const E = S[x];
        if (E && E.classList.add(...u.bulletActiveClass.split(" ")), e.isElement && S.forEach((T, $) => {
          T.setAttribute("part", $ === x ? "bullet-active" : "bullet");
        }), u.dynamicBullets) {
          const T = S[M], $ = S[z];
          for (let H = M; H <= z; H += 1)
            S[H] && S[H].classList.add(...`${u.bulletActiveClass}-main`.split(" "));
          f(T, "prev"), f($, "next");
        }
      }
      if (u.dynamicBullets) {
        const E = Math.min(S.length, u.dynamicMainBullets + 4), T = (p * E - p) / 2 - P * p, $ = w ? "right" : "left";
        S.forEach((H) => {
          H.style[e.isHorizontal() ? $ : "top"] = `${T}px`;
        });
      }
    }
    y.forEach((S, M) => {
      if (u.type === "fraction" && (S.querySelectorAll(J(u.currentClass)).forEach((z) => {
        z.textContent = u.formatFractionCurrent(x + 1);
      }), S.querySelectorAll(J(u.totalClass)).forEach((z) => {
        z.textContent = u.formatFractionTotal(I);
      })), u.type === "progressbar") {
        let z;
        u.progressbarOpposite ? z = e.isHorizontal() ? "vertical" : "horizontal" : z = e.isHorizontal() ? "horizontal" : "vertical";
        const P = (x + 1) / I;
        let E = 1, T = 1;
        z === "horizontal" ? E = P : T = P, S.querySelectorAll(J(u.progressbarFillClass)).forEach(($) => {
          $.style.transform = `translate3d(0,0,0) scaleX(${E}) scaleY(${T})`, $.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      u.type === "custom" && u.renderCustom ? (S.innerHTML = u.renderCustom(e, x + 1, I), M === 0 && r("paginationRender", S)) : (M === 0 && r("paginationRender", S), r("paginationUpdate", S)), e.params.watchOverflow && e.enabled && S.classList[e.isLocked ? "add" : "remove"](u.lockClass);
    });
  }
  function m() {
    const w = e.params.pagination;
    if (n()) return;
    const u = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let y = e.pagination.el;
    y = X(y);
    let x = "";
    if (w.type === "bullets") {
      let A = e.params.loop ? Math.ceil(u / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && A > u && (A = u);
      for (let O = 0; O < A; O += 1)
        w.renderBullet ? x += w.renderBullet.call(e, O, w.bulletClass) : x += `<${w.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${w.bulletClass}"></${w.bulletElement}>`;
    }
    w.type === "fraction" && (w.renderFraction ? x = w.renderFraction.call(e, w.currentClass, w.totalClass) : x = `<span class="${w.currentClass}"></span> / <span class="${w.totalClass}"></span>`), w.type === "progressbar" && (w.renderProgressbar ? x = w.renderProgressbar.call(e, w.progressbarFillClass) : x = `<span class="${w.progressbarFillClass}"></span>`), e.pagination.bullets = [], y.forEach((A) => {
      w.type !== "custom" && (A.innerHTML = x || ""), w.type === "bullets" && e.pagination.bullets.push(...A.querySelectorAll(J(w.bulletClass)));
    }), w.type !== "custom" && r("paginationRender", y[0]);
  }
  function h() {
    e.params.pagination = Fe(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const w = e.params.pagination;
    if (!w.el) return;
    let u;
    typeof w.el == "string" && e.isElement && (u = e.el.querySelector(w.el)), !u && typeof w.el == "string" && (u = [...document.querySelectorAll(w.el)]), u || (u = w.el), !(!u || u.length === 0) && (e.params.uniqueNavElements && typeof w.el == "string" && Array.isArray(u) && u.length > 1 && (u = [...e.el.querySelectorAll(w.el)], u.length > 1 && (u = u.filter((y) => se(y, ".swiper")[0] === e.el)[0])), Array.isArray(u) && u.length === 1 && (u = u[0]), Object.assign(e.pagination, {
      el: u
    }), u = X(u), u.forEach((y) => {
      w.type === "bullets" && w.clickable && y.classList.add(...(w.clickableClass || "").split(" ")), y.classList.add(w.modifierClass + w.type), y.classList.add(e.isHorizontal() ? w.horizontalClass : w.verticalClass), w.type === "bullets" && w.dynamicBullets && (y.classList.add(`${w.modifierClass}${w.type}-dynamic`), c = 0, w.dynamicMainBullets < 1 && (w.dynamicMainBullets = 1)), w.type === "progressbar" && w.progressbarOpposite && y.classList.add(w.progressbarOppositeClass), w.clickable && y.addEventListener("click", o), e.enabled || y.classList.add(w.lockClass);
    }));
  }
  function g() {
    const w = e.params.pagination;
    if (n()) return;
    let u = e.pagination.el;
    u && (u = X(u), u.forEach((y) => {
      y.classList.remove(w.hiddenClass), y.classList.remove(w.modifierClass + w.type), y.classList.remove(e.isHorizontal() ? w.horizontalClass : w.verticalClass), w.clickable && (y.classList.remove(...(w.clickableClass || "").split(" ")), y.removeEventListener("click", o));
    })), e.pagination.bullets && e.pagination.bullets.forEach((y) => y.classList.remove(...w.bulletActiveClass.split(" ")));
  }
  s("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const w = e.params.pagination;
    let {
      el: u
    } = e.pagination;
    u = X(u), u.forEach((y) => {
      y.classList.remove(w.horizontalClass, w.verticalClass), y.classList.add(e.isHorizontal() ? w.horizontalClass : w.verticalClass);
    });
  }), s("init", () => {
    e.params.pagination.enabled === !1 ? b() : (h(), m(), d());
  }), s("activeIndexChange", () => {
    typeof e.snapIndex > "u" && d();
  }), s("snapIndexChange", () => {
    d();
  }), s("snapGridLengthChange", () => {
    m(), d();
  }), s("destroy", () => {
    g();
  }), s("enable disable", () => {
    let {
      el: w
    } = e.pagination;
    w && (w = X(w), w.forEach((u) => u.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), s("lock unlock", () => {
    d();
  }), s("click", (w, u) => {
    const y = u.target, x = X(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && x && x.length > 0 && !y.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && y === e.navigation.nextEl || e.navigation.prevEl && y === e.navigation.prevEl)) return;
      const A = x[0].classList.contains(e.params.pagination.hiddenClass);
      r(A === !0 ? "paginationShow" : "paginationHide"), x.forEach((O) => O.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const v = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: w
    } = e.pagination;
    w && (w = X(w), w.forEach((u) => u.classList.remove(e.params.pagination.paginationDisabledClass))), h(), m(), d();
  }, b = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: w
    } = e.pagination;
    w && (w = X(w), w.forEach((u) => u.classList.add(e.params.pagination.paginationDisabledClass))), g();
  };
  Object.assign(e.pagination, {
    enable: v,
    disable: b,
    render: m,
    update: d,
    init: h,
    destroy: g
  });
}
function Gi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = W();
  let p = !1, c = null, n = null, f, l, o, d;
  t({
    scrollbar: {
      el: null,
      dragSize: "auto",
      hide: !1,
      draggable: !1,
      snapOnRelease: !0,
      lockClass: "swiper-scrollbar-lock",
      dragClass: "swiper-scrollbar-drag",
      scrollbarDisabledClass: "swiper-scrollbar-disabled",
      horizontalClass: "swiper-scrollbar-horizontal",
      verticalClass: "swiper-scrollbar-vertical"
    }
  }), e.scrollbar = {
    el: null,
    dragEl: null
  };
  function m() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: P,
      rtlTranslate: E
    } = e, {
      dragEl: T,
      el: $
    } = P, H = e.params.scrollbar, C = e.params.loop ? e.progressLoop : e.progress;
    let L = l, G = (o - l) * C;
    E ? (G = -G, G > 0 ? (L = l - G, G = 0) : -G + l > o && (L = o + G)) : G < 0 ? (L = l + G, G = 0) : G + l > o && (L = o - G), e.isHorizontal() ? (T.style.transform = `translate3d(${G}px, 0, 0)`, T.style.width = `${L}px`) : (T.style.transform = `translate3d(0px, ${G}px, 0)`, T.style.height = `${L}px`), H.hide && (clearTimeout(c), $.style.opacity = 1, c = setTimeout(() => {
      $.style.opacity = 0, $.style.transitionDuration = "400ms";
    }, 1e3));
  }
  function h(P) {
    !e.params.scrollbar.el || !e.scrollbar.el || (e.scrollbar.dragEl.style.transitionDuration = `${P}ms`);
  }
  function g() {
    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
    const {
      scrollbar: P
    } = e, {
      dragEl: E,
      el: T
    } = P;
    E.style.width = "", E.style.height = "", o = e.isHorizontal() ? T.offsetWidth : T.offsetHeight, d = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), e.params.scrollbar.dragSize === "auto" ? l = o * d : l = parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? E.style.width = `${l}px` : E.style.height = `${l}px`, d >= 1 ? T.style.display = "none" : T.style.display = "", e.params.scrollbar.hide && (T.style.opacity = 0), e.params.watchOverflow && e.enabled && P.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass);
  }
  function v(P) {
    return e.isHorizontal() ? P.clientX : P.clientY;
  }
  function b(P) {
    const {
      scrollbar: E,
      rtlTranslate: T
    } = e, {
      el: $
    } = E;
    let H;
    H = (v(P) - Ee($)[e.isHorizontal() ? "left" : "top"] - (f !== null ? f : l / 2)) / (o - l), H = Math.max(Math.min(H, 1), 0), T && (H = 1 - H);
    const C = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * H;
    e.updateProgress(C), e.setTranslate(C), e.updateActiveIndex(), e.updateSlidesClasses();
  }
  function w(P) {
    const E = e.params.scrollbar, {
      scrollbar: T,
      wrapperEl: $
    } = e, {
      el: H,
      dragEl: C
    } = T;
    p = !0, f = P.target === C ? v(P) - P.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, P.preventDefault(), P.stopPropagation(), $.style.transitionDuration = "100ms", C.style.transitionDuration = "100ms", b(P), clearTimeout(n), H.style.transitionDuration = "0ms", E.hide && (H.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), r("scrollbarDragStart", P);
  }
  function u(P) {
    const {
      scrollbar: E,
      wrapperEl: T
    } = e, {
      el: $,
      dragEl: H
    } = E;
    p && (P.preventDefault && P.cancelable ? P.preventDefault() : P.returnValue = !1, b(P), T.style.transitionDuration = "0ms", $.style.transitionDuration = "0ms", H.style.transitionDuration = "0ms", r("scrollbarDragMove", P));
  }
  function y(P) {
    const E = e.params.scrollbar, {
      scrollbar: T,
      wrapperEl: $
    } = e, {
      el: H
    } = T;
    p && (p = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", $.style.transitionDuration = ""), E.hide && (clearTimeout(n), n = re(() => {
      H.style.opacity = 0, H.style.transitionDuration = "400ms";
    }, 1e3)), r("scrollbarDragEnd", P), E.snapOnRelease && e.slideToClosest());
  }
  function x(P) {
    const {
      scrollbar: E,
      params: T
    } = e, $ = E.el;
    if (!$) return;
    const H = $, C = T.passiveListeners ? {
      passive: !1,
      capture: !1
    } : !1, L = T.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1;
    if (!H) return;
    const G = P === "on" ? "addEventListener" : "removeEventListener";
    H[G]("pointerdown", w, C), a[G]("pointermove", u, C), a[G]("pointerup", y, L);
  }
  function A() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("on");
  }
  function O() {
    !e.params.scrollbar.el || !e.scrollbar.el || x("off");
  }
  function I() {
    const {
      scrollbar: P,
      el: E
    } = e;
    e.params.scrollbar = Fe(e, e.originalParams.scrollbar, e.params.scrollbar, {
      el: "swiper-scrollbar"
    });
    const T = e.params.scrollbar;
    if (!T.el) return;
    let $;
    if (typeof T.el == "string" && e.isElement && ($ = e.el.querySelector(T.el)), !$ && typeof T.el == "string") {
      if ($ = a.querySelectorAll(T.el), !$.length) return;
    } else $ || ($ = T.el);
    e.params.uniqueNavElements && typeof T.el == "string" && $.length > 1 && E.querySelectorAll(T.el).length === 1 && ($ = E.querySelector(T.el)), $.length > 0 && ($ = $[0]), $.classList.add(e.isHorizontal() ? T.horizontalClass : T.verticalClass);
    let H;
    $ && (H = $.querySelector(J(e.params.scrollbar.dragClass)), H || (H = K("div", e.params.scrollbar.dragClass), $.append(H))), Object.assign(P, {
      el: $,
      dragEl: H
    }), T.draggable && A(), $ && $.classList[e.enabled ? "remove" : "add"](...ee(e.params.scrollbar.lockClass));
  }
  function S() {
    const P = e.params.scrollbar, E = e.scrollbar.el;
    E && E.classList.remove(...ee(e.isHorizontal() ? P.horizontalClass : P.verticalClass)), O();
  }
  s("changeDirection", () => {
    if (!e.scrollbar || !e.scrollbar.el) return;
    const P = e.params.scrollbar;
    let {
      el: E
    } = e.scrollbar;
    E = X(E), E.forEach((T) => {
      T.classList.remove(P.horizontalClass, P.verticalClass), T.classList.add(e.isHorizontal() ? P.horizontalClass : P.verticalClass);
    });
  }), s("init", () => {
    e.params.scrollbar.enabled === !1 ? z() : (I(), g(), m());
  }), s("update resize observerUpdate lock unlock changeDirection", () => {
    g();
  }), s("setTranslate", () => {
    m();
  }), s("setTransition", (P, E) => {
    h(E);
  }), s("enable disable", () => {
    const {
      el: P
    } = e.scrollbar;
    P && P.classList[e.enabled ? "remove" : "add"](...ee(e.params.scrollbar.lockClass));
  }), s("destroy", () => {
    S();
  });
  const M = () => {
    e.el.classList.remove(...ee(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.remove(...ee(e.params.scrollbar.scrollbarDisabledClass)), I(), g(), m();
  }, z = () => {
    e.el.classList.add(...ee(e.params.scrollbar.scrollbarDisabledClass)), e.scrollbar.el && e.scrollbar.el.classList.add(...ee(e.params.scrollbar.scrollbarDisabledClass)), S();
  };
  Object.assign(e.scrollbar, {
    enable: M,
    disable: z,
    updateSize: g,
    setTranslate: m,
    init: I,
    destroy: S
  });
}
function Hi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    parallax: {
      enabled: !1
    }
  });
  const r = "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]", a = (n, f) => {
    const {
      rtl: l
    } = e, o = l ? -1 : 1, d = n.getAttribute("data-swiper-parallax") || "0";
    let m = n.getAttribute("data-swiper-parallax-x"), h = n.getAttribute("data-swiper-parallax-y");
    const g = n.getAttribute("data-swiper-parallax-scale"), v = n.getAttribute("data-swiper-parallax-opacity"), b = n.getAttribute("data-swiper-parallax-rotate");
    if (m || h ? (m = m || "0", h = h || "0") : e.isHorizontal() ? (m = d, h = "0") : (h = d, m = "0"), m.indexOf("%") >= 0 ? m = `${parseInt(m, 10) * f * o}%` : m = `${m * f * o}px`, h.indexOf("%") >= 0 ? h = `${parseInt(h, 10) * f}%` : h = `${h * f}px`, typeof v < "u" && v !== null) {
      const u = v - (v - 1) * (1 - Math.abs(f));
      n.style.opacity = u;
    }
    let w = `translate3d(${m}, ${h}, 0px)`;
    if (typeof g < "u" && g !== null) {
      const u = g - (g - 1) * (1 - Math.abs(f));
      w += ` scale(${u})`;
    }
    if (b && typeof b < "u" && b !== null) {
      const u = b * f * -1;
      w += ` rotate(${u}deg)`;
    }
    n.style.transform = w;
  }, p = () => {
    const {
      el: n,
      slides: f,
      progress: l,
      snapGrid: o,
      isElement: d
    } = e, m = N(n, r);
    e.isElement && m.push(...N(e.hostEl, r)), m.forEach((h) => {
      a(h, l);
    }), f.forEach((h, g) => {
      let v = h.progress;
      e.params.slidesPerGroup > 1 && e.params.slidesPerView !== "auto" && (v += Math.ceil(g / 2) - l * (o.length - 1)), v = Math.min(Math.max(v, -1), 1), h.querySelectorAll(`${r}, [data-swiper-parallax-rotate]`).forEach((b) => {
        a(b, v);
      });
    });
  }, c = function(n) {
    n === void 0 && (n = e.params.speed);
    const {
      el: f,
      hostEl: l
    } = e, o = [...f.querySelectorAll(r)];
    e.isElement && o.push(...l.querySelectorAll(r)), o.forEach((d) => {
      let m = parseInt(d.getAttribute("data-swiper-parallax-duration"), 10) || n;
      n === 0 && (m = 0), d.style.transitionDuration = `${m}ms`;
    });
  };
  s("beforeInit", () => {
    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
  }), s("init", () => {
    e.params.parallax.enabled && p();
  }), s("setTranslate", () => {
    e.params.parallax.enabled && p();
  }), s("setTransition", (n, f) => {
    e.params.parallax.enabled && c(f);
  });
}
function Bi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r
  } = i;
  const a = F();
  t({
    zoom: {
      enabled: !1,
      limitToOriginalSize: !1,
      maxRatio: 3,
      minRatio: 1,
      toggle: !0,
      containerClass: "swiper-zoom-container",
      zoomedSlideClass: "swiper-slide-zoomed"
    }
  }), e.zoom = {
    enabled: !1
  };
  let p = 1, c = !1, n, f;
  const l = [], o = {
    originX: 0,
    originY: 0,
    slideEl: void 0,
    slideWidth: void 0,
    slideHeight: void 0,
    imageEl: void 0,
    imageWrapEl: void 0,
    maxRatio: 3
  }, d = {
    isTouched: void 0,
    isMoved: void 0,
    currentX: void 0,
    currentY: void 0,
    minX: void 0,
    minY: void 0,
    maxX: void 0,
    maxY: void 0,
    width: void 0,
    height: void 0,
    startX: void 0,
    startY: void 0,
    touchesStart: {},
    touchesCurrent: {}
  }, m = {
    x: void 0,
    y: void 0,
    prevPositionX: void 0,
    prevPositionY: void 0,
    prevTime: void 0
  };
  let h = 1;
  Object.defineProperty(e.zoom, "scale", {
    get() {
      return h;
    },
    set(D) {
      if (h !== D) {
        const k = o.imageEl, B = o.slideEl;
        r("zoomChange", D, k, B);
      }
      h = D;
    }
  });
  function g() {
    if (l.length < 2) return 1;
    const D = l[0].pageX, k = l[0].pageY, B = l[1].pageX, Y = l[1].pageY;
    return Math.sqrt((B - D) ** 2 + (Y - k) ** 2);
  }
  function v() {
    const D = e.params.zoom, k = o.imageWrapEl.getAttribute("data-swiper-zoom") || D.maxRatio;
    if (D.limitToOriginalSize && o.imageEl && o.imageEl.naturalWidth) {
      const B = o.imageEl.naturalWidth / o.imageEl.offsetWidth;
      return Math.min(B, k);
    }
    return k;
  }
  function b() {
    if (l.length < 2) return {
      x: null,
      y: null
    };
    const D = o.imageEl.getBoundingClientRect();
    return [(l[0].pageX + (l[1].pageX - l[0].pageX) / 2 - D.x - a.scrollX) / p, (l[0].pageY + (l[1].pageY - l[0].pageY) / 2 - D.y - a.scrollY) / p];
  }
  function w() {
    return e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
  }
  function u(D) {
    const k = w();
    return !!(D.target.matches(k) || e.slides.filter((B) => B.contains(D.target)).length > 0);
  }
  function y(D) {
    const k = `.${e.params.zoom.containerClass}`;
    return !!(D.target.matches(k) || [...e.hostEl.querySelectorAll(k)].filter((B) => B.contains(D.target)).length > 0);
  }
  function x(D) {
    if (D.pointerType === "mouse" && l.splice(0, l.length), !u(D)) return;
    const k = e.params.zoom;
    if (n = !1, f = !1, l.push(D), !(l.length < 2)) {
      if (n = !0, o.scaleStart = g(), !o.slideEl) {
        o.slideEl = D.target.closest(`.${e.params.slideClass}, swiper-slide`), o.slideEl || (o.slideEl = e.slides[e.activeIndex]);
        let B = o.slideEl.querySelector(`.${k.containerClass}`);
        if (B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), o.imageEl = B, B ? o.imageWrapEl = se(o.imageEl, `.${k.containerClass}`)[0] : o.imageWrapEl = void 0, !o.imageWrapEl) {
          o.imageEl = void 0;
          return;
        }
        o.maxRatio = v();
      }
      if (o.imageEl) {
        const [B, Y] = b();
        o.originX = B, o.originY = Y, o.imageEl.style.transitionDuration = "0ms";
      }
      c = !0;
    }
  }
  function A(D) {
    if (!u(D)) return;
    const k = e.params.zoom, B = e.zoom, Y = l.findIndex((_) => _.pointerId === D.pointerId);
    Y >= 0 && (l[Y] = D), !(l.length < 2) && (f = !0, o.scaleMove = g(), o.imageEl && (B.scale = o.scaleMove / o.scaleStart * p, B.scale > o.maxRatio && (B.scale = o.maxRatio - 1 + (B.scale - o.maxRatio + 1) ** 0.5), B.scale < k.minRatio && (B.scale = k.minRatio + 1 - (k.minRatio - B.scale + 1) ** 0.5), o.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`));
  }
  function O(D) {
    if (!u(D) || D.pointerType === "mouse" && D.type === "pointerout") return;
    const k = e.params.zoom, B = e.zoom, Y = l.findIndex((_) => _.pointerId === D.pointerId);
    Y >= 0 && l.splice(Y, 1), !(!n || !f) && (n = !1, f = !1, o.imageEl && (B.scale = Math.max(Math.min(B.scale, o.maxRatio), k.minRatio), o.imageEl.style.transitionDuration = `${e.params.speed}ms`, o.imageEl.style.transform = `translate3d(0,0,0) scale(${B.scale})`, p = B.scale, c = !1, B.scale > 1 && o.slideEl ? o.slideEl.classList.add(`${k.zoomedSlideClass}`) : B.scale <= 1 && o.slideEl && o.slideEl.classList.remove(`${k.zoomedSlideClass}`), B.scale === 1 && (o.originX = 0, o.originY = 0, o.slideEl = void 0)));
  }
  let I;
  function S() {
    e.touchEventsData.preventTouchMoveFromPointerMove = !1;
  }
  function M() {
    clearTimeout(I), e.touchEventsData.preventTouchMoveFromPointerMove = !0, I = setTimeout(() => {
      e.destroyed || S();
    });
  }
  function z(D) {
    const k = e.device;
    if (!o.imageEl || d.isTouched) return;
    k.android && D.cancelable && D.preventDefault(), d.isTouched = !0;
    const B = l.length > 0 ? l[0] : D;
    d.touchesStart.x = B.pageX, d.touchesStart.y = B.pageY;
  }
  function P(D) {
    if (!u(D) || !y(D))
      return;
    const k = e.zoom;
    if (!o.imageEl || !d.isTouched || !o.slideEl)
      return;
    d.isMoved || (d.width = o.imageEl.offsetWidth || o.imageEl.clientWidth, d.height = o.imageEl.offsetHeight || o.imageEl.clientHeight, d.startX = Be(o.imageWrapEl, "x") || 0, d.startY = Be(o.imageWrapEl, "y") || 0, o.slideWidth = o.slideEl.offsetWidth, o.slideHeight = o.slideEl.offsetHeight, o.imageWrapEl.style.transitionDuration = "0ms");
    const B = d.width * k.scale, Y = d.height * k.scale;
    if (d.minX = Math.min(o.slideWidth / 2 - B / 2, 0), d.maxX = -d.minX, d.minY = Math.min(o.slideHeight / 2 - Y / 2, 0), d.maxY = -d.minY, d.touchesCurrent.x = l.length > 0 ? l[0].pageX : D.pageX, d.touchesCurrent.y = l.length > 0 ? l[0].pageY : D.pageY, Math.max(Math.abs(d.touchesCurrent.x - d.touchesStart.x), Math.abs(d.touchesCurrent.y - d.touchesStart.y)) > 5 && (e.allowClick = !1), !d.isMoved && !c) {
      if (e.isHorizontal() && (Math.floor(d.minX) === Math.floor(d.startX) && d.touchesCurrent.x < d.touchesStart.x || Math.floor(d.maxX) === Math.floor(d.startX) && d.touchesCurrent.x > d.touchesStart.x)) {
        d.isTouched = !1, S();
        return;
      }
      if (!e.isHorizontal() && (Math.floor(d.minY) === Math.floor(d.startY) && d.touchesCurrent.y < d.touchesStart.y || Math.floor(d.maxY) === Math.floor(d.startY) && d.touchesCurrent.y > d.touchesStart.y)) {
        d.isTouched = !1, S();
        return;
      }
    }
    D.cancelable && D.preventDefault(), D.stopPropagation(), M(), d.isMoved = !0;
    const V = (k.scale - p) / (o.maxRatio - e.params.zoom.minRatio), {
      originX: q,
      originY: ne
    } = o;
    d.currentX = d.touchesCurrent.x - d.touchesStart.x + d.startX + V * (d.width - q * 2), d.currentY = d.touchesCurrent.y - d.touchesStart.y + d.startY + V * (d.height - ne * 2), d.currentX < d.minX && (d.currentX = d.minX + 1 - (d.minX - d.currentX + 1) ** 0.8), d.currentX > d.maxX && (d.currentX = d.maxX - 1 + (d.currentX - d.maxX + 1) ** 0.8), d.currentY < d.minY && (d.currentY = d.minY + 1 - (d.minY - d.currentY + 1) ** 0.8), d.currentY > d.maxY && (d.currentY = d.maxY - 1 + (d.currentY - d.maxY + 1) ** 0.8), m.prevPositionX || (m.prevPositionX = d.touchesCurrent.x), m.prevPositionY || (m.prevPositionY = d.touchesCurrent.y), m.prevTime || (m.prevTime = Date.now()), m.x = (d.touchesCurrent.x - m.prevPositionX) / (Date.now() - m.prevTime) / 2, m.y = (d.touchesCurrent.y - m.prevPositionY) / (Date.now() - m.prevTime) / 2, Math.abs(d.touchesCurrent.x - m.prevPositionX) < 2 && (m.x = 0), Math.abs(d.touchesCurrent.y - m.prevPositionY) < 2 && (m.y = 0), m.prevPositionX = d.touchesCurrent.x, m.prevPositionY = d.touchesCurrent.y, m.prevTime = Date.now(), o.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function E() {
    const D = e.zoom;
    if (!o.imageEl) return;
    if (!d.isTouched || !d.isMoved) {
      d.isTouched = !1, d.isMoved = !1;
      return;
    }
    d.isTouched = !1, d.isMoved = !1;
    let k = 300, B = 300;
    const Y = m.x * k, _ = d.currentX + Y, V = m.y * B, q = d.currentY + V;
    m.x !== 0 && (k = Math.abs((_ - d.currentX) / m.x)), m.y !== 0 && (B = Math.abs((q - d.currentY) / m.y));
    const ne = Math.max(k, B);
    d.currentX = _, d.currentY = q;
    const we = d.width * D.scale, Q = d.height * D.scale;
    d.minX = Math.min(o.slideWidth / 2 - we / 2, 0), d.maxX = -d.minX, d.minY = Math.min(o.slideHeight / 2 - Q / 2, 0), d.maxY = -d.minY, d.currentX = Math.max(Math.min(d.currentX, d.maxX), d.minX), d.currentY = Math.max(Math.min(d.currentY, d.maxY), d.minY), o.imageWrapEl.style.transitionDuration = `${ne}ms`, o.imageWrapEl.style.transform = `translate3d(${d.currentX}px, ${d.currentY}px,0)`;
  }
  function T() {
    const D = e.zoom;
    o.slideEl && e.activeIndex !== e.slides.indexOf(o.slideEl) && (o.imageEl && (o.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), o.imageWrapEl && (o.imageWrapEl.style.transform = "translate3d(0,0,0)"), o.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), D.scale = 1, p = 1, o.slideEl = void 0, o.imageEl = void 0, o.imageWrapEl = void 0, o.originX = 0, o.originY = 0);
  }
  function $(D) {
    const k = e.zoom, B = e.params.zoom;
    if (!o.slideEl) {
      D && D.target && (o.slideEl = D.target.closest(`.${e.params.slideClass}, swiper-slide`)), o.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? o.slideEl = N(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : o.slideEl = e.slides[e.activeIndex]);
      let pe = o.slideEl.querySelector(`.${B.containerClass}`);
      pe && (pe = pe.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), o.imageEl = pe, pe ? o.imageWrapEl = se(o.imageEl, `.${B.containerClass}`)[0] : o.imageWrapEl = void 0;
    }
    if (!o.imageEl || !o.imageWrapEl) return;
    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), o.slideEl.classList.add(`${B.zoomedSlideClass}`);
    let Y, _, V, q, ne, we, Q, ie, Ne, We, qe, je, ve, be, Pe, Le, ze, Ie;
    typeof d.touchesStart.x > "u" && D ? (Y = D.pageX, _ = D.pageY) : (Y = d.touchesStart.x, _ = d.touchesStart.y);
    const ce = typeof D == "number" ? D : null;
    p === 1 && ce && (Y = void 0, _ = void 0, d.touchesStart.x = void 0, d.touchesStart.y = void 0);
    const Ue = v();
    k.scale = ce || Ue, p = ce || Ue, D && !(p === 1 && ce) ? (ze = o.slideEl.offsetWidth, Ie = o.slideEl.offsetHeight, V = Ee(o.slideEl).left + a.scrollX, q = Ee(o.slideEl).top + a.scrollY, ne = V + ze / 2 - Y, we = q + Ie / 2 - _, Ne = o.imageEl.offsetWidth || o.imageEl.clientWidth, We = o.imageEl.offsetHeight || o.imageEl.clientHeight, qe = Ne * k.scale, je = We * k.scale, ve = Math.min(ze / 2 - qe / 2, 0), be = Math.min(Ie / 2 - je / 2, 0), Pe = -ve, Le = -be, Q = ne * k.scale, ie = we * k.scale, Q < ve && (Q = ve), Q > Pe && (Q = Pe), ie < be && (ie = be), ie > Le && (ie = Le)) : (Q = 0, ie = 0), ce && k.scale === 1 && (o.originX = 0, o.originY = 0), o.imageWrapEl.style.transitionDuration = "300ms", o.imageWrapEl.style.transform = `translate3d(${Q}px, ${ie}px,0)`, o.imageEl.style.transitionDuration = "300ms", o.imageEl.style.transform = `translate3d(0,0,0) scale(${k.scale})`;
  }
  function H() {
    const D = e.zoom, k = e.params.zoom;
    if (!o.slideEl) {
      e.params.virtual && e.params.virtual.enabled && e.virtual ? o.slideEl = N(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : o.slideEl = e.slides[e.activeIndex];
      let B = o.slideEl.querySelector(`.${k.containerClass}`);
      B && (B = B.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), o.imageEl = B, B ? o.imageWrapEl = se(o.imageEl, `.${k.containerClass}`)[0] : o.imageWrapEl = void 0;
    }
    !o.imageEl || !o.imageWrapEl || (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), D.scale = 1, p = 1, d.touchesStart.x = void 0, d.touchesStart.y = void 0, o.imageWrapEl.style.transitionDuration = "300ms", o.imageWrapEl.style.transform = "translate3d(0,0,0)", o.imageEl.style.transitionDuration = "300ms", o.imageEl.style.transform = "translate3d(0,0,0) scale(1)", o.slideEl.classList.remove(`${k.zoomedSlideClass}`), o.slideEl = void 0, o.originX = 0, o.originY = 0);
  }
  function C(D) {
    const k = e.zoom;
    k.scale && k.scale !== 1 ? H() : $(D);
  }
  function L() {
    const D = e.params.passiveListeners ? {
      passive: !0,
      capture: !1
    } : !1, k = e.params.passiveListeners ? {
      passive: !1,
      capture: !0
    } : !0;
    return {
      passiveListener: D,
      activeListenerWithCapture: k
    };
  }
  function G() {
    const D = e.zoom;
    if (D.enabled) return;
    D.enabled = !0;
    const {
      passiveListener: k,
      activeListenerWithCapture: B
    } = L();
    e.wrapperEl.addEventListener("pointerdown", x, k), e.wrapperEl.addEventListener("pointermove", A, B), ["pointerup", "pointercancel", "pointerout"].forEach((Y) => {
      e.wrapperEl.addEventListener(Y, O, k);
    }), e.wrapperEl.addEventListener("pointermove", P, B);
  }
  function R() {
    const D = e.zoom;
    if (!D.enabled) return;
    D.enabled = !1;
    const {
      passiveListener: k,
      activeListenerWithCapture: B
    } = L();
    e.wrapperEl.removeEventListener("pointerdown", x, k), e.wrapperEl.removeEventListener("pointermove", A, B), ["pointerup", "pointercancel", "pointerout"].forEach((Y) => {
      e.wrapperEl.removeEventListener(Y, O, k);
    }), e.wrapperEl.removeEventListener("pointermove", P, B);
  }
  s("init", () => {
    e.params.zoom.enabled && G();
  }), s("destroy", () => {
    R();
  }), s("touchStart", (D, k) => {
    e.zoom.enabled && z(k);
  }), s("touchEnd", (D, k) => {
    e.zoom.enabled && E();
  }), s("doubleTap", (D, k) => {
    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && C(k);
  }), s("transitionEnd", () => {
    e.zoom.enabled && e.params.zoom.enabled && T();
  }), s("slideChange", () => {
    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && T();
  }), Object.assign(e.zoom, {
    enable: G,
    disable: R,
    in: $,
    out: H,
    toggle: C
  });
}
function _i(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    controller: {
      control: void 0,
      inverse: !1,
      by: "slide"
      // or 'container'
    }
  }), e.controller = {
    control: void 0
  };
  function r(f, l) {
    const o = /* @__PURE__ */ (function() {
      let g, v, b;
      return (w, u) => {
        for (v = -1, g = w.length; g - v > 1; )
          b = g + v >> 1, w[b] <= u ? v = b : g = b;
        return g;
      };
    })();
    this.x = f, this.y = l, this.lastIndex = f.length - 1;
    let d, m;
    return this.interpolate = function(g) {
      return g ? (m = o(this.x, g), d = m - 1, (g - this.x[d]) * (this.y[m] - this.y[d]) / (this.x[m] - this.x[d]) + this.y[d]) : 0;
    }, this;
  }
  function a(f) {
    e.controller.spline = e.params.loop ? new r(e.slidesGrid, f.slidesGrid) : new r(e.snapGrid, f.snapGrid);
  }
  function p(f, l) {
    const o = e.controller.control;
    let d, m;
    const h = e.constructor;
    function g(v) {
      if (v.destroyed) return;
      const b = e.rtlTranslate ? -e.translate : e.translate;
      e.params.controller.by === "slide" && (a(v), m = -e.controller.spline.interpolate(-b)), (!m || e.params.controller.by === "container") && (d = (v.maxTranslate() - v.minTranslate()) / (e.maxTranslate() - e.minTranslate()), (Number.isNaN(d) || !Number.isFinite(d)) && (d = 1), m = (b - e.minTranslate()) * d + v.minTranslate()), e.params.controller.inverse && (m = v.maxTranslate() - m), v.updateProgress(m), v.setTranslate(m, e), v.updateActiveIndex(), v.updateSlidesClasses();
    }
    if (Array.isArray(o))
      for (let v = 0; v < o.length; v += 1)
        o[v] !== l && o[v] instanceof h && g(o[v]);
    else o instanceof h && l !== o && g(o);
  }
  function c(f, l) {
    const o = e.constructor, d = e.controller.control;
    let m;
    function h(g) {
      g.destroyed || (g.setTransition(f, e), f !== 0 && (g.transitionStart(), g.params.autoHeight && re(() => {
        g.updateAutoHeight();
      }), me(g.wrapperEl, () => {
        d && g.transitionEnd();
      })));
    }
    if (Array.isArray(d))
      for (m = 0; m < d.length; m += 1)
        d[m] !== l && d[m] instanceof o && h(d[m]);
    else d instanceof o && l !== d && h(d);
  }
  function n() {
    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline);
  }
  s("beforeInit", () => {
    if (typeof window < "u" && // eslint-disable-line
    (typeof e.params.controller.control == "string" || e.params.controller.control instanceof HTMLElement)) {
      (typeof e.params.controller.control == "string" ? [...document.querySelectorAll(e.params.controller.control)] : [e.params.controller.control]).forEach((l) => {
        if (e.controller.control || (e.controller.control = []), l && l.swiper)
          e.controller.control.push(l.swiper);
        else if (l) {
          const o = `${e.params.eventsPrefix}init`, d = (m) => {
            e.controller.control.push(m.detail[0]), e.update(), l.removeEventListener(o, d);
          };
          l.addEventListener(o, d);
        }
      });
      return;
    }
    e.controller.control = e.params.controller.control;
  }), s("update", () => {
    n();
  }), s("resize", () => {
    n();
  }), s("observerUpdate", () => {
    n();
  }), s("setTranslate", (f, l, o) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTranslate(l, o);
  }), s("setTransition", (f, l, o) => {
    !e.controller.control || e.controller.control.destroyed || e.controller.setTransition(l, o);
  }), Object.assign(e.controller, {
    setTranslate: p,
    setTransition: c
  });
}
function Ri(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    a11y: {
      enabled: !0,
      notificationClass: "swiper-notification",
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
      firstSlideMessage: "This is the first slide",
      lastSlideMessage: "This is the last slide",
      paginationBulletMessage: "Go to slide {{index}}",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      containerRole: null,
      itemRoleDescriptionMessage: null,
      slideRole: "group",
      id: null,
      scrollOnFocus: !0
    }
  }), e.a11y = {
    clicked: !1
  };
  let r = null, a, p, c = (/* @__PURE__ */ new Date()).getTime();
  function n(C) {
    const L = r;
    L.length !== 0 && (L.innerHTML = "", L.innerHTML = C);
  }
  function f(C) {
    const L = () => Math.round(16 * Math.random()).toString(16);
    return "x".repeat(C).replace(/x/g, L);
  }
  function l(C) {
    C = X(C), C.forEach((L) => {
      L.setAttribute("tabIndex", "0");
    });
  }
  function o(C) {
    C = X(C), C.forEach((L) => {
      L.setAttribute("tabIndex", "-1");
    });
  }
  function d(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("role", L);
    });
  }
  function m(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("aria-roledescription", L);
    });
  }
  function h(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("aria-controls", L);
    });
  }
  function g(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("aria-label", L);
    });
  }
  function v(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("id", L);
    });
  }
  function b(C, L) {
    C = X(C), C.forEach((G) => {
      G.setAttribute("aria-live", L);
    });
  }
  function w(C) {
    C = X(C), C.forEach((L) => {
      L.setAttribute("aria-disabled", !0);
    });
  }
  function u(C) {
    C = X(C), C.forEach((L) => {
      L.setAttribute("aria-disabled", !1);
    });
  }
  function y(C) {
    if (C.keyCode !== 13 && C.keyCode !== 32) return;
    const L = e.params.a11y, G = C.target;
    if (!(e.pagination && e.pagination.el && (G === e.pagination.el || e.pagination.el.contains(C.target)) && !C.target.matches(J(e.params.pagination.bulletClass)))) {
      if (e.navigation && e.navigation.prevEl && e.navigation.nextEl) {
        const R = X(e.navigation.prevEl);
        X(e.navigation.nextEl).includes(G) && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? n(L.lastSlideMessage) : n(L.nextSlideMessage)), R.includes(G) && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? n(L.firstSlideMessage) : n(L.prevSlideMessage));
      }
      e.pagination && G.matches(J(e.params.pagination.bulletClass)) && G.click();
    }
  }
  function x() {
    if (e.params.loop || e.params.rewind || !e.navigation) return;
    const {
      nextEl: C,
      prevEl: L
    } = e.navigation;
    L && (e.isBeginning ? (w(L), o(L)) : (u(L), l(L))), C && (e.isEnd ? (w(C), o(C)) : (u(C), l(C)));
  }
  function A() {
    return e.pagination && e.pagination.bullets && e.pagination.bullets.length;
  }
  function O() {
    return A() && e.params.pagination.clickable;
  }
  function I() {
    const C = e.params.a11y;
    A() && e.pagination.bullets.forEach((L) => {
      e.params.pagination.clickable && (l(L), e.params.pagination.renderBullet || (d(L, "button"), g(L, C.paginationBulletMessage.replace(/\{\{index\}\}/, he(L) + 1)))), L.matches(J(e.params.pagination.bulletActiveClass)) ? L.setAttribute("aria-current", "true") : L.removeAttribute("aria-current");
    });
  }
  const S = (C, L, G) => {
    l(C), C.tagName !== "BUTTON" && (d(C, "button"), C.addEventListener("keydown", y)), g(C, G), h(C, L);
  }, M = (C) => {
    p && p !== C.target && !p.contains(C.target) && (a = !0), e.a11y.clicked = !0;
  }, z = () => {
    a = !1, requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        e.destroyed || (e.a11y.clicked = !1);
      });
    });
  }, P = (C) => {
    c = (/* @__PURE__ */ new Date()).getTime();
  }, E = (C) => {
    if (e.a11y.clicked || !e.params.a11y.scrollOnFocus || (/* @__PURE__ */ new Date()).getTime() - c < 100) return;
    const L = C.target.closest(`.${e.params.slideClass}, swiper-slide`);
    if (!L || !e.slides.includes(L)) return;
    p = L;
    const G = e.slides.indexOf(L) === e.activeIndex, R = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(L);
    G || R || C.sourceCapabilities && C.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, requestAnimationFrame(() => {
      a || (e.params.loop ? e.slideToLoop(parseInt(L.getAttribute("data-swiper-slide-index")), 0) : e.slideTo(e.slides.indexOf(L), 0), a = !1);
    }));
  }, T = () => {
    const C = e.params.a11y;
    C.itemRoleDescriptionMessage && m(e.slides, C.itemRoleDescriptionMessage), C.slideRole && d(e.slides, C.slideRole);
    const L = e.slides.length;
    C.slideLabelMessage && e.slides.forEach((G, R) => {
      const D = e.params.loop ? parseInt(G.getAttribute("data-swiper-slide-index"), 10) : R, k = C.slideLabelMessage.replace(/\{\{index\}\}/, D + 1).replace(/\{\{slidesLength\}\}/, L);
      g(G, k);
    });
  }, $ = () => {
    const C = e.params.a11y;
    e.el.append(r);
    const L = e.el;
    C.containerRoleDescriptionMessage && m(L, C.containerRoleDescriptionMessage), C.containerMessage && g(L, C.containerMessage), C.containerRole && d(L, C.containerRole);
    const G = e.wrapperEl, R = C.id || G.getAttribute("id") || `swiper-wrapper-${f(16)}`, D = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
    v(G, R), b(G, D), T();
    let {
      nextEl: k,
      prevEl: B
    } = e.navigation ? e.navigation : {};
    k = X(k), B = X(B), k && k.forEach((_) => S(_, R, C.nextSlideMessage)), B && B.forEach((_) => S(_, R, C.prevSlideMessage)), O() && X(e.pagination.el).forEach((V) => {
      V.addEventListener("keydown", y);
    }), W().addEventListener("visibilitychange", P), e.el.addEventListener("focus", E, !0), e.el.addEventListener("focus", E, !0), e.el.addEventListener("pointerdown", M, !0), e.el.addEventListener("pointerup", z, !0);
  };
  function H() {
    r && r.remove();
    let {
      nextEl: C,
      prevEl: L
    } = e.navigation ? e.navigation : {};
    C = X(C), L = X(L), C && C.forEach((R) => R.removeEventListener("keydown", y)), L && L.forEach((R) => R.removeEventListener("keydown", y)), O() && X(e.pagination.el).forEach((D) => {
      D.removeEventListener("keydown", y);
    }), W().removeEventListener("visibilitychange", P), e.el && typeof e.el != "string" && (e.el.removeEventListener("focus", E, !0), e.el.removeEventListener("pointerdown", M, !0), e.el.removeEventListener("pointerup", z, !0));
  }
  s("beforeInit", () => {
    r = K("span", e.params.a11y.notificationClass), r.setAttribute("aria-live", "assertive"), r.setAttribute("aria-atomic", "true");
  }), s("afterInit", () => {
    e.params.a11y.enabled && $();
  }), s("slidesLengthChange snapGridLengthChange slidesGridLengthChange", () => {
    e.params.a11y.enabled && T();
  }), s("fromEdge toEdge afterInit lock unlock", () => {
    e.params.a11y.enabled && x();
  }), s("paginationUpdate", () => {
    e.params.a11y.enabled && I();
  }), s("destroy", () => {
    e.params.a11y.enabled && H();
  });
}
function Xi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    history: {
      enabled: !1,
      root: "",
      replaceState: !1,
      key: "slides",
      keepQuery: !1
    }
  });
  let r = !1, a = {};
  const p = (m) => m.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""), c = (m) => {
    const h = F();
    let g;
    m ? g = new URL(m) : g = h.location;
    const v = g.pathname.slice(1).split("/").filter((y) => y !== ""), b = v.length, w = v[b - 2], u = v[b - 1];
    return {
      key: w,
      value: u
    };
  }, n = (m, h) => {
    const g = F();
    if (!r || !e.params.history.enabled) return;
    let v;
    e.params.url ? v = new URL(e.params.url) : v = g.location;
    const b = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${h}"]`) : e.slides[h];
    let w = p(b.getAttribute("data-history"));
    if (e.params.history.root.length > 0) {
      let y = e.params.history.root;
      y[y.length - 1] === "/" && (y = y.slice(0, y.length - 1)), w = `${y}/${m ? `${m}/` : ""}${w}`;
    } else v.pathname.includes(m) || (w = `${m ? `${m}/` : ""}${w}`);
    e.params.history.keepQuery && (w += v.search);
    const u = g.history.state;
    u && u.value === w || (e.params.history.replaceState ? g.history.replaceState({
      value: w
    }, null, w) : g.history.pushState({
      value: w
    }, null, w));
  }, f = (m, h, g) => {
    if (h)
      for (let v = 0, b = e.slides.length; v < b; v += 1) {
        const w = e.slides[v];
        if (p(w.getAttribute("data-history")) === h) {
          const y = e.getSlideIndex(w);
          e.slideTo(y, m, g);
        }
      }
    else
      e.slideTo(0, m, g);
  }, l = () => {
    a = c(e.params.url), f(e.params.speed, a.value, !1);
  }, o = () => {
    const m = F();
    if (e.params.history) {
      if (!m.history || !m.history.pushState) {
        e.params.history.enabled = !1, e.params.hashNavigation.enabled = !0;
        return;
      }
      if (r = !0, a = c(e.params.url), !a.key && !a.value) {
        e.params.history.replaceState || m.addEventListener("popstate", l);
        return;
      }
      f(0, a.value, e.params.runCallbacksOnInit), e.params.history.replaceState || m.addEventListener("popstate", l);
    }
  }, d = () => {
    const m = F();
    e.params.history.replaceState || m.removeEventListener("popstate", l);
  };
  s("init", () => {
    e.params.history.enabled && o();
  }), s("destroy", () => {
    e.params.history.enabled && d();
  }), s("transitionEnd _freeModeNoMomentumRelease", () => {
    r && n(e.params.history.key, e.activeIndex);
  }), s("slideChange", () => {
    r && e.params.cssMode && n(e.params.history.key, e.activeIndex);
  });
}
function Vi(i) {
  let {
    swiper: e,
    extendParams: t,
    emit: s,
    on: r
  } = i, a = !1;
  const p = W(), c = F();
  t({
    hashNavigation: {
      enabled: !1,
      replaceState: !1,
      watchState: !1,
      getSlideIndex(d, m) {
        if (e.virtual && e.params.virtual.enabled) {
          const h = e.slides.filter((v) => v.getAttribute("data-hash") === m)[0];
          return h ? parseInt(h.getAttribute("data-swiper-slide-index"), 10) : 0;
        }
        return e.getSlideIndex(N(e.slidesEl, `.${e.params.slideClass}[data-hash="${m}"], swiper-slide[data-hash="${m}"]`)[0]);
      }
    }
  });
  const n = () => {
    s("hashChange");
    const d = p.location.hash.replace("#", ""), m = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], h = m ? m.getAttribute("data-hash") : "";
    if (d !== h) {
      const g = e.params.hashNavigation.getSlideIndex(e, d);
      if (typeof g > "u" || Number.isNaN(g)) return;
      e.slideTo(g);
    }
  }, f = () => {
    if (!a || !e.params.hashNavigation.enabled) return;
    const d = e.virtual && e.params.virtual.enabled ? e.slidesEl.querySelector(`[data-swiper-slide-index="${e.activeIndex}"]`) : e.slides[e.activeIndex], m = d ? d.getAttribute("data-hash") || d.getAttribute("data-history") : "";
    e.params.hashNavigation.replaceState && c.history && c.history.replaceState ? (c.history.replaceState(null, null, `#${m}` || ""), s("hashSet")) : (p.location.hash = m || "", s("hashSet"));
  }, l = () => {
    if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
    a = !0;
    const d = p.location.hash.replace("#", "");
    if (d) {
      const h = e.params.hashNavigation.getSlideIndex(e, d);
      e.slideTo(h || 0, 0, e.params.runCallbacksOnInit, !0);
    }
    e.params.hashNavigation.watchState && c.addEventListener("hashchange", n);
  }, o = () => {
    e.params.hashNavigation.watchState && c.removeEventListener("hashchange", n);
  };
  r("init", () => {
    e.params.hashNavigation.enabled && l();
  }), r("destroy", () => {
    e.params.hashNavigation.enabled && o();
  }), r("transitionEnd _freeModeNoMomentumRelease", () => {
    a && f();
  }), r("slideChange", () => {
    a && e.params.cssMode && f();
  });
}
function Yi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s,
    emit: r,
    params: a
  } = i;
  e.autoplay = {
    running: !1,
    paused: !1,
    timeLeft: 0
  }, t({
    autoplay: {
      enabled: !1,
      delay: 3e3,
      waitForTransition: !0,
      disableOnInteraction: !1,
      stopOnLastSlide: !1,
      reverseDirection: !1,
      pauseOnMouseEnter: !1
    }
  });
  let p, c, n = a && a.autoplay ? a.autoplay.delay : 3e3, f = a && a.autoplay ? a.autoplay.delay : 3e3, l, o = (/* @__PURE__ */ new Date()).getTime(), d, m, h, g, v, b, w;
  function u(L) {
    !e || e.destroyed || !e.wrapperEl || L.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", u), !(w || L.detail && L.detail.bySwiperTouchMove) && M());
  }
  const y = () => {
    if (e.destroyed || !e.autoplay.running) return;
    e.autoplay.paused ? d = !0 : d && (f = l, d = !1);
    const L = e.autoplay.paused ? l : o + f - (/* @__PURE__ */ new Date()).getTime();
    e.autoplay.timeLeft = L, r("autoplayTimeLeft", L, L / n), c = requestAnimationFrame(() => {
      y();
    });
  }, x = () => {
    let L;
    return e.virtual && e.params.virtual.enabled ? L = e.slides.filter((R) => R.classList.contains("swiper-slide-active"))[0] : L = e.slides[e.activeIndex], L ? parseInt(L.getAttribute("data-swiper-autoplay"), 10) : void 0;
  }, A = (L) => {
    if (e.destroyed || !e.autoplay.running) return;
    cancelAnimationFrame(c), y();
    let G = typeof L > "u" ? e.params.autoplay.delay : L;
    n = e.params.autoplay.delay, f = e.params.autoplay.delay;
    const R = x();
    !Number.isNaN(R) && R > 0 && typeof L > "u" && (G = R, n = R, f = R), l = G;
    const D = e.params.speed, k = () => {
      !e || e.destroyed || (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(D, !0, !0), r("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, D, !0, !0), r("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(D, !0, !0), r("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, D, !0, !0), r("autoplay")), e.params.cssMode && (o = (/* @__PURE__ */ new Date()).getTime(), requestAnimationFrame(() => {
        A();
      })));
    };
    return G > 0 ? (clearTimeout(p), p = setTimeout(() => {
      k();
    }, G)) : requestAnimationFrame(() => {
      k();
    }), G;
  }, O = () => {
    o = (/* @__PURE__ */ new Date()).getTime(), e.autoplay.running = !0, A(), r("autoplayStart");
  }, I = () => {
    e.autoplay.running = !1, clearTimeout(p), cancelAnimationFrame(c), r("autoplayStop");
  }, S = (L, G) => {
    if (e.destroyed || !e.autoplay.running) return;
    clearTimeout(p), L || (b = !0);
    const R = () => {
      r("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", u) : M();
    };
    if (e.autoplay.paused = !0, G) {
      v && (l = e.params.autoplay.delay), v = !1, R();
      return;
    }
    l = (l || e.params.autoplay.delay) - ((/* @__PURE__ */ new Date()).getTime() - o), !(e.isEnd && l < 0 && !e.params.loop) && (l < 0 && (l = 0), R());
  }, M = () => {
    e.isEnd && l < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (o = (/* @__PURE__ */ new Date()).getTime(), b ? (b = !1, A(l)) : A(), e.autoplay.paused = !1, r("autoplayResume"));
  }, z = () => {
    if (e.destroyed || !e.autoplay.running) return;
    const L = W();
    L.visibilityState === "hidden" && (b = !0, S(!0)), L.visibilityState === "visible" && M();
  }, P = (L) => {
    L.pointerType === "mouse" && (b = !0, w = !0, !(e.animating || e.autoplay.paused) && S(!0));
  }, E = (L) => {
    L.pointerType === "mouse" && (w = !1, e.autoplay.paused && M());
  }, T = () => {
    e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", P), e.el.addEventListener("pointerleave", E));
  }, $ = () => {
    e.el && typeof e.el != "string" && (e.el.removeEventListener("pointerenter", P), e.el.removeEventListener("pointerleave", E));
  }, H = () => {
    W().addEventListener("visibilitychange", z);
  }, C = () => {
    W().removeEventListener("visibilitychange", z);
  };
  s("init", () => {
    e.params.autoplay.enabled && (T(), H(), O());
  }), s("destroy", () => {
    $(), C(), e.autoplay.running && I();
  }), s("_freeModeStaticRelease", () => {
    (h || b) && M();
  }), s("_freeModeNoMomentumRelease", () => {
    e.params.autoplay.disableOnInteraction ? I() : S(!0, !0);
  }), s("beforeTransitionStart", (L, G, R) => {
    e.destroyed || !e.autoplay.running || (R || !e.params.autoplay.disableOnInteraction ? S(!0, !0) : I());
  }), s("sliderFirstMove", () => {
    if (!(e.destroyed || !e.autoplay.running)) {
      if (e.params.autoplay.disableOnInteraction) {
        I();
        return;
      }
      m = !0, h = !1, b = !1, g = setTimeout(() => {
        b = !0, h = !0, S(!0);
      }, 200);
    }
  }), s("touchEnd", () => {
    if (!(e.destroyed || !e.autoplay.running || !m)) {
      if (clearTimeout(g), clearTimeout(p), e.params.autoplay.disableOnInteraction) {
        h = !1, m = !1;
        return;
      }
      h && e.params.cssMode && M(), h = !1, m = !1;
    }
  }), s("slideChange", () => {
    e.destroyed || !e.autoplay.running || (v = !0);
  }), Object.assign(e.autoplay, {
    start: O,
    stop: I,
    pause: S,
    resume: M
  });
}
function Fi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    thumbs: {
      swiper: null,
      multipleActiveThumbs: !0,
      autoScrollOffset: 0,
      slideThumbActiveClass: "swiper-slide-thumb-active",
      thumbsContainerClass: "swiper-thumbs"
    }
  });
  let r = !1, a = !1;
  e.thumbs = {
    swiper: null
  };
  function p() {
    const f = e.thumbs.swiper;
    if (!f || f.destroyed) return;
    const l = f.clickedIndex, o = f.clickedSlide;
    if (o && o.classList.contains(e.params.thumbs.slideThumbActiveClass) || typeof l > "u" || l === null) return;
    let d;
    f.params.loop ? d = parseInt(f.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : d = l, e.params.loop ? e.slideToLoop(d) : e.slideTo(d);
  }
  function c() {
    const {
      thumbs: f
    } = e.params;
    if (r) return !1;
    r = !0;
    const l = e.constructor;
    if (f.swiper instanceof l)
      e.thumbs.swiper = f.swiper, Object.assign(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), Object.assign(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper.update();
    else if (fe(f.swiper)) {
      const o = Object.assign({}, f.swiper);
      Object.assign(o, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), e.thumbs.swiper = new l(o), a = !0;
    }
    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", p), !0;
  }
  function n(f) {
    const l = e.thumbs.swiper;
    if (!l || l.destroyed) return;
    const o = l.params.slidesPerView === "auto" ? l.slidesPerViewDynamic() : l.params.slidesPerView;
    let d = 1;
    const m = e.params.thumbs.slideThumbActiveClass;
    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (d = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (d = 1), d = Math.floor(d), l.slides.forEach((v) => v.classList.remove(m)), l.params.loop || l.params.virtual && l.params.virtual.enabled)
      for (let v = 0; v < d; v += 1)
        N(l.slidesEl, `[data-swiper-slide-index="${e.realIndex + v}"]`).forEach((b) => {
          b.classList.add(m);
        });
    else
      for (let v = 0; v < d; v += 1)
        l.slides[e.realIndex + v] && l.slides[e.realIndex + v].classList.add(m);
    const h = e.params.thumbs.autoScrollOffset, g = h && !l.params.loop;
    if (e.realIndex !== l.realIndex || g) {
      const v = l.activeIndex;
      let b, w;
      if (l.params.loop) {
        const u = l.slides.filter((y) => y.getAttribute("data-swiper-slide-index") === `${e.realIndex}`)[0];
        b = l.slides.indexOf(u), w = e.activeIndex > e.previousIndex ? "next" : "prev";
      } else
        b = e.realIndex, w = b > e.previousIndex ? "next" : "prev";
      g && (b += w === "next" ? h : -1 * h), l.visibleSlidesIndexes && l.visibleSlidesIndexes.indexOf(b) < 0 && (l.params.centeredSlides ? b > v ? b = b - Math.floor(o / 2) + 1 : b = b + Math.floor(o / 2) - 1 : b > v && l.params.slidesPerGroup, l.slideTo(b, f ? 0 : void 0));
    }
  }
  s("beforeInit", () => {
    const {
      thumbs: f
    } = e.params;
    if (!(!f || !f.swiper))
      if (typeof f.swiper == "string" || f.swiper instanceof HTMLElement) {
        const l = W(), o = () => {
          const m = typeof f.swiper == "string" ? l.querySelector(f.swiper) : f.swiper;
          if (m && m.swiper)
            f.swiper = m.swiper, c(), n(!0);
          else if (m) {
            const h = `${e.params.eventsPrefix}init`, g = (v) => {
              f.swiper = v.detail[0], m.removeEventListener(h, g), c(), n(!0), f.swiper.update(), e.update();
            };
            m.addEventListener(h, g);
          }
          return m;
        }, d = () => {
          if (e.destroyed) return;
          o() || requestAnimationFrame(d);
        };
        requestAnimationFrame(d);
      } else
        c(), n(!0);
  }), s("slideChange update resize observerUpdate", () => {
    n();
  }), s("setTransition", (f, l) => {
    const o = e.thumbs.swiper;
    !o || o.destroyed || o.setTransition(l);
  }), s("beforeDestroy", () => {
    const f = e.thumbs.swiper;
    !f || f.destroyed || a && f.destroy();
  }), Object.assign(e.thumbs, {
    init: c,
    update: n
  });
}
function Ni(i) {
  let {
    swiper: e,
    extendParams: t,
    emit: s,
    once: r
  } = i;
  t({
    freeMode: {
      enabled: !1,
      momentum: !0,
      momentumRatio: 1,
      momentumBounce: !0,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: !1,
      minimumVelocity: 0.02
    }
  });
  function a() {
    if (e.params.cssMode) return;
    const n = e.getTranslate();
    e.setTranslate(n), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
      currentPos: e.rtl ? e.translate : -e.translate
    });
  }
  function p() {
    if (e.params.cssMode) return;
    const {
      touchEventsData: n,
      touches: f
    } = e;
    n.velocities.length === 0 && n.velocities.push({
      position: f[e.isHorizontal() ? "startX" : "startY"],
      time: n.touchStartTime
    }), n.velocities.push({
      position: f[e.isHorizontal() ? "currentX" : "currentY"],
      time: Z()
    });
  }
  function c(n) {
    let {
      currentPos: f
    } = n;
    if (e.params.cssMode) return;
    const {
      params: l,
      wrapperEl: o,
      rtlTranslate: d,
      snapGrid: m,
      touchEventsData: h
    } = e, v = Z() - h.touchStartTime;
    if (f < -e.minTranslate()) {
      e.slideTo(e.activeIndex);
      return;
    }
    if (f > -e.maxTranslate()) {
      e.slides.length < m.length ? e.slideTo(m.length - 1) : e.slideTo(e.slides.length - 1);
      return;
    }
    if (l.freeMode.momentum) {
      if (h.velocities.length > 1) {
        const I = h.velocities.pop(), S = h.velocities.pop(), M = I.position - S.position, z = I.time - S.time;
        e.velocity = M / z, e.velocity /= 2, Math.abs(e.velocity) < l.freeMode.minimumVelocity && (e.velocity = 0), (z > 150 || Z() - I.time > 300) && (e.velocity = 0);
      } else
        e.velocity = 0;
      e.velocity *= l.freeMode.momentumVelocityRatio, h.velocities.length = 0;
      let b = 1e3 * l.freeMode.momentumRatio;
      const w = e.velocity * b;
      let u = e.translate + w;
      d && (u = -u);
      let y = !1, x;
      const A = Math.abs(e.velocity) * 20 * l.freeMode.momentumBounceRatio;
      let O;
      if (u < e.maxTranslate())
        l.freeMode.momentumBounce ? (u + e.maxTranslate() < -A && (u = e.maxTranslate() - A), x = e.maxTranslate(), y = !0, h.allowMomentumBounce = !0) : u = e.maxTranslate(), l.loop && l.centeredSlides && (O = !0);
      else if (u > e.minTranslate())
        l.freeMode.momentumBounce ? (u - e.minTranslate() > A && (u = e.minTranslate() + A), x = e.minTranslate(), y = !0, h.allowMomentumBounce = !0) : u = e.minTranslate(), l.loop && l.centeredSlides && (O = !0);
      else if (l.freeMode.sticky) {
        let I;
        for (let S = 0; S < m.length; S += 1)
          if (m[S] > -u) {
            I = S;
            break;
          }
        Math.abs(m[I] - u) < Math.abs(m[I - 1] - u) || e.swipeDirection === "next" ? u = m[I] : u = m[I - 1], u = -u;
      }
      if (O && r("transitionEnd", () => {
        e.loopFix();
      }), e.velocity !== 0) {
        if (d ? b = Math.abs((-u - e.translate) / e.velocity) : b = Math.abs((u - e.translate) / e.velocity), l.freeMode.sticky) {
          const I = Math.abs((d ? -u : u) - e.translate), S = e.slidesSizesGrid[e.activeIndex];
          I < S ? b = l.speed : I < 2 * S ? b = l.speed * 1.5 : b = l.speed * 2.5;
        }
      } else if (l.freeMode.sticky) {
        e.slideToClosest();
        return;
      }
      l.freeMode.momentumBounce && y ? (e.updateProgress(x), e.setTransition(b), e.setTranslate(u), e.transitionStart(!0, e.swipeDirection), e.animating = !0, me(o, () => {
        !e || e.destroyed || !h.allowMomentumBounce || (s("momentumBounce"), e.setTransition(l.speed), setTimeout(() => {
          e.setTranslate(x), me(o, () => {
            !e || e.destroyed || e.transitionEnd();
          });
        }, 0));
      })) : e.velocity ? (s("_freeModeNoMomentumRelease"), e.updateProgress(u), e.setTransition(b), e.setTranslate(u), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, me(o, () => {
        !e || e.destroyed || e.transitionEnd();
      }))) : e.updateProgress(u), e.updateActiveIndex(), e.updateSlidesClasses();
    } else if (l.freeMode.sticky) {
      e.slideToClosest();
      return;
    } else l.freeMode && s("_freeModeNoMomentumRelease");
    (!l.freeMode.momentum || v >= l.longSwipesMs) && (s("_freeModeStaticRelease"), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses());
  }
  Object.assign(e, {
    freeMode: {
      onTouchStart: a,
      onTouchMove: p,
      onTouchEnd: c
    }
  });
}
function Wi(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    grid: {
      rows: 1,
      fill: "column"
    }
  });
  let r, a, p, c;
  const n = () => {
    let g = e.params.spaceBetween;
    return typeof g == "string" && g.indexOf("%") >= 0 ? g = parseFloat(g.replace("%", "")) / 100 * e.size : typeof g == "string" && (g = parseFloat(g)), g;
  }, f = (g) => {
    const {
      slidesPerView: v
    } = e.params, {
      rows: b,
      fill: w
    } = e.params.grid, u = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : g.length;
    p = Math.floor(u / b), Math.floor(u / b) === u / b ? r = u : r = Math.ceil(u / b) * b, v !== "auto" && w === "row" && (r = Math.max(r, v * b)), a = r / b;
  }, l = () => {
    e.slides && e.slides.forEach((g) => {
      g.swiperSlideGridSet && (g.style.height = "", g.style[e.getDirectionLabel("margin-top")] = "");
    });
  }, o = (g, v, b) => {
    const {
      slidesPerGroup: w
    } = e.params, u = n(), {
      rows: y,
      fill: x
    } = e.params.grid, A = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : b.length;
    let O, I, S;
    if (x === "row" && w > 1) {
      const M = Math.floor(g / (w * y)), z = g - y * w * M, P = M === 0 ? w : Math.min(Math.ceil((A - M * y * w) / y), w);
      S = Math.floor(z / P), I = z - S * P + M * w, O = I + S * r / y, v.style.order = O;
    } else x === "column" ? (I = Math.floor(g / y), S = g - I * y, (I > p || I === p && S === y - 1) && (S += 1, S >= y && (S = 0, I += 1))) : (S = Math.floor(g / a), I = g - S * a);
    v.row = S, v.column = I, v.style.height = `calc((100% - ${(y - 1) * u}px) / ${y})`, v.style[e.getDirectionLabel("margin-top")] = S !== 0 ? u && `${u}px` : "", v.swiperSlideGridSet = !0;
  }, d = (g, v) => {
    const {
      centeredSlides: b,
      roundLengths: w
    } = e.params, u = n(), {
      rows: y
    } = e.params.grid;
    if (e.virtualSize = (g + u) * r, e.virtualSize = Math.ceil(e.virtualSize / y) - u, e.params.cssMode || (e.wrapperEl.style[e.getDirectionLabel("width")] = `${e.virtualSize + u}px`), b) {
      const x = [];
      for (let A = 0; A < v.length; A += 1) {
        let O = v[A];
        w && (O = Math.floor(O)), v[A] < e.virtualSize + v[0] && x.push(O);
      }
      v.splice(0, v.length), v.push(...x);
    }
  }, m = () => {
    c = e.params.grid && e.params.grid.rows > 1;
  }, h = () => {
    const {
      params: g,
      el: v
    } = e, b = g.grid && g.grid.rows > 1;
    c && !b ? (v.classList.remove(`${g.containerModifierClass}grid`, `${g.containerModifierClass}grid-column`), p = 1, e.emitContainerClasses()) : !c && b && (v.classList.add(`${g.containerModifierClass}grid`), g.grid.fill === "column" && v.classList.add(`${g.containerModifierClass}grid-column`), e.emitContainerClasses()), c = b;
  };
  s("init", m), s("update", h), e.grid = {
    initSlides: f,
    unsetSlides: l,
    updateSlide: o,
    updateWrapperSize: d
  };
}
function qi(i) {
  const e = this, {
    params: t,
    slidesEl: s
  } = e;
  t.loop && e.loopDestroy();
  const r = (a) => {
    if (typeof a == "string") {
      const p = document.createElement("div");
      p.innerHTML = a, s.append(p.children[0]), p.innerHTML = "";
    } else
      s.append(a);
  };
  if (typeof i == "object" && "length" in i)
    for (let a = 0; a < i.length; a += 1)
      i[a] && r(i[a]);
  else
    r(i);
  e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update();
}
function ji(i) {
  const e = this, {
    params: t,
    activeIndex: s,
    slidesEl: r
  } = e;
  t.loop && e.loopDestroy();
  let a = s + 1;
  const p = (c) => {
    if (typeof c == "string") {
      const n = document.createElement("div");
      n.innerHTML = c, r.prepend(n.children[0]), n.innerHTML = "";
    } else
      r.prepend(c);
  };
  if (typeof i == "object" && "length" in i) {
    for (let c = 0; c < i.length; c += 1)
      i[c] && p(i[c]);
    a = s + i.length;
  } else
    p(i);
  e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update(), e.slideTo(a, 0, !1);
}
function Ui(i, e) {
  const t = this, {
    params: s,
    activeIndex: r,
    slidesEl: a
  } = t;
  let p = r;
  s.loop && (p -= t.loopedSlides, t.loopDestroy(), t.recalcSlides());
  const c = t.slides.length;
  if (i <= 0) {
    t.prependSlide(e);
    return;
  }
  if (i >= c) {
    t.appendSlide(e);
    return;
  }
  let n = p > i ? p + 1 : p;
  const f = [];
  for (let l = c - 1; l >= i; l -= 1) {
    const o = t.slides[l];
    o.remove(), f.unshift(o);
  }
  if (typeof e == "object" && "length" in e) {
    for (let l = 0; l < e.length; l += 1)
      e[l] && a.append(e[l]);
    n = p > i ? p + e.length : p;
  } else
    a.append(e);
  for (let l = 0; l < f.length; l += 1)
    a.append(f[l]);
  t.recalcSlides(), s.loop && t.loopCreate(), (!s.observer || t.isElement) && t.update(), s.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
}
function Ki(i) {
  const e = this, {
    params: t,
    activeIndex: s
  } = e;
  let r = s;
  t.loop && (r -= e.loopedSlides, e.loopDestroy());
  let a = r, p;
  if (typeof i == "object" && "length" in i) {
    for (let c = 0; c < i.length; c += 1)
      p = i[c], e.slides[p] && e.slides[p].remove(), p < a && (a -= 1);
    a = Math.max(a, 0);
  } else
    p = i, e.slides[p] && e.slides[p].remove(), p < a && (a -= 1), a = Math.max(a, 0);
  e.recalcSlides(), t.loop && e.loopCreate(), (!t.observer || e.isElement) && e.update(), t.loop ? e.slideTo(a + e.loopedSlides, 0, !1) : e.slideTo(a, 0, !1);
}
function Zi() {
  const i = this, e = [];
  for (let t = 0; t < i.slides.length; t += 1)
    e.push(t);
  i.removeSlide(e);
}
function Qi(i) {
  let {
    swiper: e
  } = i;
  Object.assign(e, {
    appendSlide: qi.bind(e),
    prependSlide: ji.bind(e),
    addSlide: Ui.bind(e),
    removeSlide: Ki.bind(e),
    removeAllSlides: Zi.bind(e)
  });
}
function de(i) {
  const {
    effect: e,
    swiper: t,
    on: s,
    setTranslate: r,
    setTransition: a,
    overwriteParams: p,
    perspective: c,
    recreateShadows: n,
    getEffectParams: f
  } = i;
  s("beforeInit", () => {
    if (t.params.effect !== e) return;
    t.classNames.push(`${t.params.containerModifierClass}${e}`), c && c() && t.classNames.push(`${t.params.containerModifierClass}3d`);
    const o = p ? p() : {};
    Object.assign(t.params, o), Object.assign(t.originalParams, o);
  }), s("setTranslate", () => {
    t.params.effect === e && r();
  }), s("setTransition", (o, d) => {
    t.params.effect === e && a(d);
  }), s("transitionEnd", () => {
    if (t.params.effect === e && n) {
      if (!f || !f().slideShadows) return;
      t.slides.forEach((o) => {
        o.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((d) => d.remove());
      }), n();
    }
  });
  let l;
  s("virtualUpdate", () => {
    t.params.effect === e && (t.slides.length || (l = !0), requestAnimationFrame(() => {
      l && t.slides && t.slides.length && (r(), l = !1);
    }));
  });
}
function ge(i, e) {
  const t = ae(e);
  return t !== e && (t.style.backfaceVisibility = "hidden", t.style["-webkit-backface-visibility"] = "hidden"), t;
}
function Me(i) {
  let {
    swiper: e,
    duration: t,
    transformElements: s,
    allSlides: r
  } = i;
  const {
    activeIndex: a
  } = e, p = (c) => c.parentElement ? c.parentElement : e.slides.filter((f) => f.shadowRoot && f.shadowRoot === c.parentNode)[0];
  if (e.params.virtualTranslate && t !== 0) {
    let c = !1, n;
    r ? n = s : n = s.filter((f) => {
      const l = f.classList.contains("swiper-slide-transform") ? p(f) : f;
      return e.getSlideIndex(l) === a;
    }), n.forEach((f) => {
      me(f, () => {
        if (c || !e || e.destroyed) return;
        c = !0, e.animating = !1;
        const l = new window.CustomEvent("transitionend", {
          bubbles: !0,
          cancelable: !0
        });
        e.wrapperEl.dispatchEvent(l);
      });
    });
  }
}
function Ji(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    fadeEffect: {
      crossFade: !1
    }
  }), de({
    effect: "fade",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        slides: p
      } = e, c = e.params.fadeEffect;
      for (let n = 0; n < p.length; n += 1) {
        const f = e.slides[n];
        let o = -f.swiperSlideOffset;
        e.params.virtualTranslate || (o -= e.translate);
        let d = 0;
        e.isHorizontal() || (d = o, o = 0);
        const m = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(f.progress), 0) : 1 + Math.min(Math.max(f.progress, -1), 0), h = ge(c, f);
        h.style.opacity = m, h.style.transform = `translate3d(${o}px, ${d}px, 0px)`;
      }
    },
    setTransition: (p) => {
      const c = e.slides.map((n) => ae(n));
      c.forEach((n) => {
        n.style.transitionDuration = `${p}ms`;
      }), Me({
        swiper: e,
        duration: p,
        transformElements: c,
        allSlides: !0
      });
    },
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function es(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    cubeEffect: {
      slideShadows: !0,
      shadow: !0,
      shadowOffset: 20,
      shadowScale: 0.94
    }
  });
  const r = (n, f, l) => {
    let o = l ? n.querySelector(".swiper-slide-shadow-left") : n.querySelector(".swiper-slide-shadow-top"), d = l ? n.querySelector(".swiper-slide-shadow-right") : n.querySelector(".swiper-slide-shadow-bottom");
    o || (o = K("div", `swiper-slide-shadow-cube swiper-slide-shadow-${l ? "left" : "top"}`.split(" ")), n.append(o)), d || (d = K("div", `swiper-slide-shadow-cube swiper-slide-shadow-${l ? "right" : "bottom"}`.split(" ")), n.append(d)), o && (o.style.opacity = Math.max(-f, 0)), d && (d.style.opacity = Math.max(f, 0));
  };
  de({
    effect: "cube",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        el: n,
        wrapperEl: f,
        slides: l,
        width: o,
        height: d,
        rtlTranslate: m,
        size: h,
        browser: g
      } = e, v = Te(e), b = e.params.cubeEffect, w = e.isHorizontal(), u = e.virtual && e.params.virtual.enabled;
      let y = 0, x;
      b.shadow && (w ? (x = e.wrapperEl.querySelector(".swiper-cube-shadow"), x || (x = K("div", "swiper-cube-shadow"), e.wrapperEl.append(x)), x.style.height = `${o}px`) : (x = n.querySelector(".swiper-cube-shadow"), x || (x = K("div", "swiper-cube-shadow"), n.append(x))));
      for (let O = 0; O < l.length; O += 1) {
        const I = l[O];
        let S = O;
        u && (S = parseInt(I.getAttribute("data-swiper-slide-index"), 10));
        let M = S * 90, z = Math.floor(M / 360);
        m && (M = -M, z = Math.floor(-M / 360));
        const P = Math.max(Math.min(I.progress, 1), -1);
        let E = 0, T = 0, $ = 0;
        S % 4 === 0 ? (E = -z * 4 * h, $ = 0) : (S - 1) % 4 === 0 ? (E = 0, $ = -z * 4 * h) : (S - 2) % 4 === 0 ? (E = h + z * 4 * h, $ = h) : (S - 3) % 4 === 0 && (E = -h, $ = 3 * h + h * 4 * z), m && (E = -E), w || (T = E, E = 0);
        const H = `rotateX(${v(w ? 0 : -M)}deg) rotateY(${v(w ? M : 0)}deg) translate3d(${E}px, ${T}px, ${$}px)`;
        P <= 1 && P > -1 && (y = S * 90 + P * 90, m && (y = -S * 90 - P * 90)), I.style.transform = H, b.slideShadows && r(I, P, w);
      }
      if (f.style.transformOrigin = `50% 50% -${h / 2}px`, f.style["-webkit-transform-origin"] = `50% 50% -${h / 2}px`, b.shadow)
        if (w)
          x.style.transform = `translate3d(0px, ${o / 2 + b.shadowOffset}px, ${-o / 2}px) rotateX(89.99deg) rotateZ(0deg) scale(${b.shadowScale})`;
        else {
          const O = Math.abs(y) - Math.floor(Math.abs(y) / 90) * 90, I = 1.5 - (Math.sin(O * 2 * Math.PI / 360) / 2 + Math.cos(O * 2 * Math.PI / 360) / 2), S = b.shadowScale, M = b.shadowScale / I, z = b.shadowOffset;
          x.style.transform = `scale3d(${S}, 1, ${M}) translate3d(0px, ${d / 2 + z}px, ${-d / 2 / M}px) rotateX(-89.99deg)`;
        }
      const A = (g.isSafari || g.isWebView) && g.needPerspectiveFix ? -h / 2 : 0;
      f.style.transform = `translate3d(0px,0,${A}px) rotateX(${v(e.isHorizontal() ? 0 : y)}deg) rotateY(${v(e.isHorizontal() ? -y : 0)}deg)`, f.style.setProperty("--swiper-cube-translate-z", `${A}px`);
    },
    setTransition: (n) => {
      const {
        el: f,
        slides: l
      } = e;
      if (l.forEach((o) => {
        o.style.transitionDuration = `${n}ms`, o.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((d) => {
          d.style.transitionDuration = `${n}ms`;
        });
      }), e.params.cubeEffect.shadow && !e.isHorizontal()) {
        const o = f.querySelector(".swiper-cube-shadow");
        o && (o.style.transitionDuration = `${n}ms`);
      }
    },
    recreateShadows: () => {
      const n = e.isHorizontal();
      e.slides.forEach((f) => {
        const l = Math.max(Math.min(f.progress, 1), -1);
        r(f, l, n);
      });
    },
    getEffectParams: () => e.params.cubeEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      resistanceRatio: 0,
      spaceBetween: 0,
      centeredSlides: !1,
      virtualTranslate: !0
    })
  });
}
function le(i, e, t) {
  const s = `swiper-slide-shadow${t ? `-${t}` : ""}${i ? ` swiper-slide-shadow-${i}` : ""}`, r = ae(e);
  let a = r.querySelector(`.${s.split(" ").join(".")}`);
  return a || (a = K("div", s.split(" ")), r.append(a)), a;
}
function ts(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    flipEffect: {
      slideShadows: !0,
      limitRotation: !0
    }
  });
  const r = (n, f) => {
    let l = e.isHorizontal() ? n.querySelector(".swiper-slide-shadow-left") : n.querySelector(".swiper-slide-shadow-top"), o = e.isHorizontal() ? n.querySelector(".swiper-slide-shadow-right") : n.querySelector(".swiper-slide-shadow-bottom");
    l || (l = le("flip", n, e.isHorizontal() ? "left" : "top")), o || (o = le("flip", n, e.isHorizontal() ? "right" : "bottom")), l && (l.style.opacity = Math.max(-f, 0)), o && (o.style.opacity = Math.max(f, 0));
  };
  de({
    effect: "flip",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        slides: n,
        rtlTranslate: f
      } = e, l = e.params.flipEffect, o = Te(e);
      for (let d = 0; d < n.length; d += 1) {
        const m = n[d];
        let h = m.progress;
        e.params.flipEffect.limitRotation && (h = Math.max(Math.min(m.progress, 1), -1));
        const g = m.swiperSlideOffset;
        let b = -180 * h, w = 0, u = e.params.cssMode ? -g - e.translate : -g, y = 0;
        e.isHorizontal() ? f && (b = -b) : (y = u, u = 0, w = -b, b = 0), m.style.zIndex = -Math.abs(Math.round(h)) + n.length, l.slideShadows && r(m, h);
        const x = `translate3d(${u}px, ${y}px, 0px) rotateX(${o(w)}deg) rotateY(${o(b)}deg)`, A = ge(l, m);
        A.style.transform = x;
      }
    },
    setTransition: (n) => {
      const f = e.slides.map((l) => ae(l));
      f.forEach((l) => {
        l.style.transitionDuration = `${n}ms`, l.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((o) => {
          o.style.transitionDuration = `${n}ms`;
        });
      }), Me({
        swiper: e,
        duration: n,
        transformElements: f
      });
    },
    recreateShadows: () => {
      e.params.flipEffect, e.slides.forEach((n) => {
        let f = n.progress;
        e.params.flipEffect.limitRotation && (f = Math.max(Math.min(n.progress, 1), -1)), r(n, f);
      });
    },
    getEffectParams: () => e.params.flipEffect,
    perspective: () => !0,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: !0,
      spaceBetween: 0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function is(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      scale: 1,
      modifier: 1,
      slideShadows: !0
    }
  }), de({
    effect: "coverflow",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        width: p,
        height: c,
        slides: n,
        slidesSizesGrid: f
      } = e, l = e.params.coverflowEffect, o = e.isHorizontal(), d = e.translate, m = o ? -d + p / 2 : -d + c / 2, h = o ? l.rotate : -l.rotate, g = l.depth, v = Te(e);
      for (let b = 0, w = n.length; b < w; b += 1) {
        const u = n[b], y = f[b], x = u.swiperSlideOffset, A = (m - x - y / 2) / y, O = typeof l.modifier == "function" ? l.modifier(A) : A * l.modifier;
        let I = o ? h * O : 0, S = o ? 0 : h * O, M = -g * Math.abs(O), z = l.stretch;
        typeof z == "string" && z.indexOf("%") !== -1 && (z = parseFloat(l.stretch) / 100 * y);
        let P = o ? 0 : z * O, E = o ? z * O : 0, T = 1 - (1 - l.scale) * Math.abs(O);
        Math.abs(E) < 1e-3 && (E = 0), Math.abs(P) < 1e-3 && (P = 0), Math.abs(M) < 1e-3 && (M = 0), Math.abs(I) < 1e-3 && (I = 0), Math.abs(S) < 1e-3 && (S = 0), Math.abs(T) < 1e-3 && (T = 0);
        const $ = `translate3d(${E}px,${P}px,${M}px)  rotateX(${v(S)}deg) rotateY(${v(I)}deg) scale(${T})`, H = ge(l, u);
        if (H.style.transform = $, u.style.zIndex = -Math.abs(Math.round(O)) + 1, l.slideShadows) {
          let C = o ? u.querySelector(".swiper-slide-shadow-left") : u.querySelector(".swiper-slide-shadow-top"), L = o ? u.querySelector(".swiper-slide-shadow-right") : u.querySelector(".swiper-slide-shadow-bottom");
          C || (C = le("coverflow", u, o ? "left" : "top")), L || (L = le("coverflow", u, o ? "right" : "bottom")), C && (C.style.opacity = O > 0 ? O : 0), L && (L.style.opacity = -O > 0 ? -O : 0);
        }
      }
    },
    setTransition: (p) => {
      e.slides.map((n) => ae(n)).forEach((n) => {
        n.style.transitionDuration = `${p}ms`, n.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((f) => {
          f.style.transitionDuration = `${p}ms`;
        });
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0
    })
  });
}
function ss(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    creativeEffect: {
      limitProgress: 1,
      shadowPerProgress: !1,
      progressMultiplier: 1,
      perspective: !0,
      prev: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      },
      next: {
        translate: [0, 0, 0],
        rotate: [0, 0, 0],
        opacity: 1,
        scale: 1
      }
    }
  });
  const r = (c) => typeof c == "string" ? c : `${c}px`;
  de({
    effect: "creative",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        slides: c,
        wrapperEl: n,
        slidesSizesGrid: f
      } = e, l = e.params.creativeEffect, {
        progressMultiplier: o
      } = l, d = e.params.centeredSlides, m = Te(e);
      if (d) {
        const h = f[0] / 2 - e.params.slidesOffsetBefore || 0;
        n.style.transform = `translateX(calc(50% - ${h}px))`;
      }
      for (let h = 0; h < c.length; h += 1) {
        const g = c[h], v = g.progress, b = Math.min(Math.max(g.progress, -l.limitProgress), l.limitProgress);
        let w = b;
        d || (w = Math.min(Math.max(g.originalProgress, -l.limitProgress), l.limitProgress));
        const u = g.swiperSlideOffset, y = [e.params.cssMode ? -u - e.translate : -u, 0, 0], x = [0, 0, 0];
        let A = !1;
        e.isHorizontal() || (y[1] = y[0], y[0] = 0);
        let O = {
          translate: [0, 0, 0],
          rotate: [0, 0, 0],
          scale: 1,
          opacity: 1
        };
        b < 0 ? (O = l.next, A = !0) : b > 0 && (O = l.prev, A = !0), y.forEach((T, $) => {
          y[$] = `calc(${T}px + (${r(O.translate[$])} * ${Math.abs(b * o)}))`;
        }), x.forEach((T, $) => {
          let H = O.rotate[$] * Math.abs(b * o);
          x[$] = H;
        }), g.style.zIndex = -Math.abs(Math.round(v)) + c.length;
        const I = y.join(", "), S = `rotateX(${m(x[0])}deg) rotateY(${m(x[1])}deg) rotateZ(${m(x[2])}deg)`, M = w < 0 ? `scale(${1 + (1 - O.scale) * w * o})` : `scale(${1 - (1 - O.scale) * w * o})`, z = w < 0 ? 1 + (1 - O.opacity) * w * o : 1 - (1 - O.opacity) * w * o, P = `translate3d(${I}) ${S} ${M}`;
        if (A && O.shadow || !A) {
          let T = g.querySelector(".swiper-slide-shadow");
          if (!T && O.shadow && (T = le("creative", g)), T) {
            const $ = l.shadowPerProgress ? b * (1 / l.limitProgress) : b;
            T.style.opacity = Math.min(Math.max(Math.abs($), 0), 1);
          }
        }
        const E = ge(l, g);
        E.style.transform = P, E.style.opacity = z, O.origin && (E.style.transformOrigin = O.origin);
      }
    },
    setTransition: (c) => {
      const n = e.slides.map((f) => ae(f));
      n.forEach((f) => {
        f.style.transitionDuration = `${c}ms`, f.querySelectorAll(".swiper-slide-shadow").forEach((l) => {
          l.style.transitionDuration = `${c}ms`;
        });
      }), Me({
        swiper: e,
        duration: c,
        transformElements: n,
        allSlides: !0
      });
    },
    perspective: () => e.params.creativeEffect.perspective,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
function rs(i) {
  let {
    swiper: e,
    extendParams: t,
    on: s
  } = i;
  t({
    cardsEffect: {
      slideShadows: !0,
      rotate: !0,
      perSlideRotate: 2,
      perSlideOffset: 8
    }
  }), de({
    effect: "cards",
    swiper: e,
    on: s,
    setTranslate: () => {
      const {
        slides: p,
        activeIndex: c,
        rtlTranslate: n
      } = e, f = e.params.cardsEffect, {
        startTranslate: l,
        isTouched: o
      } = e.touchEventsData, d = n ? -e.translate : e.translate;
      for (let m = 0; m < p.length; m += 1) {
        const h = p[m], g = h.progress, v = Math.min(Math.max(g, -4), 4);
        let b = h.swiperSlideOffset;
        e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (b -= p[0].swiperSlideOffset);
        let w = e.params.cssMode ? -b - e.translate : -b, u = 0;
        const y = -100 * Math.abs(v);
        let x = 1, A = -f.perSlideRotate * v, O = f.perSlideOffset - Math.abs(v) * 0.75;
        const I = e.virtual && e.params.virtual.enabled ? e.virtual.from + m : m, S = (I === c || I === c - 1) && v > 0 && v < 1 && (o || e.params.cssMode) && d < l, M = (I === c || I === c + 1) && v < 0 && v > -1 && (o || e.params.cssMode) && d > l;
        if (S || M) {
          const T = (1 - Math.abs((Math.abs(v) - 0.5) / 0.5)) ** 0.5;
          A += -28 * v * T, x += -0.5 * T, O += 96 * T, u = `${-25 * T * Math.abs(v)}%`;
        }
        if (v < 0 ? w = `calc(${w}px ${n ? "-" : "+"} (${O * Math.abs(v)}%))` : v > 0 ? w = `calc(${w}px ${n ? "-" : "+"} (-${O * Math.abs(v)}%))` : w = `${w}px`, !e.isHorizontal()) {
          const T = u;
          u = w, w = T;
        }
        const z = v < 0 ? `${1 + (1 - x) * v}` : `${1 - (1 - x) * v}`, P = `
        translate3d(${w}, ${u}, ${y}px)
        rotateZ(${f.rotate ? n ? -A : A : 0}deg)
        scale(${z})
      `;
        if (f.slideShadows) {
          let T = h.querySelector(".swiper-slide-shadow");
          T || (T = le("cards", h)), T && (T.style.opacity = Math.min(Math.max((Math.abs(v) - 0.5) / 0.5, 0), 1));
        }
        h.style.zIndex = -Math.abs(Math.round(g)) + p.length;
        const E = ge(f, h);
        E.style.transform = P;
      }
    },
    setTransition: (p) => {
      const c = e.slides.map((n) => ae(n));
      c.forEach((n) => {
        n.style.transitionDuration = `${p}ms`, n.querySelectorAll(".swiper-slide-shadow").forEach((f) => {
          f.style.transitionDuration = `${p}ms`;
        });
      }), Me({
        swiper: e,
        duration: p,
        transformElements: c
      });
    },
    perspective: () => !0,
    overwriteParams: () => ({
      watchSlidesProgress: !0,
      virtualTranslate: !e.params.cssMode
    })
  });
}
const as = [Ai, $i, Oi, Di, ki, Gi, Hi, Bi, _i, Ri, Xi, Vi, Yi, Fi, Ni, Wi, Qi, Ji, es, ts, is, ss, rs];
j.use(as);
const Ce = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function oe(i) {
  return typeof i == "object" && i !== null && i.constructor && Object.prototype.toString.call(i).slice(8, -1) === "Object" && !i.__swiper__;
}
function Ve(i, e) {
  const t = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((s) => t.indexOf(s) < 0).forEach((s) => {
    typeof i[s] > "u" ? i[s] = e[s] : oe(e[s]) && oe(i[s]) && Object.keys(e[s]).length > 0 ? e[s].__swiper__ ? i[s] = e[s] : Ve(i[s], e[s]) : i[s] = e[s];
  });
}
function ns(i) {
  return i === void 0 && (i = {}), i.navigation && typeof i.navigation.nextEl > "u" && typeof i.navigation.prevEl > "u";
}
function ls(i) {
  return i === void 0 && (i = {}), i.pagination && typeof i.pagination.el > "u";
}
function os(i) {
  return i === void 0 && (i = {}), i.scrollbar && typeof i.scrollbar.el > "u";
}
function Se(i) {
  return i === void 0 && (i = ""), i.replace(/-[a-z]/g, (e) => e.toUpperCase().replace("-", ""));
}
function ds(i) {
  let {
    swiper: e,
    slides: t,
    passedParams: s,
    changedParams: r,
    nextEl: a,
    prevEl: p,
    scrollbarEl: c,
    paginationEl: n
  } = i;
  const f = r.filter((S) => S !== "children" && S !== "direction" && S !== "wrapperClass"), {
    params: l,
    pagination: o,
    navigation: d,
    scrollbar: m,
    virtual: h,
    thumbs: g
  } = e;
  let v, b, w, u, y, x, A, O;
  r.includes("thumbs") && s.thumbs && s.thumbs.swiper && !s.thumbs.swiper.destroyed && l.thumbs && (!l.thumbs.swiper || l.thumbs.swiper.destroyed) && (v = !0), r.includes("controller") && s.controller && s.controller.control && l.controller && !l.controller.control && (b = !0), r.includes("pagination") && s.pagination && (s.pagination.el || n) && (l.pagination || l.pagination === !1) && o && !o.el && (w = !0), r.includes("scrollbar") && s.scrollbar && (s.scrollbar.el || c) && (l.scrollbar || l.scrollbar === !1) && m && !m.el && (u = !0), r.includes("navigation") && s.navigation && (s.navigation.prevEl || p) && (s.navigation.nextEl || a) && (l.navigation || l.navigation === !1) && d && !d.prevEl && !d.nextEl && (y = !0);
  const I = (S) => {
    e[S] && (e[S].destroy(), S === "navigation" ? (e.isElement && (e[S].prevEl.remove(), e[S].nextEl.remove()), l[S].prevEl = void 0, l[S].nextEl = void 0, e[S].prevEl = void 0, e[S].nextEl = void 0) : (e.isElement && e[S].el.remove(), l[S].el = void 0, e[S].el = void 0));
  };
  r.includes("loop") && e.isElement && (l.loop && !s.loop ? x = !0 : !l.loop && s.loop ? A = !0 : O = !0), f.forEach((S) => {
    if (oe(l[S]) && oe(s[S]))
      Object.assign(l[S], s[S]), (S === "navigation" || S === "pagination" || S === "scrollbar") && "enabled" in s[S] && !s[S].enabled && I(S);
    else {
      const M = s[S];
      (M === !0 || M === !1) && (S === "navigation" || S === "pagination" || S === "scrollbar") ? M === !1 && I(S) : l[S] = s[S];
    }
  }), f.includes("controller") && !b && e.controller && e.controller.control && l.controller && l.controller.control && (e.controller.control = l.controller.control), r.includes("children") && t && h && l.virtual.enabled ? (h.slides = t, h.update(!0)) : r.includes("virtual") && h && l.virtual.enabled && (t && (h.slides = t), h.update(!0)), r.includes("children") && t && l.loop && (O = !0), v && g.init() && g.update(!0), b && (e.controller.control = l.controller.control), w && (e.isElement && (!n || typeof n == "string") && (n = document.createElement("div"), n.classList.add("swiper-pagination"), n.part.add("pagination"), e.el.appendChild(n)), n && (l.pagination.el = n), o.init(), o.render(), o.update()), u && (e.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-scrollbar"), c.part.add("scrollbar"), e.el.appendChild(c)), c && (l.scrollbar.el = c), m.init(), m.updateSize(), m.setTranslate()), y && (e.isElement && ((!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-button-next"), a.innerHTML = e.hostEl.constructor.nextButtonSvg, a.part.add("button-next"), e.el.appendChild(a)), (!p || typeof p == "string") && (p = document.createElement("div"), p.classList.add("swiper-button-prev"), p.innerHTML = e.hostEl.constructor.prevButtonSvg, p.part.add("button-prev"), e.el.appendChild(p))), a && (l.navigation.nextEl = a), p && (l.navigation.prevEl = p), d.init(), d.update()), r.includes("allowSlideNext") && (e.allowSlideNext = s.allowSlideNext), r.includes("allowSlidePrev") && (e.allowSlidePrev = s.allowSlidePrev), r.includes("direction") && e.changeDirection(s.direction, !1), (x || O) && e.loopDestroy(), (A || O) && e.loopCreate(), e.update();
}
const tt = (i) => {
  if (parseFloat(i) === Number(i)) return Number(i);
  if (i === "true" || i === "") return !0;
  if (i === "false") return !1;
  if (i === "null") return null;
  if (i !== "undefined") {
    if (typeof i == "string" && i.includes("{") && i.includes("}") && i.includes('"')) {
      let e;
      try {
        e = JSON.parse(i);
      } catch {
        e = i;
      }
      return e;
    }
    return i;
  }
}, it = ["a11y", "autoplay", "controller", "cards-effect", "coverflow-effect", "creative-effect", "cube-effect", "fade-effect", "flip-effect", "free-mode", "grid", "hash-navigation", "history", "keyboard", "mousewheel", "navigation", "pagination", "parallax", "scrollbar", "thumbs", "virtual", "zoom"];
function st(i, e, t) {
  const s = {}, r = {};
  Ve(s, Xe);
  const a = [...Ce, "on"], p = a.map((n) => n.replace(/_/, ""));
  a.forEach((n) => {
    n = n.replace("_", ""), typeof i[n] < "u" && (r[n] = i[n]);
  });
  const c = [...i.attributes];
  return typeof e == "string" && typeof t < "u" && c.push({
    name: e,
    value: oe(t) ? {
      ...t
    } : t
  }), c.forEach((n) => {
    const f = it.filter((l) => n.name.indexOf(`${l}-`) === 0)[0];
    if (f) {
      const l = Se(f), o = Se(n.name.split(`${f}-`)[1]);
      typeof r[l] > "u" && (r[l] = {}), r[l] === !0 && (r[l] = {
        enabled: !0
      }), r[l][o] = tt(n.value);
    } else {
      const l = Se(n.name);
      if (!p.includes(l)) return;
      const o = tt(n.value);
      r[l] && it.includes(n.name) && !oe(o) ? (r[l].constructor !== Object && (r[l] = {}), r[l].enabled = !!o) : r[l] = o;
    }
  }), Ve(s, r), s.navigation ? s.navigation = {
    prevEl: ".swiper-button-prev",
    nextEl: ".swiper-button-next",
    ...s.navigation !== !0 ? s.navigation : {}
  } : s.navigation === !1 && delete s.navigation, s.scrollbar ? s.scrollbar = {
    el: ".swiper-scrollbar",
    ...s.scrollbar !== !0 ? s.scrollbar : {}
  } : s.scrollbar === !1 && delete s.scrollbar, s.pagination ? s.pagination = {
    el: ".swiper-pagination",
    ...s.pagination !== !0 ? s.pagination : {}
  } : s.pagination === !1 && delete s.pagination, {
    params: s,
    passedParams: r
  };
}
const cs = ":host{--swiper-theme-color:#007aff}:host{position:relative;display:block;margin-left:auto;margin-right:auto;z-index:1}.swiper{width:100%;height:100%;margin-left:auto;margin-right:auto;position:relative;overflow:hidden;list-style:none;padding:0;z-index:1;display:block}.swiper-vertical>.swiper-wrapper{flex-direction:column}.swiper-wrapper{position:relative;width:100%;height:100%;z-index:1;display:flex;transition-property:transform;transition-timing-function:var(--swiper-wrapper-transition-timing-function,initial);box-sizing:content-box}.swiper-android ::slotted(swiper-slide),.swiper-ios ::slotted(swiper-slide),.swiper-wrapper{transform:translate3d(0px,0,0)}.swiper-horizontal{touch-action:pan-y}.swiper-vertical{touch-action:pan-x}::slotted(swiper-slide){flex-shrink:0;width:100%;height:100%;position:relative;transition-property:transform;display:block}::slotted(.swiper-slide-invisible-blank){visibility:hidden}.swiper-autoheight,.swiper-autoheight ::slotted(swiper-slide){height:auto}.swiper-autoheight .swiper-wrapper{align-items:flex-start;transition-property:transform,height}.swiper-backface-hidden ::slotted(swiper-slide){transform:translateZ(0);-webkit-backface-visibility:hidden;backface-visibility:hidden}.swiper-3d.swiper-css-mode .swiper-wrapper{perspective:1200px}.swiper-3d .swiper-wrapper{transform-style:preserve-3d}.swiper-3d{perspective:1200px}.swiper-3d .swiper-cube-shadow,.swiper-3d ::slotted(swiper-slide){transform-style:preserve-3d}.swiper-css-mode>.swiper-wrapper{overflow:auto;scrollbar-width:none;-ms-overflow-style:none}.swiper-css-mode>.swiper-wrapper::-webkit-scrollbar{display:none}.swiper-css-mode ::slotted(swiper-slide){scroll-snap-align:start start}.swiper-css-mode.swiper-horizontal>.swiper-wrapper{scroll-snap-type:x mandatory}.swiper-css-mode.swiper-vertical>.swiper-wrapper{scroll-snap-type:y mandatory}.swiper-css-mode.swiper-free-mode>.swiper-wrapper{scroll-snap-type:none}.swiper-css-mode.swiper-free-mode ::slotted(swiper-slide){scroll-snap-align:none}.swiper-css-mode.swiper-centered>.swiper-wrapper::before{content:'';flex-shrink:0;order:9999}.swiper-css-mode.swiper-centered ::slotted(swiper-slide){scroll-snap-align:center center;scroll-snap-stop:always}.swiper-css-mode.swiper-centered.swiper-horizontal ::slotted(swiper-slide):first-child{margin-inline-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-horizontal>.swiper-wrapper::before{height:100%;min-height:1px;width:var(--swiper-centered-offset-after)}.swiper-css-mode.swiper-centered.swiper-vertical ::slotted(swiper-slide):first-child{margin-block-start:var(--swiper-centered-offset-before)}.swiper-css-mode.swiper-centered.swiper-vertical>.swiper-wrapper::before{width:100%;min-width:1px;height:var(--swiper-centered-offset-after)}.swiper-virtual ::slotted(swiper-slide){-webkit-backface-visibility:hidden;transform:translateZ(0)}.swiper-virtual.swiper-css-mode .swiper-wrapper::after{content:'';position:absolute;left:0;top:0;pointer-events:none}.swiper-virtual.swiper-css-mode.swiper-horizontal .swiper-wrapper::after{height:1px;width:var(--swiper-virtual-size)}.swiper-virtual.swiper-css-mode.swiper-vertical .swiper-wrapper::after{width:1px;height:var(--swiper-virtual-size)}:host{--swiper-navigation-size:44px}.swiper-button-next,.swiper-button-prev{position:absolute;top:var(--swiper-navigation-top-offset,50%);width:calc(var(--swiper-navigation-size)/ 44 * 27);height:var(--swiper-navigation-size);margin-top:calc(0px - (var(--swiper-navigation-size)/ 2));z-index:10;cursor:pointer;display:flex;align-items:center;justify-content:center;color:var(--swiper-navigation-color,var(--swiper-theme-color))}.swiper-button-next.swiper-button-disabled,.swiper-button-prev.swiper-button-disabled{opacity:.35;cursor:auto;pointer-events:none}.swiper-button-next.swiper-button-hidden,.swiper-button-prev.swiper-button-hidden{opacity:0;cursor:auto;pointer-events:none}.swiper-navigation-disabled .swiper-button-next,.swiper-navigation-disabled .swiper-button-prev{display:none!important}.swiper-button-next svg,.swiper-button-prev svg{width:100%;height:100%;object-fit:contain;transform-origin:center}.swiper-rtl .swiper-button-next svg,.swiper-rtl .swiper-button-prev svg{transform:rotate(180deg)}.swiper-button-prev,.swiper-rtl .swiper-button-next{left:var(--swiper-navigation-sides-offset,10px);right:auto}.swiper-button-next,.swiper-rtl .swiper-button-prev{right:var(--swiper-navigation-sides-offset,10px);left:auto}.swiper-button-lock{display:none}.swiper-pagination{position:absolute;text-align:center;transition:.3s opacity;transform:translate3d(0,0,0);z-index:10}.swiper-pagination.swiper-pagination-hidden{opacity:0}.swiper-pagination-disabled>.swiper-pagination,.swiper-pagination.swiper-pagination-disabled{display:none!important}.swiper-horizontal>.swiper-pagination-bullets,.swiper-pagination-bullets.swiper-pagination-horizontal,.swiper-pagination-custom,.swiper-pagination-fraction{bottom:var(--swiper-pagination-bottom,8px);top:var(--swiper-pagination-top,auto);left:0;width:100%}.swiper-pagination-bullets-dynamic{overflow:hidden;font-size:0}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transform:scale(.33);position:relative}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-main{transform:scale(1)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-prev-prev{transform:scale(.33)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next{transform:scale(.66)}.swiper-pagination-bullets-dynamic .swiper-pagination-bullet-active-next-next{transform:scale(.33)}.swiper-pagination-bullet{width:var(--swiper-pagination-bullet-width,var(--swiper-pagination-bullet-size,8px));height:var(--swiper-pagination-bullet-height,var(--swiper-pagination-bullet-size,8px));display:inline-block;border-radius:var(--swiper-pagination-bullet-border-radius,50%);background:var(--swiper-pagination-bullet-inactive-color,#000);opacity:var(--swiper-pagination-bullet-inactive-opacity, .2)}button.swiper-pagination-bullet{border:none;margin:0;padding:0;box-shadow:none;-webkit-appearance:none;appearance:none}.swiper-pagination-clickable .swiper-pagination-bullet{cursor:pointer}.swiper-pagination-bullet:only-child{display:none!important}.swiper-pagination-bullet-active{opacity:var(--swiper-pagination-bullet-opacity, 1);background:var(--swiper-pagination-color,var(--swiper-theme-color))}.swiper-pagination-vertical.swiper-pagination-bullets,.swiper-vertical>.swiper-pagination-bullets{right:var(--swiper-pagination-right,8px);left:var(--swiper-pagination-left,auto);top:50%;transform:translate3d(0px,-50%,0)}.swiper-pagination-vertical.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets .swiper-pagination-bullet{margin:var(--swiper-pagination-bullet-vertical-gap,6px) 0;display:block}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{top:50%;transform:translateY(-50%);width:8px}.swiper-pagination-vertical.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-vertical>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{display:inline-block;transition:.2s transform,.2s top}.swiper-horizontal>.swiper-pagination-bullets .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet{margin:0 var(--swiper-pagination-bullet-horizontal-gap,4px)}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic{left:50%;transform:translateX(-50%);white-space:nowrap}.swiper-horizontal>.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet,.swiper-pagination-horizontal.swiper-pagination-bullets.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s left}.swiper-horizontal.swiper-rtl>.swiper-pagination-bullets-dynamic .swiper-pagination-bullet{transition:.2s transform,.2s right}.swiper-pagination-fraction{color:var(--swiper-pagination-fraction-color,inherit)}.swiper-pagination-progressbar{background:var(--swiper-pagination-progressbar-bg-color,rgba(0,0,0,.25));position:absolute}.swiper-pagination-progressbar .swiper-pagination-progressbar-fill{background:var(--swiper-pagination-color,var(--swiper-theme-color));position:absolute;left:0;top:0;width:100%;height:100%;transform:scale(0);transform-origin:left top}.swiper-rtl .swiper-pagination-progressbar .swiper-pagination-progressbar-fill{transform-origin:right top}.swiper-horizontal>.swiper-pagination-progressbar,.swiper-pagination-progressbar.swiper-pagination-horizontal,.swiper-pagination-progressbar.swiper-pagination-vertical.swiper-pagination-progressbar-opposite,.swiper-vertical>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite{width:100%;height:var(--swiper-pagination-progressbar-size,4px);left:0;top:0}.swiper-horizontal>.swiper-pagination-progressbar.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-horizontal.swiper-pagination-progressbar-opposite,.swiper-pagination-progressbar.swiper-pagination-vertical,.swiper-vertical>.swiper-pagination-progressbar{width:var(--swiper-pagination-progressbar-size,4px);height:100%;left:0;top:0}.swiper-pagination-lock{display:none}.swiper-scrollbar{border-radius:var(--swiper-scrollbar-border-radius,10px);position:relative;touch-action:none;background:var(--swiper-scrollbar-bg-color,rgba(0,0,0,.1))}.swiper-scrollbar-disabled>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-disabled{display:none!important}.swiper-horizontal>.swiper-scrollbar,.swiper-scrollbar.swiper-scrollbar-horizontal{position:absolute;left:var(--swiper-scrollbar-sides-offset,1%);bottom:var(--swiper-scrollbar-bottom,4px);top:var(--swiper-scrollbar-top,auto);z-index:50;height:var(--swiper-scrollbar-size,4px);width:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar.swiper-scrollbar-vertical,.swiper-vertical>.swiper-scrollbar{position:absolute;left:var(--swiper-scrollbar-left,auto);right:var(--swiper-scrollbar-right,4px);top:var(--swiper-scrollbar-sides-offset,1%);z-index:50;width:var(--swiper-scrollbar-size,4px);height:calc(100% - 2 * var(--swiper-scrollbar-sides-offset,1%))}.swiper-scrollbar-drag{height:100%;width:100%;position:relative;background:var(--swiper-scrollbar-drag-bg-color,rgba(0,0,0,.5));border-radius:var(--swiper-scrollbar-border-radius,10px);left:0;top:0}.swiper-scrollbar-cursor-drag{cursor:move}.swiper-scrollbar-lock{display:none}::slotted(.swiper-slide-zoomed){cursor:move;touch-action:none}.swiper .swiper-notification{position:absolute;left:0;top:0;pointer-events:none;opacity:0;z-index:-1000}.swiper-free-mode>.swiper-wrapper{transition-timing-function:ease-out;margin:0 auto}.swiper-grid>.swiper-wrapper{flex-wrap:wrap}.swiper-grid-column>.swiper-wrapper{flex-wrap:wrap;flex-direction:column}.swiper-fade.swiper-free-mode ::slotted(swiper-slide){transition-timing-function:ease-out}.swiper-fade ::slotted(swiper-slide){pointer-events:none;transition-property:opacity}.swiper-fade ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-fade ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-fade ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper.swiper-cube{overflow:visible}.swiper-cube ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1;visibility:hidden;transform-origin:0 0;width:100%;height:100%}.swiper-cube ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-cube.swiper-rtl ::slotted(swiper-slide){transform-origin:100% 0}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-cube ::slotted(.swiper-slide-active),.swiper-cube ::slotted(.swiper-slide-next),.swiper-cube ::slotted(.swiper-slide-prev){pointer-events:auto;visibility:visible}.swiper-cube .swiper-cube-shadow{position:absolute;left:0;bottom:0px;width:100%;height:100%;opacity:.6;z-index:0}.swiper-cube .swiper-cube-shadow:before{content:'';background:#000;position:absolute;left:0;top:0;bottom:0;right:0;filter:blur(50px)}.swiper-cube ::slotted(.swiper-slide-next)+::slotted(swiper-slide){pointer-events:auto;visibility:visible}.swiper.swiper-flip{overflow:visible}.swiper-flip ::slotted(swiper-slide){pointer-events:none;-webkit-backface-visibility:hidden;backface-visibility:hidden;z-index:1}.swiper-flip ::slotted(swiper-slide) ::slotted(swiper-slide){pointer-events:none}.swiper-flip ::slotted(.swiper-slide-active),.swiper-flip ::slotted(.swiper-slide-active) ::slotted(.swiper-slide-active){pointer-events:auto}.swiper-creative ::slotted(swiper-slide){-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden;transition-property:transform,opacity,height}.swiper.swiper-cards{overflow:visible}.swiper-cards ::slotted(swiper-slide){transform-origin:center bottom;-webkit-backface-visibility:hidden;backface-visibility:hidden;overflow:hidden}", ps = "::slotted(.swiper-slide-shadow),::slotted(.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-top){position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;z-index:10}::slotted(.swiper-slide-shadow){background:rgba(0,0,0,.15)}::slotted(.swiper-slide-shadow-left){background-image:linear-gradient(to left,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-right){background-image:linear-gradient(to right,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-top){background-image:linear-gradient(to top,rgba(0,0,0,.5),rgba(0,0,0,0))}::slotted(.swiper-slide-shadow-bottom){background-image:linear-gradient(to bottom,rgba(0,0,0,.5),rgba(0,0,0,0))}.swiper-lazy-preloader{animation:swiper-preloader-spin 1s infinite linear;width:42px;height:42px;position:absolute;left:50%;top:50%;margin-left:-21px;margin-top:-21px;z-index:10;transform-origin:50%;box-sizing:border-box;border:4px solid var(--swiper-preloader-color,var(--swiper-theme-color));border-radius:50%;border-top-color:transparent}@keyframes swiper-preloader-spin{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-cube.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-bottom),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-left),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-right),::slotted(.swiper-slide-shadow-flip.swiper-slide-shadow-top){z-index:0;-webkit-backface-visibility:hidden;backface-visibility:hidden}::slotted(.swiper-zoom-container){width:100%;height:100%;display:flex;justify-content:center;align-items:center;text-align:center}::slotted(.swiper-zoom-container)>canvas,::slotted(.swiper-zoom-container)>img,::slotted(.swiper-zoom-container)>svg{max-width:100%;max-height:100%;object-fit:contain}";
class fs {
}
const pt = typeof window > "u" || typeof HTMLElement > "u" ? fs : HTMLElement, rt = `<svg width="11" height="20" viewBox="0 0 11 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z" fill="currentColor"/></svg>
    `, ft = (i, e) => {
  if (typeof CSSStyleSheet < "u" && i.adoptedStyleSheets) {
    const t = new CSSStyleSheet();
    t.replaceSync(e), i.adoptedStyleSheets = [t];
  } else {
    const t = document.createElement("style");
    t.rel = "stylesheet", t.textContent = e, i.appendChild(t);
  }
};
class ut extends pt {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  static get nextButtonSvg() {
    return rt;
  }
  static get prevButtonSvg() {
    return rt.replace("/></svg>", ' transform-origin="center" transform="rotate(180)"/></svg>');
  }
  cssStyles() {
    return [
      cs,
      // eslint-disable-line
      ...this.injectStyles && Array.isArray(this.injectStyles) ? this.injectStyles : []
    ].join(`
`);
  }
  cssLinks() {
    return this.injectStylesUrls || [];
  }
  calcSlideSlots() {
    const e = this.slideSlots || 0, t = [...this.querySelectorAll("[slot^=slide-]")].map((s) => parseInt(s.getAttribute("slot").split("slide-")[1], 10));
    if (this.slideSlots = t.length ? Math.max(...t) + 1 : 0, !!this.rendered) {
      if (this.slideSlots > e)
        for (let s = e; s < this.slideSlots; s += 1) {
          const r = document.createElement("swiper-slide");
          r.setAttribute("part", `slide slide-${s + 1}`);
          const a = document.createElement("slot");
          a.setAttribute("name", `slide-${s + 1}`), r.appendChild(a), this.shadowRoot.querySelector(".swiper-wrapper").appendChild(r);
        }
      else if (this.slideSlots < e) {
        const s = this.swiper.slides;
        for (let r = s.length - 1; r >= 0; r -= 1)
          r > this.slideSlots && s[r].remove();
      }
    }
  }
  render() {
    if (this.rendered) return;
    this.calcSlideSlots();
    let e = this.cssStyles();
    this.slideSlots > 0 && (e = e.replace(/::slotted\(([a-z-0-9.]*)\)/g, "$1")), e.length && ft(this.shadowRoot, e), this.cssLinks().forEach((s) => {
      if (this.shadowRoot.querySelector(`link[href="${s}"]`)) return;
      const a = document.createElement("link");
      a.rel = "stylesheet", a.href = s, this.shadowRoot.appendChild(a);
    });
    const t = document.createElement("div");
    t.classList.add("swiper"), t.part = "container", t.innerHTML = `
      <slot name="container-start"></slot>
      <div class="swiper-wrapper" part="wrapper">
        <slot></slot>
        ${Array.from({
      length: this.slideSlots
    }).map((s, r) => `
        <swiper-slide part="slide slide-${r}">
          <slot name="slide-${r}"></slot>
        </swiper-slide>
        `).join("")}
      </div>
      <slot name="container-end"></slot>
      ${ns(this.passedParams) ? `
        <div part="button-prev" class="swiper-button-prev">${this.constructor.prevButtonSvg}</div>
        <div part="button-next" class="swiper-button-next">${this.constructor.nextButtonSvg}</div>
      ` : ""}
      ${ls(this.passedParams) ? `
        <div part="pagination" class="swiper-pagination"></div>
      ` : ""}
      ${os(this.passedParams) ? `
        <div part="scrollbar" class="swiper-scrollbar"></div>
      ` : ""}
    `, this.shadowRoot.appendChild(t), this.rendered = !0;
  }
  initialize() {
    var e = this;
    if (this.initialized) return;
    this.initialized = !0;
    const {
      params: t,
      passedParams: s
    } = st(this);
    this.swiperParams = t, this.passedParams = s, delete this.swiperParams.init, this.render(), this.swiper = new j(this.shadowRoot.querySelector(".swiper"), {
      ...t.virtual ? {} : {
        observer: !0
      },
      ...t,
      touchEventsTarget: "container",
      onAny: function(r) {
        r === "observerUpdate" && e.calcSlideSlots();
        const a = t.eventsPrefix ? `${t.eventsPrefix}${r.toLowerCase()}` : r.toLowerCase();
        for (var p = arguments.length, c = new Array(p > 1 ? p - 1 : 0), n = 1; n < p; n++)
          c[n - 1] = arguments[n];
        const f = new CustomEvent(a, {
          detail: c,
          bubbles: r !== "hashChange",
          cancelable: !0
        });
        e.dispatchEvent(f);
      }
    });
  }
  connectedCallback() {
    this.initialized && this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || this.init === !1 || this.getAttribute("init") === "false" || this.initialize();
  }
  disconnectedCallback() {
    this.nested && this.closest("swiper-slide") && this.closest("swiper-slide").swiperLoopMoveDOM || (this.swiper && this.swiper.destroy && this.swiper.destroy(), this.initialized = !1);
  }
  updateSwiperOnPropChange(e, t) {
    const {
      params: s,
      passedParams: r
    } = st(this, e, t);
    this.passedParams = r, this.swiperParams = s, !(this.swiper && this.swiper.params[e] === t) && ds({
      swiper: this.swiper,
      passedParams: this.passedParams,
      changedParams: [Se(e)],
      ...e === "navigation" && r[e] ? {
        prevEl: ".swiper-button-prev",
        nextEl: ".swiper-button-next"
      } : {},
      ...e === "pagination" && r[e] ? {
        paginationEl: ".swiper-pagination"
      } : {},
      ...e === "scrollbar" && r[e] ? {
        scrollbarEl: ".swiper-scrollbar"
      } : {}
    });
  }
  attributeChangedCallback(e, t, s) {
    this.initialized && (t === "true" && s === null && (s = !1), this.updateSwiperOnPropChange(e, s));
  }
  static get observedAttributes() {
    return Ce.filter((t) => t.includes("_")).map((t) => t.replace(/[A-Z]/g, (s) => `-${s}`).replace("_", "").toLowerCase());
  }
}
Ce.forEach((i) => {
  i !== "init" && (i = i.replace("_", ""), Object.defineProperty(ut.prototype, i, {
    configurable: !0,
    get() {
      return (this.passedParams || {})[i];
    },
    set(e) {
      this.passedParams || (this.passedParams = {}), this.passedParams[i] = e, this.initialized && this.updateSwiperOnPropChange(i, e);
    }
  }));
});
class us extends pt {
  constructor() {
    super(), this.attachShadow({
      mode: "open"
    });
  }
  render() {
    const e = this.lazy || this.getAttribute("lazy") === "" || this.getAttribute("lazy") === "true";
    if (ft(this.shadowRoot, ps), this.shadowRoot.appendChild(document.createElement("slot")), e) {
      const t = document.createElement("div");
      t.classList.add("swiper-lazy-preloader"), t.part.add("preloader"), this.shadowRoot.appendChild(t);
    }
  }
  initialize() {
    this.render();
  }
  connectedCallback() {
    this.initialize();
  }
}
const ms = () => {
  typeof window > "u" || (window.customElements.get("swiper-container") || window.customElements.define("swiper-container", ut), window.customElements.get("swiper-slide") || window.customElements.define("swiper-slide", us));
};
typeof window < "u" && (window.SwiperElementRegisterParams = (i) => {
  Ce.push(...i);
});
export {
  ut as SwiperContainer,
  us as SwiperSlide,
  ms as register
};
